{
  "nav": {
    "general": "General",
    "modules": "Modules",
    "reports": "Reports",
    "dashboard": "Home",
    "tracking": "Tracking",
    "projects": "Projects",
    "clientBudgets": "Quotes",
    "finance": "Finance",
    "partners": "Partners",
    "financeLookups": "Categories and payments",
    "team": "Service front",
    "serviceFrontModels": "Service front models",
    "checklistModels": "Checklist models",
    "diary": "Construction diary",
    "workers": "Collaborators",
    "occurrences": "Occurrences",
    "documentCategories": "Document categories",
    "photoTags": "Photo tags",
    "classifications": "Classifications",
    "weatherConditions": "Weather conditions",
    "projectPriorities": "Project priorities",
    "projectTypes": "Project types",
    "projectStatuses": "Project statuses",
    "projectBudgetStatuses": "Cost planning statuses",
    "projectClientBudgetStatuses": "Client budget statuses",
    "serviceFrontDeadlineStatuses": "Deadline statuses",
    "materials": "Materials",
    "budget": "Cost planning",
    "pdf": "PDF reports",
    "settings": "Company settings",
    "equipments": "Equipments",
    "serviceTaxCodes": "Service codes"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications yet.",
    "markAllRead": "Mark all as read",
    "clearAll": "Clear all",
    "dismiss": "Dismiss notification",
    "types": {
      "projectReport": {
        "ready": "Your report is ready.",
        "failed": "Report generation failed."
      }
    }
  },
  "plan": {
    "free": "Free plan",
    "starter": "Starter",
    "pro": "Pro",
    "business": "Business"
  },
  "login": {
    "title": "Sign in to KonstruLog",
    "description": "Use your email and password to sign in.",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "noAccount": "Don't have an account?",
    "register": "Create account",
    "error": "Incorrect email or password",
    "emailNotConfirmed": "Confirm your email before signing in. Check your inbox.",
    "supabaseNotConfigured": "Supabase is not configured. Check your .env file.",
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "appBanner": {
    "devEnv": "Development environment",
    "demoEnv": "Demonstration environment",
    "impersonation": "Impersonation mode — viewing {{orgName}} as {{email}}",
    "impersonationWithStaff": "Impersonation mode ({{staffEmail}}) — viewing {{orgName}} as {{email}}",
    "impersonationReadOnly": "Read-only impersonation — viewing {{orgName}} as {{email}}",
    "impersonationReadOnlyWithStaff": "Read-only impersonation ({{staffEmail}}) — viewing {{orgName}} as {{email}}",
    "demoAccount": "Demo account — {{orgName}}"
  },
  "register": {
    "title": "Create account",
    "description": "Fill in the details below to get started.",
    "fullName": "Full name",
    "fullNamePlaceholder": "João Silva",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "submit": "Create account",
    "hasAccount": "Already have an account?",
    "login": "Sign in",
    "checkEmail": "Confirm your email",
    "checkEmailDesc": "We sent a confirmation link to {{email}}. Click the link to activate your account.",
    "emailAlreadyExists": "This email is already registered. Sign in or use a different email.",
    "error": "Could not create account",
    "supabaseNotConfigured": "Supabase is not configured. Check your .env file.",
    "acceptTerms": "I agree to the Terms of Use and Privacy Policy.",
    "googleTermsHint": "By continuing with Google, you agree to the Terms of Use and Privacy Policy."
  },
  "legal": {
    "termsTitle": "Terms of Use",
    "privacyTitle": "Privacy Policy",
    "lastUpdated": "Last updated: October 9, 2026",
    "backToLogin": "Back to sign in",
    "acceptRequired": "You must accept the Terms of Use and Privacy Policy.",
    "acceptPrefix": "I agree to the",
    "acceptAnd": "and the",
    "terms": {
      "intro": "These Terms of Use govern access to KonstruLog, construction execution software for companies that run jobs in the field and the office. By creating an account or using the service, you agree to these terms. This page is a general description of the service, not legal advice.",
      "serviceTitle": "The service",
      "serviceBody": "KonstruLog provides tools for daily logs, work areas, photos, crew, job cost, proposals, purchasing, and related project records. We may improve, add, or remove features. Availability is not guaranteed without interruption.",
      "accountsTitle": "Accounts and organizations",
      "accountsBody": "You are responsible for your login credentials and for activity under your account. Company data belongs to the organization you join or create. Organization admins decide who has access. You must provide accurate company information (such as CNPJ or EIN) and keep it up to date.",
      "acceptableUseTitle": "Acceptable use",
      "acceptableUseBody": "Do not misuse the service, attempt unauthorized access, upload unlawful content, or interfere with other customers. You must have the right to upload photos, documents, and personal data of workers and partners that you store in KonstruLog.",
      "contentTitle": "Your data",
      "contentBody": "You retain rights to the content you submit. You grant us a limited license to host, process, and display that content solely to operate the service for your organization. We do not sell your job records.",
      "liabilityTitle": "Disclaimer and liability",
      "liabilityBody": "The service is provided as-is. KonstruLog is not a substitute for licensed engineering, legal, payroll, tax, or accounting advice. To the extent permitted by law, we are not liable for lost profits, delays on site, or indirect damages arising from use of the software.",
      "paymentsTitle": "Financial services (Brazil)",
      "paymentsBody": "When a Brazilian organization enables PIX or boleto charges, the payment services made available through this platform, including processing transactions, issuing boletos, transfers, and other movement of funds, are provided by the payment institution configured for that organization. By default, that institution is PAGAR.ME S.A. Organizations configured to use Asaas use ASAAS GESTÃO FINANCEIRA INSTITUIÇÃO DE PAGAMENTOS S.A. The institution's fee is deducted from the amount paid. KonstruLog acts solely as a technology integrator. It is not a financial or payment institution, does not intermediate funds in its own name, and does not keep a commission on these charges.",
      "changesTitle": "Changes",
      "changesBody": "We may update these terms. Continued use after we post a new version constitutes acceptance. If you do not agree, stop using the service and export your data with your admin."
    },
    "privacy": {
      "intro": "This Privacy Policy explains how KonstruLog handles personal and company data when you use our websites, web app, and mobile apps. It applies to customers in Brazil and the United States. Country-specific addenda (such as LGPD or CCPA) may be added later.",
      "collectTitle": "What we collect",
      "collectBody": "We collect account data (name, email, date of birth, phone), organization data (legal name, tax ID, address), job records you enter (daily logs, photos, crew, partners, financial entries), and technical data (device, IP, logs) needed to run and secure the service.",
      "useTitle": "How we use data",
      "useBody": "We use data to provide the product, authenticate users, store project history, send transactional email, improve reliability, and meet legal obligations. We do not use your job photos or diaries to train public AI models.",
      "shareTitle": "Sharing",
      "shareBody": "We share data with subprocessors that host infrastructure, authentication, and email, only as needed to operate KonstruLog. Brazilian organizations that enable PIX or boleto charges share registration and transaction data with the payment institution configured for that organization: by default, PAGAR.ME S.A.; if the organization is on Asaas, ASAAS GESTÃO FINANCEIRA INSTITUIÇÃO DE PAGAMENTOS S.A. We may disclose information if required by law. We do not sell personal information.",
      "retentionTitle": "Retention and security",
      "retentionBody": "We keep organization data while the account is active and for a reasonable period afterward so you can export it. We use access controls, encryption in transit, and tenant isolation. No method of storage is 100% secure.",
      "rightsTitle": "Your rights",
      "rightsBody": "Depending on your location, you may request access, correction, deletion, or portability of personal data, or object to certain processing. Organization admins control member access. Contact us to exercise these rights.",
      "contactTitle": "Contact",
      "contactBody": "Questions about privacy or these terms: contato@konstrulog.com (Brazil) or contact@konstrulog.com (United States)."
    }
  },
  "auth": {
    "profileLoadErrorTitle": "Could not load your account",
    "profileLoadError": "Check your connection and try again. If the problem continues, contact support.",
    "retry": "Try again",
    "signOut": "Sign out",
    "continueWithGoogle": "Continue with Google",
    "orEmailPassword": "or continue with email",
    "googleError": "Could not start Google sign-in. Try again.",
    "googleNotConfigured": "Google sign-in is not configured. Add VITE_GOOGLE_WEB_CLIENT_ID to your .env file.",
    "googleAccountNotFound": "No account found for this Google account. Create an account first, then sign in.",
    "googleEmailMismatch": "Use the Google account for the invited email ({{email}}).",
    "googleAccountSwitched": "That Google account belongs to a different user. Use the invited email."
  },
  "authCallback": {
    "loading": "Signing you in…",
    "errorTitle": "Could not complete sign-in",
    "invalidOrExpired": "This link is invalid or has expired. Ask your admin to resend the invite.",
    "notConfigured": "Authentication is not configured. Contact support.",
    "signupsDisabled": "New account creation is disabled in authentication settings. Enable “Allow new users to sign up” in Supabase, then try again.",
    "backToLogin": "Back to sign in",
    "mobileBridgeLoading": "Returning to the KonstruLog app…",
    "mobileBridgeMissingReturn": "This mobile sign-in link is incomplete. Close this window and try again from the app."
  },
  "noOrgAccess": {
    "title": "You no longer have access",
    "description": "This invite was revoked or is no longer valid. Contact your organization admin if you think this is a mistake.",
    "signOut": "Sign out"
  },
  "noPermission": {
    "title": "No permissions assigned",
    "description": "Your account does not have permission for any area of KonstruLog yet. Contact your organization administrator to request access.",
    "descriptionWithOrg": "Your account in <org>{{orgName}}</org> does not have permission for any area of KonstruLog yet. Contact your organization administrator to request access.",
    "signOut": "Sign out"
  },
  "notFound": {
    "errorCode": "Error 404",
    "title": "Page not found",
    "description": "This page does not exist or the link may be incorrect. Check the address or go back to a known area.",
    "goHome": "Go to home",
    "goLogin": "Go to login",
    "goBack": "Go back"
  },
  "memberDisabled": {
    "title": "Your access is disabled",
    "description": "Your organization admin disabled your account. Contact them if you need access again.",
    "descriptionWithOrg": "Your access to {{orgName}} was disabled by an admin. Contact them if you need access again.",
    "signOut": "Sign out"
  },
  "acceptInvite": {
    "eyebrow": "Invitation",
    "title": "You were invited to join the organization {{orgName}}",
    "heroTitle": "Join {{orgName}}",
    "description": "Confirm your name and continue with Google, or set a password to join your team.",
    "descriptionExisting": "Confirm your name to join this organization.",
    "platformTitle": "Welcome to KonstruLog",
    "platformDescription": "Confirm your name and continue with Google, or set a password to get started.",
    "platformDescriptionExisting": "Confirm your name to continue.",
    "orSetPassword": "or set a password",
    "fullName": "Full name",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "passwordMin": "Minimum 6 characters",
    "passwordMismatch": "Passwords do not match",
    "submit": "Join organization",
    "continue": "Continue",
    "platformSubmit": "Continue",
    "logout": "Sign out",
    "useAnotherAccount": "Use another account",
    "supabaseNotConfigured": "Authentication is not configured. Contact support."
  },
  "accessLocked": {
    "goToBilling": "Go to billing",
    "signOut": "Sign out",
    "generic": {
      "title": "Access restricted",
      "description": "Your account does not have active access right now."
    },
    "trialEnded": {
      "title": "Trial ended",
      "description": "Your trial period has ended. Review billing to restore access."
    },
    "paymentRequired": {
      "title": "Payment pending",
      "description": "A payment is required to continue using KonstruLog."
    },
    "organizationBlocked": {
      "title": "Access suspended",
      "description": "Your organization access has been suspended. Contact support for help."
    }
  },
  "billing": {
    "title": "Billing",
    "subscriptionStatus": "{{plan}}",
    "noSubscription": "No active subscription on file.",
    "accessActiveTitle": "Subscription active",
    "accessActive": "Your subscription is active.",
    "contact": "Questions?<br/>Contact us at <email>{{email}}</email>",
    "paymentsTitle": "Payments",
    "paymentsDescription": "Recent charges and invoices for your organization.",
    "noPayments": "No payments recorded yet.",
    "method": "Method",
    "description": "Description",
    "paymentDescriptionMonthly": "KonstruLog {{plan}} — monthly",
    "amount": "Amount",
    "date": "Date",
    "dueAtLabel": "Due date",
    "viewPayment": "View payment",
    "subscribeTitle": "Choose your plan",
    "subscribeDescription": "Pick a plan and payment method to continue after your trial.",
    "subscribeCta": "Start subscription",
    "subscribeSuccess": "Subscription created. Complete payment if prompted.",
    "subscribeCardSuccess": "Subscription activated with your credit card.",
    "subscribeError": "Could not start the subscription.",
    "subscribeUnavailable": "Online billing is not available yet. Contact support.",
    "settingsDescription": "Plan, invoices, and payment methods for your organization.",
    "subscriptionStatusTitle": "Current plan",
    "periodEnds": "Renews on {{date}}",
    "periodEndsLabel": "Renews on",
    "status": "Status",
    "choosePlan": "Plan",
    "chooseMethod": "Payment method",
    "perMonth": "/mo",
    "cardMethodHint": "Credit card only. Your card is charged in KonstruLog and renews automatically each month.",
    "cardFormTitle": "Credit card",
    "cardFormIncomplete": "Fill in all required card and billing details.",
    "cardNumberInvalid": "Enter a valid card number.",
    "cardPreviewNamePlaceholder": "NAME ON CARD",
    "cardHolderName": "Name on card",
    "cardNumber": "Card number",
    "cardExpiryMonth": "Month",
    "cardExpiryYear": "Year",
    "cardCcv": "CVV",
    "cardHolderInfoTitle": "Billing details",
    "holderName": "Full name",
    "holderEmail": "Email",
    "holderTaxId": "CPF/CNPJ",
    "holderPostalCode": "ZIP code",
    "holderAddressNumber": "Number",
    "holderAddressComplement": "Complement",
    "holderPhone": "Phone",
    "manualCycleHint": "Each month a new charge is created. You must pay PIX or boleto before the due date.",
    "retryCardTitle": "Update payment method",
    "retryCardDescription": "The last charge failed. Enter a valid credit card to pay the open invoice and keep automatic renewals.",
    "retryCardOpenCta": "Update card",
    "retryCardCta": "Pay and update card",
    "retryCardSuccess": "Payment confirmed. Your subscription is active again.",
    "retryCardError": "Could not charge this card. Check the details and try again.",
    "graceBanner": "Payment failed. Update billing by {{date}} to keep access.",
    "graceBannerMember": "Payment failed. Access may end on {{date}}. Ask an organization administrator to update billing.",
    "openInvoiceTitle": "Open invoice",
    "openInvoiceDescription": "Pay this charge to keep your subscription active.",
    "dueAt": "Due {{date}}",
    "pixQrAlt": "PIX QR code",
    "pixCopyLabel": "PIX copy-and-paste",
    "payWithCard": "Pay with card",
    "planLabels": {
      "starter": "Starter",
      "pro": "Pro",
      "business": "Business"
    },
    "statusLabels": {
      "trialing": "Trial",
      "active": "Active",
      "past_due": "Past due",
      "canceled": "Canceled"
    },
    "paymentMethods": {
      "pix": "PIX",
      "boleto": "Boleto",
      "credit_card": "Credit card",
      "other": "Other"
    },
    "paymentStatuses": {
      "pending": "Pending",
      "paid": "Paid",
      "overdue": "Overdue",
      "canceled": "Canceled"
    }
  },
  "onboarding": {
    "eyebrow": "Onboarding",
    "stepOf": "{{current}} / {{total}}",
    "personalTitle": "Personal information",
    "personalDescription": "This information identifies you in KonstruLog.",
    "collaboratorPersonalDescription": "Enter your role, date of birth, and phone number.",
    "companyTitle": "Company information",
    "companyDescription": "This information identifies your company in KonstruLog.",
    "collaboratorAddressTitle": "Address",
    "collaboratorAddressDescription": "Enter your address to finish collaborator registration.",
    "title": "Set up your company",
    "description": "This information identifies your account in KonstruLog.",
    "fullName": "Your name",
    "fullNamePlaceholder": "João Silva",
    "birthDate": "Date of birth",
    "birthDatePlaceholder": "Select date",
    "birthDateOpenCalendar": "Open calendar",
    "birthDateFuture": "Birth date cannot be in the future.",
    "birthDateMinAge": "You must be at least 18 years old.",
    "orgName": "Trade name",
    "orgNamePlaceholder": "Acme Construction",
    "orgNameRequired": "Enter your company trade name",
    "legalName": "Legal name",
    "legalNamePlaceholder": "Acme Construction Ltda",
    "legalNamePlaceholderUs": "Acme Construction LLC",
    "country": "Country",
    "countryBR": "Brazil",
    "countryUS": "United States",
    "cnpj": "CNPJ",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "cnpjInvalid": "Enter a valid CNPJ",
    "ein": "EIN",
    "einPlaceholder": "12-3456789",
    "einInvalid": "Enter a valid EIN",
    "orgType": "Account type",
    "solo": "Solo — freelancer or small company",
    "business": "Business — team with multiple members",
    "logout": "Sign out",
    "continue": "Continue",
    "back": "Back",
    "submit": "Start free trial",
    "submitPaid": "Start {{plan}} plan",
    "collaboratorSubmit": "Join organization",
    "error": "Failed to create company",
    "unauthorized": "We couldn’t finish setting up your account. Sign out and sign back in. If this keeps happening, contact support."
  },
  "productTour": {
    "welcomeTitle": "Welcome to KonstruLog",
    "welcomeDescription": "A short tour of this screen so you know where to start.",
    "start": "Start tour",
    "skip": "Skip",
    "next": "Next",
    "back": "Back",
    "done": "Done",
    "stepOf": "{{current}} / {{total}}",
    "replay": "Take a tour",
    "steps": {
      "appNav": {
        "title": "Home, projects, and quotes",
        "description": "Use the sidebar to go to Home, Tracking, the project list, and quotes."
      },
      "dashboardKpis": {
        "title": "Project health at a glance",
        "description": "These cards show active, paused, missing diary entries, and overdue work. Click one to filter the list."
      },
      "newProject": {
        "title": "Create a project",
        "description": "Add your first project here. You can set it up in a few steps."
      },
      "memberProjects": {
        "title": "Your projects",
        "description": "Open a project to record diary entries, photos, and progress."
      },
      "globalSearch": {
        "title": "Search",
        "description": "Find projects and pages quickly. On desktop you can also press Ctrl/Cmd+K."
      },
      "settings": {
        "title": "Company settings",
        "description": "Company setup lives here: users, models, workers, and more."
      },
      "accountMenu": {
        "title": "Your account",
        "description": "Change language, theme, or organization, replay this tour, or sign out. Notifications sit next to this menu."
      }
    }
  },
  "account": {
    "title": "Account",
    "sections": {
      "personal": "Personal"
    }
  },
  "settings": {
    "sections": {
      "empresa": "Company",
      "cadastros": "Catalog",
      "obras": "Projects",
      "ferramentas": "Tools"
    },
    "nav": {
      "main": "Overview",
      "profile": "Profile",
      "general": "General",
      "organization": "Organization",
      "administration": "Administration",
      "users": "Users",
      "permissions": "Permissions"
    },
    "searchPlaceholder": "Search setting",
    "home": {
      "title": "Quick access to main company settings",
      "subtitle": "Company, catalog, and tools — find what you need, fast",
      "descriptions": {
        "administration": "Organization, users, permissions, and general preferences",
        "general": "Configure general app behavior for your organization",
        "organization": "Manage your company details",
        "users": "Manage users, invites, and access for your organization",
        "permissions": "Define roles and permission templates for your team",
        "diaryReportModels": "Configure reusable PDF models for project diary reports",
        "serviceFrontModels": "Create reusable service front models for your projects",
        "checklistModels": "Create reusable checklist models for service front steps",
        "occurrences": "Configure the occurrence types tracked on site",
        "documentCategories": "Organize project documents into categories",
        "photoTags": "Manage tags used to classify project photos",
        "classifications": "Set up priorities, types, and statuses",
        "workers": "Manage collaborators and their roles",
        "materials": "Manage materials, categories, and measurement units",
        "equipments": "Manage equipments and categories",
        "partners": "Register clients, suppliers, and service providers used on projects and in finance",
        "financeLookups": "Set up financial categories and payment methods",
        "serviceTaxCodes": "Register LC 116 service codes used on NFS-e"
      }
    },
    "materials": {
      "categories": "Material categories",
      "list": "List",
      "measurementUnits": "Measurement units",
      "items": "Materials"
    },
    "workers": {
      "list": "List",
      "items": "Collaborators",
      "roles": "Roles"
    },
    "title": "Company settings",
    "description": "Team, catalog, and preferences.",
    "hubEmpty": "No settings sections are available for your account.",
    "edit": "Edit",
    "orgSectionTitle": "Organization",
    "orgSectionDescription": "Details for your company in KonstruLog. The name is synced across the app after you save.",
    "orgId": "Organization ID",
    "orgType": "Account type",
    "yourRole": "Your role",
    "planLabel": "Plan",
    "updatedAt": "Last updated",
    "save": "Save changes",
    "saveSuccess": "Organization updated.",
    "saveError": "Could not save changes.",
    "forbidden": "You don’t have permission to edit organization settings.",
    "loadError": "Could not load organization details.",
    "memberReadOnly": "Only organization admins can change the company name. Contact an admin if something looks wrong.",
    "stepDetails": "Organization details",
    "stepReview": "Review and submit",
    "formReviewTitle": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "profile": {
      "description": "Your name appears in the app.",
      "fullName": "Full name",
      "fullNamePlaceholder": "João Silva",
      "birthDate": "Date of birth",
      "birthDatePlaceholder": "Select date",
      "birthDateOpenCalendar": "Open calendar",
      "birthDateFuture": "Birth date cannot be in the future.",
      "birthDateMinAge": "You must be at least 18 years old.",
      "email": "Email",
      "permissionProfile": "Permission profile",
      "unknownName": "Not set",
      "formTitle": "Edit profile",
      "stepDetails": "Profile details",
      "saveSuccess": "Profile updated.",
      "saveError": "Could not save your profile.",
      "avatar": "Profile photo",
      "avatarHint": "JPEG, PNG, or WebP up to 2 MB.",
      "avatarModalTitle": "Your profile photo",
      "avatarEdit": "Edit",
      "avatarEditAria": "Edit profile photo",
      "avatarRemove": "Remove photo",
      "avatarRemoveConfirmTitle": "Remove profile photo?",
      "avatarRemoveConfirmDescription": "Your initials will be shown instead until you add a new photo.",
      "avatarUpdateSuccess": "Profile photo updated.",
      "avatarRemoveSuccess": "Profile photo removed."
    },
    "general": {
      "sectionDiary": "Diary",
      "allowPastDiaryEntryEdits": "Allow editing diary entries from previous days",
      "allowPastDiaryEntryEditsDescription": "When this is on, published diary entries from previous days can be edited or deleted.",
      "diaryEntryFormModeDescription": "Choose how much detail diary entries include.",
      "diaryEntryFormOccurrences": "Occurrences",
      "diaryEntryFormMaterials": "Materials",
      "diaryEntryFormEquipments": "Equipment",
      "diaryEntryFormChecklists": "Checklists",
      "sectionFiscal": "Tax invoices",
      "fiscalDocumentsEnabled": "Issue electronic invoices (NFS-e)",
      "fiscalDocumentsEnabledDescription": "When this is off, the company does not issue NFS-e and tax invoice screens stay hidden.",
      "sectionCharges": "Charges",
      "chargesEnabled": "Generate boleto and PIX",
      "chargesEnabledDescription": "When this is off, the company does not generate boleto and PIX and the bank account section stays hidden.",
      "saveSuccess": "Settings saved."
    },
    "organization": {
      "formTitle": "Edit organization",
      "sectionLegal": "Legal identity",
      "sectionDomain": "Domain",
      "sectionContact": "Contact & billing",
      "sectionSize": "Company size",
      "sectionAccount": "Account",
      "logo": "Logo",
      "logoHint": "JPEG, PNG, or WebP up to 2 MB. Large images are downscaled automatically.",
      "logoModalTitle": "Company logo",
      "logoEdit": "Choose image",
      "logoEditAria": "Edit company logo",
      "logoRemove": "Remove logo",
      "logoRemoveConfirmTitle": "Remove logo?",
      "logoRemoveConfirmDescription": "The logo will no longer appear on reports until you add another one.",
      "logoUpdateSuccess": "Logo updated.",
      "logoRemoveSuccess": "Logo removed.",
      "technicalResponsible": "Technical responsible",
      "technicalResponsiblePlaceholder": "Select a collaborator…",
      "technicalResponsibleRegistry": "CREA / CAU",
      "technicalResponsibleRegistryPlaceholder": "Registration number",
      "country": "Country",
      "countries": {
        "BR": "Brazil",
        "US": "United States"
      },
      "countryLockedHint": "Chosen when the company was created. Contact support to change it.",
      "timeZone": "Time zone",
      "timeZonePlaceholder": "Search time zone…",
      "segment": "Segment",
      "segmentPlaceholder": "Select a segment",
      "segments": {
        "residential": "Residential",
        "commercial": "Commercial",
        "industrial": "Industrial",
        "renovation": "Renovation"
      },
      "address": "Headquarters address",
      "addressPlaceholder": "Street, city, state, ZIP",
      "phone": "Phone",
      "phonePlaceholder": "+55 11 99999-0000",
      "commercialEmail": "Commercial email",
      "commercialEmailPlaceholder": "contato@empresa.com",
      "commercialEmailInvalid": "Enter a valid email",
      "financialContact": "Financial contact",
      "estimatedEmployeeCount": "Estimated employees",
      "estimatedConcurrentProjects": "Estimated concurrent projects",
      "employeeRanges": {
        "from_1_to_5": "1–5",
        "from_6_to_20": "6–20",
        "from_21_to_50": "21–50",
        "from_51_to_200": "51–200",
        "from_200_plus": "200+"
      },
      "concurrentProjectsRanges": {
        "one": "1",
        "from_2_to_5": "2–5",
        "from_6_to_15": "6–15",
        "from_16_to_30": "16–30",
        "from_30_plus": "30+"
      },
      "employeeRangePlaceholder": "Select a range…",
      "concurrentProjectsRangePlaceholder": "Select a range…"
    },
    "users": {
      "invite": "Create user",
      "inviteTitle": "Create user",
      "inviteStep": "Invite details",
      "inviteStepEmail": "Email",
      "inviteStepPermissions": "Permissions",
      "inviteStepReview": "Review",
      "inviteSubmit": "Create user",
      "createWorkerOnAccept": "Create collaborator",
      "createWorkerOnAcceptHint": "As a collaborator, they can be responsible for a project, create site diaries, and take part in other activities in the system. Phone, address, and role are filled in when they accept the invite.",
      "inviteSuccess": "Invite sent.",
      "createSuccess": "User created.",
      "sendInviteModalTitle": "Send invite now?",
      "sendInviteModalDescription": "You can send an invite email now or create the user without sending an email. Users without an invite stay in “Not invited” until you send one from the users list.",
      "sendInviteNow": "Send invite now",
      "createWithoutInvite": "Create without invite",
      "sendInvite": "Send invite",
      "sendInviteSuccess": "Invite sent.",
      "resendInvite": "Resend invite",
      "resendInviteSuccess": "Invite resent.",
      "colStatus": "Status",
      "invitedAt": "Invited",
      "status": {
        "not_invited": "Not invited",
        "invited": "Invited",
        "onboarded": "Active",
        "disabled": "Disabled"
      },
      "backToList": "Back to users",
      "email": "Email",
      "role": "Role",
      "colName": "Name",
      "colPermissions": "Permissions",
      "profileType": "Profile type",
      "useExistingProfile": "Use existing profile",
      "customPermissions": "Custom permissions",
      "selectProfile": "Select profile",
      "permissionRequired": "Select a permission profile.",
      "inviteEmailAlreadyExists": "It is not possible to create this user. An account with this email already exists.",
      "inviteMemberAlreadyExists": "It is not possible to create this user. They are already in your organization.",
      "inviteUserAlreadyInOrg": "It is not possible to create this user. This email belongs to a user in another organization.",
      "saveAsProfile": "Save as new profile",
      "selectedProfile": "Selected profile",
      "customProfile": "Custom",
      "searchPlaceholder": "Search by name or email…",
      "clearSearch": "Clear search",
      "total_one": "{{count}} result",
      "total_other": "{{count}} results",
      "userCount_one": "{{count}} user",
      "userCount_other": "{{count}} users",
      "emptyTitle": "No users yet",
      "emptyDescription": "Invite teammates to collaborate in your organization.",
      "noSearchResults": "No users match your search.",
      "noFilterResults": "No users match the selected filters.",
      "loadError": "Could not load users.",
      "loadMoreError": "Could not load more users.",
      "loadMoreRetry": "Try again",
      "seatsRemaining_one": "You can invite {{count}} more user on your plan.",
      "seatsRemaining_other": "You can invite {{count}} more users on your plan.",
      "atCapHint": "You reached the user limit for your plan.",
      "drawerDetailTitle": "User detail",
      "joinedAt": "Joined",
      "permissionsHeading": "Permissions",
      "edit": "Edit",
      "remove": "Remove",
      "disable": "Disable",
      "enable": "Enable",
      "disableConfirmTitle": "Disable user",
      "disableConfirmDescription": "This user will lose access to your organization until you enable them again. Their seat stays assigned.",
      "disableConfirmAction": "Disable user",
      "disableSuccess": "User disabled.",
      "enableSuccess": "User enabled.",
      "actionsMenu": "User actions",
      "editTitle": "Edit user permissions",
      "editStep": "User details",
      "formReviewTitle": "Review and submit",
      "reviewSummaryTitle": "Summary",
      "editSuccess": "User permissions updated.",
      "removeConfirmTitle": "Remove user",
      "removeConfirmDescription": "This user will lose access to your organization. This action cannot be undone.",
      "removeConfirmAction": "Remove user",
      "removeSuccess": "User removed.",
      "filter": {
        "permissions": "Permissions",
        "permissionsSearch": "Search permission profiles…",
        "permissionsEmpty": "No permission profiles found.",
        "apply": "Show results",
        "reset": "Clear",
        "close": "Close filter"
      }
    },
    "equipments": {
      "categories": "Equipment categories",
      "list": "List",
      "items": "Equipments"
    },
    "finance": {
      "categories": "Financial categories",
      "paymentMethods": "Payment methods"
    }
  },
  "roles": {
    "admin": "Admin",
    "member": "Member",
    "owner": "Owner"
  },
  "memberHome": {
    "title": "Your work",
    "subtitle": "Pick an obra below to open details, diary, and entries you can access.",
    "projectsHeading": "Your obras"
  },
  "projectServiceFronts": {
    "new": "New service front",
    "edit": "Edit",
    "delete": "Delete",
    "inactivate": "Inactivate",
    "reactivate": "Reactivate",
    "save": "Save",
    "cancel": "Cancel",
    "formSections": {
      "identification": "Identification",
      "details": "Details"
    },
    "createdAt": "Created",
    "createdByLabel": "Registered by",
    "unknownCreator": "Unknown user",
    "colName": "Name",
    "colStatus": "Status",
    "colDescription": "Description",
    "colColor": "Color",
    "colProgress": "Progress",
    "colDeadlineStatus": "Deadline",
    "colInitialDate": "Start date",
    "colCompletionDate": "Completion",
    "colTeam": "Team",
    "colProjectDiaryEntries": "Diary entries",
    "colOccurrences": "Occurrences",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "progressLabel": "Progress",
    "progressInvalid": "Enter a whole number from 0 to 100.",
    "initialDateLabel": "Start date",
    "completionDateLabel": "Expected completion date",
    "completionDateBeforeInitial": "Completion date cannot be before the start date.",
    "deadlineStatusLabel": "Deadline",
    "deadlineStatus": {
      "on_time": "On time",
      "overdue": "Overdue",
      "completed": "Completed"
    },
    "teamLabel": "Team",
    "teamPlaceholder": "Select collaborators…",
    "drawerNoTeam": "No team assigned.",
    "checklistsLabel": "Checklists",
    "checklistsPlaceholder": "Select checklists…",
    "drawerNoChecklists": "No checklists assigned.",
    "colorInvalid": "Enter a valid hex color (e.g. #1D4ED8).",
    "colorPlaceholder": "#RRGGBB",
    "dialogCreateTitle": "New service front",
    "dialogEditTitle": "Edit service front",
    "formCreateTitle": "New service front",
    "formEditTitle": "Edit service front",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Service front details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "backToList": "Back to service fronts",
    "notFound": "This service front no longer exists or you cannot access it.",
    "drawerNoDescription": "No description.",
    "drawerDetailTitle": "Service front detail",
    "drawerStatsProjectDiaryEntries": "Diary entries",
    "drawerStatsOccurrences": "Occurrences",
    "drawerStatsPhotos": "Photos",
    "drawerRecentActivitiesSection": "Diary entry",
    "drawerRecentProjectServiceFronts": "Service front",
    "drawerRecentOccurrences": "Occurrences",
    "drawerSeeAll": "See all",
    "drawerNoRecentProjectServiceFronts": "No diary entries for this service front yet.",
    "drawerNoRecentOccurrences": "No occurrences on related diary entries yet.",
    "drawerActivityPhotoCount_one": "{{count}} photo",
    "drawerActivityPhotoCount_other": "{{count}} photos",
    "loadError": "Could not load service fronts.",
    "saveSuccess": "Service front saved.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "deleteSuccess": "Service front removed.",
    "inactivateSuccess": "Service front inactivated.",
    "reactivateSuccess": "Service front reactivated.",
    "deleteConfirmTitle": "Remove this service front?",
    "deleteConfirmDescription": "This cannot be undone. The service front has no diary history.",
    "deleteConfirmAction": "Remove",
    "inactivateConfirmTitle": "Inactivate this service front?",
    "inactivateConfirmDescription": "It will be hidden from new diary entries. Existing diary history is preserved.",
    "inactivateConfirmAction": "Inactivate",
    "reactivateConfirmTitle": "Reactivate this service front?",
    "reactivateConfirmDescription": "It will appear again in new diary entries and selections.",
    "reactivateConfirmAction": "Reactivate",
    "deleteInUse": "This front is used in diary activities and cannot be deleted.",
    "nameTaken": "A service front with this name already exists.",
    "forbidden": "You don’t have permission to change service fronts.",
    "actionsMenu": "Actions",
    "emptyTitle": "No service fronts",
    "emptyDescription": "Create one to use in the construction diary and other features.",
    "searchPlaceholder": "Search by name or description…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No service fronts match your search.",
    "filter": {
      "progress": "Progress",
      "progressRangeInvalid": "From must be less than or equal to To.",
      "deadlineStatus": "Deadline",
      "deadlineStatusSearch": "Search deadline status…",
      "deadlineStatusEmpty": "No deadline statuses found.",
      "initialDate": "Start date",
      "completionDate": "Completion date",
      "dateFromLabel": "From",
      "dateToLabel": "To",
      "projectDiaryEntries": "Daily log entries",
      "projectDiaryEntriesWith": "With entries",
      "projectDiaryEntriesWithout": "Without entries",
      "occurrences": "Occurrences",
      "occurrencesWith": "With occurrences",
      "occurrencesWithout": "Without occurrences"
    },
    "loadMoreError": "Could not load more service fronts.",
    "loadMoreRetry": "Try again"
  },
  "serviceFrontModels": {
    "new": "New model",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "createdAt": "Created",
    "colName": "Name",
    "colDescription": "Description",
    "colSteps": "Steps",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "stepsLabel": "Steps",
    "stepsOverflow": "+{{count}} steps",
    "stepNameLabel": "Step {{index}}",
    "stepNamePlaceholder": "Step name…",
    "stepColorLabel": "Step {{index}} color",
    "colorInvalid": "Enter a valid hex color (e.g. #1D4ED8).",
    "addStep": "Add step",
    "removeStep": "Remove step",
    "reorderStep": "Reorder step",
    "formCreateTitle": "New service front model",
    "formEditTitle": "Edit service front model",
    "notFound": "This model no longer exists or you cannot access it.",
    "drawerNoDescription": "No description.",
    "drawerDetailTitle": "Service front model detail",
    "loadError": "Could not load models.",
    "saveSuccess": "Model saved.",
    "deleteSuccess": "Model removed.",
    "deleteConfirmTitle": "Remove this model?",
    "deleteConfirmDescription": "This cannot be undone. You cannot delete a model that is used by projects.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This model is used by projects and cannot be deleted.",
    "nameTaken": "A model with this name already exists.",
    "forbidden": "You don’t have permission to change models.",
    "actionsMenu": "Actions",
    "emptyTitle": "No service front models",
    "emptyDescription": "No service front models are configured for this organization yet.",
    "searchPlaceholder": "Search by name or description…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No models match your search.",
    "noFilterResults": "No models match the selected filters.",
    "loadMoreError": "Could not load more models.",
    "loadMoreRetry": "Try again",
    "checklistModelsLabel": "Checklist models",
    "checklistModelsPlaceholder": "Select checklist models…",
    "checklistModelsSearch": "Search checklist models…",
    "checklistModelsEmpty": "No checklist models found.",
    "checklistModelsNone": "No checklist models",
    "checklistsCount_one": "{{count}} checklist",
    "checklistsCount_other": "{{count}} checklists",
    "stepChecklistsLabel_one": "Checklist",
    "stepChecklistsLabel_other": "Checklists"
  },
  "checklistModels": {
    "new": "New model",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "createdAt": "Created",
    "colName": "Name",
    "colDescription": "Description",
    "colItems": "Items",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "itemsLabel": "Items",
    "itemsOverflow": "+{{count}} items",
    "itemNameLabel": "Item {{index}}",
    "itemNamePlaceholder": "Item name…",
    "addItem": "Add item",
    "removeItem": "Remove item",
    "reorderItem": "Reorder item",
    "formCreateTitle": "New checklist model",
    "formEditTitle": "Edit checklist model",
    "notFound": "This model no longer exists or you cannot access it.",
    "drawerNoDescription": "No description.",
    "drawerDetailTitle": "Checklist model detail",
    "loadError": "Could not load models.",
    "saveSuccess": "Model saved.",
    "deleteSuccess": "Model removed.",
    "deleteConfirmTitle": "Remove this model?",
    "deleteConfirmDescription": "This cannot be undone. You cannot delete a model that is in use.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This model is in use and cannot be deleted.",
    "nameTaken": "A model with this name already exists.",
    "forbidden": "You don’t have permission to change models.",
    "actionsMenu": "Actions",
    "emptyTitle": "No checklist models",
    "emptyDescription": "No checklist models are configured for this organization yet.",
    "searchPlaceholder": "Search by name or description…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No models match your search.",
    "noFilterResults": "No models match the selected filters.",
    "loadMoreError": "Could not load more models.",
    "loadMoreRetry": "Try again"
  },
  "workers": {
    "new": "New collaborator",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "createdAt": "Created",
    "colName": "Name",
    "colLinkedUser": "Linked user",
    "colCode": "Code",
    "colRole": "Role",
    "colEmploymentLink": "Employment",
    "colBirthDate": "Date of birth",
    "colProjectServiceFronts": "Service fronts",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "codeLabel": "Code",
    "codeNotFound": "No collaborator found with this code.",
    "roleLabel": "Role",
    "rolePlaceholder": "Select a role…",
    "employmentLinkLabel": "Employment",
    "employmentLinkOwned": "In-house",
    "employmentLinkOutsourced": "Outsourced",
    "employmentLinkOutsourcedWithPartner": "Outsourced · {{name}}",
    "serviceProviderLabel": "Service provider",
    "serviceProviderPlaceholder": "Select a service provider…",
    "birthDateLabel": "Date of birth",
    "birthDatePlaceholder": "MM/DD/YYYY",
    "birthDateOpenCalendar": "Open calendar",
    "birthDateFuture": "Birth date cannot be in the future.",
    "birthDateMinAge": "Collaborator must be at least 16 years old.",
    "phoneLabel": "Phone",
    "linkedUserLabel": "Linked user",
    "linkedUserHint": "Optional. Links this collaborator to a person who signs in.",
    "linkedUserPlaceholder": "Select a user…",
    "linkedUserLinked": "Linked",
    "projectServiceFrontsLabel": "Service fronts",
    "projectServiceFrontsPlaceholder": "Select service fronts…",
    "projectServiceFrontsSearch": "Search service fronts…",
    "projectServiceFrontsEmpty": "No service fronts found.",
    "projectServiceFrontsRemove": "Remove {{name}}",
    "projectServiceFrontsOverflow": "{{count}} more service fronts",
    "projectServiceFrontsRequired": "Select at least one service front.",
    "formCreateTitle": "New collaborator",
    "addButtonLabel": "Add collaborator",
    "emptyCatalog": "No collaborators registered.",
    "formEditTitle": "Edit collaborator",
    "reviewPreviousPrefix": "Previous:",
    "backToList": "Back to collaborators",
    "notFound": "This collaborator no longer exists or you cannot access it.",
    "drawerDetailTitle": "Collaborator detail",
    "detailGeneralSection": "General",
    "detailPersonalSection": "Personal details",
    "addressesSection": "Address",
    "addressesEmpty": "No address registered.",
    "loadError": "Could not load collaborators.",
    "saveSuccess": "Collaborator saved.",
    "deleteSuccess": "Collaborator removed.",
    "deleteConfirmTitle": "Remove this collaborator?",
    "deleteConfirmDescription": "This cannot be undone. You cannot delete a collaborator assigned to diary activities.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This collaborator is assigned to activities and cannot be deleted.",
    "invalidProjectServiceFronts": "One or more selected service fronts are invalid.",
    "forbidden": "You don’t have permission to change collaborators.",
    "actionsMenu": "Actions",
    "emptyTitle": "No collaborators",
    "emptyDescription": "Add the team that appears on the diary.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No collaborators match your search.",
    "noFilterResults": "No collaborators match the selected filters.",
    "loadMoreError": "Could not load more collaborators.",
    "loadMoreRetry": "Try again",
    "filter": {
      "projectServiceFront": "Service fronts",
      "projectServiceFrontWithCount": "Service fronts, {{count}} selected",
      "projectServiceFrontSearch": "Search service fronts…",
      "projectServiceFrontEmpty": "No service fronts found.",
      "projectServiceFrontLoadError": "Could not load service fronts."
    },
    "filterProjectServiceFront": "Service fronts",
    "filterProjectServiceFrontWithCount": "Service fronts, {{count}} selected",
    "filterProjectServiceFrontClear": "Remove filter {{name}}",
    "filterProjectServiceFrontDialogTitle": "Filter by service front",
    "filterProjectServiceFrontDialogDescription": "Select one or more service fronts. Your selection is kept while you search.",
    "filterProjectServiceFrontSearch": "Search service fronts…",
    "filterProjectServiceFrontSelected": "Selected",
    "filterProjectServiceFrontResults": "Results",
    "filterProjectServiceFrontEmpty": "No service fronts found.",
    "filterProjectServiceFrontLoadError": "Could not load service fronts.",
    "filterApply": "Show results",
    "filterReset": "Clear",
    "filterCancel": "Cancel"
  },
  "occurrences": {
    "new": "New occurrence",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "createdAt": "Created",
    "colName": "Name",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#1A56DB",
    "colorInvalid": "Enter a valid hex color (e.g. #1A56DB).",
    "formCreateTitle": "New occurrence",
    "formEditTitle": "Edit occurrence",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Occurrence details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "backToList": "Back to occurrences",
    "notFound": "This occurrence no longer exists or you cannot access it.",
    "drawerDetailTitle": "Occurrence detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load occurrences.",
    "saveSuccess": "Occurrence saved.",
    "deleteSuccess": "Occurrence removed.",
    "deleteConfirmTitle": "Remove this occurrence?",
    "deleteConfirmDescription": "This cannot be undone. You cannot delete an occurrence that is in use.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This occurrence is in use and cannot be deleted.",
    "forbidden": "You don’t have permission to change occurrences.",
    "actionsMenu": "Actions",
    "emptyTitle": "No occurrences",
    "emptyDescription": "No occurrences are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No occurrences match your search.",
    "noFilterResults": "No occurrences match the selected filters.",
    "loadMoreError": "Could not load more occurrences.",
    "loadMoreRetry": "Try again"
  },
  "documentCategories": {
    "new": "New category",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "createdAt": "Created",
    "colName": "Name",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#1A56DB",
    "colorInvalid": "Enter a valid hex color (e.g. #1A56DB).",
    "formCreateTitle": "New document category",
    "formEditTitle": "Edit document category",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Category details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "backToList": "Back to categories",
    "notFound": "This category no longer exists or you cannot access it.",
    "drawerDetailTitle": "Document category detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load document categories.",
    "saveSuccess": "Category saved.",
    "deleteSuccess": "Category removed.",
    "deleteConfirmTitle": "Remove this category?",
    "deleteConfirmDescription": "This cannot be undone. You cannot delete a category that is in use.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This category is in use and cannot be deleted.",
    "forbidden": "You don’t have permission to change document categories.",
    "actionsMenu": "Actions",
    "emptyTitle": "No categories",
    "emptyDescription": "No document categories are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No categories match your search.",
    "noFilterResults": "No categories match the selected filters.",
    "loadMoreError": "Could not load more categories.",
    "loadMoreRetry": "Try again"
  },
  "projectDocuments": {
    "new": "New document",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "saveVersion": "Upload version",
    "cancel": "Cancel",
    "formSections": {
      "identification": "Identification"
    },
    "colCode": "Code",
    "codeLabel": "Code",
    "colName": "Document",
    "colCategory": "Category",
    "colCurrentVersion": "Current version",
    "colUpdatedAt": "Updated",
    "nameLabel": "Name",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "descriptionLabel": "Description",
    "changeDescriptionLabel": "Change description",
    "versionDateLabel": "Date",
    "versionAuthorLabel": "Uploaded by",
    "fileLabel": "File",
    "fileSizeLabel": "File size",
    "versionLabel": "Version",
    "actionsLabel": "Actions",
    "actionsMenu": "Actions",
    "previewAction": "Preview",
    "viewAction": "View",
    "downloadAction": "Download",
    "newVersion": "New version",
    "formCreateTitle": "New document",
    "formEditTitle": "Edit document",
    "formReviewTitle": "Review and submit",
    "formStepDetails": "Document details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "newVersionTitle": "New version — {{name}}",
    "newVersionStep": "Upload file",
    "backToList": "Back to documents",
    "drawerDetailTitle": "Document detail",
    "generalSection": "Information",
    "currentVersionSection": "Current version",
    "historySection": "Version history",
    "unknownUser": "Unknown user",
    "loadError": "Could not load documents.",
    "notFound": "Document not found.",
    "saveError": "Could not save the document.",
    "deleteError": "Could not delete the document.",
    "saveSuccess": "Document saved.",
    "versionSaveSuccess": "New version uploaded.",
    "deleteSuccess": "Document removed.",
    "deleteConfirmTitle": "Remove this document?",
    "deleteConfirmDescription": "This removes the document and all versions. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "fileRequired": "Select a file.",
    "fileInvalid": "Unsupported file type.",
    "emptyTitle": "No documents",
    "emptyDescription": "Upload project documents with version history.",
    "searchPlaceholder": "Search documents…",
    "clearSearch": "Clear search",
    "filterCategory": "Category",
    "filterCategorySearch": "Search categories…",
    "filterCategoryEmpty": "No categories found.",
    "clearFilters": "Clear filters",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noFilterResults": "No documents match the selected filters.",
    "loadMoreError": "Could not load more documents.",
    "loadMoreRetry": "Try again"
  },
  "projectBudgets": {
    "new": "New cost plan",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "saveVersion": "Create version",
    "cancel": "Cancel",
    "colName": "Cost plan",
    "colNumber": "Number",
    "colType": "Type",
    "colVersion": "Version",
    "colStatus": "Status",
    "colTotalValue": "Total",
    "colBudgetDate": "Plan date",
    "colServiceFront": "Service front",
    "selectCostLine": "Select cost line",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "numberLabel": "Number",
    "typeLabel": "Type",
    "typePlaceholder": "Select a type",
    "versionLabel": "Version",
    "statusLabel": "Status",
    "statusPlaceholder": "Select a status",
    "budgetDateLabel": "Plan date",
    "notesLabel": "Notes",
    "totalValueLabel": "Total value",
    "updatedAtLabel": "Updated",
    "plannedValueLabel": "Planned value",
    "lineNotesLabel": "Notes",
    "serviceFrontLabel": "Service front",
    "serviceFrontPlaceholder": "Select a service front",
    "serviceFrontLineTitle": "Service front {{index}}",
    "serviceFrontsSection": "Service fronts",
    "serviceFrontsRequired": "Add at least one service front.",
    "serviceFrontsDuplicate": "Each service front can only be selected once.",
    "itemsSection": "Cost lines",
    "itemsSectionDescription": "Plan the cost of this service front. This does not create a purchase.",
    "itemsRequired": "Add at least one cost line.",
    "itemLineTitle": "Line {{index}}",
    "itemNameLabel": "Description",
    "itemNameDescription": "What this service front should cost. This does not create a purchase.",
    "itemQuantityLabel": "Quantity",
    "itemUnitLabel": "Unit",
    "itemUnitPriceLabel": "Unit price",
    "itemPlannedValueLabel": "Planned value",
    "itemCatalogSection": "Catalog",
    "itemCatalogDescription": "Optional. Link a catalog item to fill a purchase request later. It does not add stock and does not buy anything.",
    "itemCatalogKindLabel": "Type",
    "itemCatalogKindPlaceholder": "Select a type",
    "itemCatalogKindMaterial": "Material",
    "itemCatalogKindEquipment": "Equipment",
    "itemCatalogKindOther": "Other",
    "itemMaterialLabel": "Material",
    "itemEquipmentLabel": "Equipment",
    "itemCatalogExclusive": "Link a material or equipment, not both.",
    "addItem": "Add cost line",
    "addItemSave": "Add",
    "editItem": "Edit cost line",
    "removeItem": "Remove cost line",
    "deleteItemConfirmTitle": "Remove this cost line?",
    "deleteItemConfirmDescription": "It will be removed from this cost plan.",
    "deleteItemConfirmAction": "Remove",
    "addServiceFront": "Add service front",
    "editServiceFront": "Edit service front",
    "addShort": "Add",
    "composerContinue": "Continue",
    "composerBack": "Back",
    "composerStepFront": "Service front",
    "composerStepLines": "Cost lines",
    "composerStepProgress": "{{current}} / {{total}} — {{label}}",
    "composerSelectedFront": "Selected service front",
    "composerLinesHint": "Each line is a planned cost for this service front — not a purchase.",
    "addLineTitle": "Add service front line",
    "addLineAction": "Add service front",
    "formDraftSection": "Service fronts in this cost plan",
    "formDraftEmpty": "No service fronts added yet.",
    "formDraftItemsSection": "Cost lines in this plan",
    "formDraftItemsEmpty": "No cost lines added yet.",
    "itemsCount": "{{count}} cost line(s)",
    "remove": "Remove",
    "lineDone": "Done",
    "removeServiceFront": "Remove service front",
    "liveTotal": "Total: {{value}}",
    "documentsLabel": "Documents",
    "documentsPlaceholder": "Select documents",
    "documentsSection": "Documents",
    "documentsCount": "{{count}} document(s)",
    "documentsEmpty": "No documents linked yet.",
    "manageDocuments": "Manage documents",
    "manageDocumentsTitle": "Manage documents",
    "manageDocumentsSave": "Save",
    "manageDocumentsSuccess": "Documents updated.",
    "manageDocumentsSelected": "{{count}} selected",
    "manageDocumentsPreviewEmpty": "Select a document to preview.",
    "manageDocumentsListEmpty": "No documents found.",
    "manageDocumentsLoadMore": "Load more",
    "manageDocumentsUnavailable": "No project documents available.",
    "serviceFrontsCount": "{{count}} service front(s)",
    "actionsMenu": "Actions",
    "newVersion": "New version",
    "formCreateTitle": "New cost plan",
    "formEditTitle": "Edit cost plan",
    "formReviewTitle": "Review and submit",
    "formStepDetails": "Cost plan details",
    "formSections": {
      "identification": "Identification",
      "items": "Cost lines"
    },
    "formStepServiceFronts": "Cost lines",
    "formStepServiceFrontsDescription": "Add the planned costs for this service front. This does not create a purchase.",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "newVersionTitle": "New version — {{name}}",
    "drawerDetailTitle": "Cost plan detail",
    "loadError": "Could not load cost plans.",
    "notFound": "Cost plan not found.",
    "saveError": "Could not save the cost plan.",
    "deleteError": "Could not delete the cost plan.",
    "saveSuccess": "Cost plan saved.",
    "versionSaveSuccess": "New cost plan version created.",
    "deleteSuccess": "Cost plan removed.",
    "deleteConfirmTitle": "Remove this cost plan?",
    "deleteConfirmDescription": "This removes the cost plan permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This cost plan has linked payables and cannot be deleted.",
    "approve": "Approve",
    "approveSuccess": "Cost plan approved.",
    "sendForReview": "Send for review",
    "sendForReviewSuccess": "Cost plan sent for review.",
    "reject": "Reject",
    "rejectSuccess": "Cost plan rejected.",
    "cancelBudget": "Cancel",
    "cancelBudgetSuccess": "Cost plan cancelled.",
    "emptyTitle": "No cost plans",
    "emptyDescription": "The usual path is to approve a client budget, then detail costs by service front. You can still create a cost plan without a client budget.",
    "commercialRevenueSection": "Client budget revenue",
    "plannedRevenueLabel": "Planned revenue",
    "plannedCostLabel": "Planned cost",
    "plannedMarginLabel": "Planned margin",
    "discountLabel": "Discount",
    "finalValueLabel": "Final value",
    "createPurchaseRequest": "Create purchase request",
    "createPurchaseRequestHint": "Creates a request from the selected planned lines only. A material that is not on the cost plan: New purchase request.",
    "createPurchaseRequestNeedItems": "Select at least one cost line.",
    "createPurchaseRequestSameFront": "Select cost lines from the same service front.",
    "currentEmpty": "No current cost plan yet.",
    "viewAll": "View cost planning",
    "searchPlaceholder": "Search cost plans…",
    "clearSearch": "Clear search",
    "filter": {
      "date": "Date",
      "type": "Type",
      "typeSearch": "Search types…",
      "typeEmpty": "No types found.",
      "status": "Status",
      "statusSearch": "Search statuses…",
      "statusEmpty": "No statuses found."
    },
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "clearFilters": "Clear filters",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noFilterResults": "No cost plans match the selected filters.",
    "loadMoreError": "Could not load more cost plans.",
    "loadMoreRetry": "Try again",
    "type": {
      "initial": "Initial",
      "revision": "Revision",
      "additive": "Additive"
    },
    "status": {
      "in_elaboration": "In elaboration",
      "under_review": "Under review",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    }
  },
  "projectClientBudgets": {
    "new": "New client budget",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "saveVersion": "Create version",
    "cancel": "Cancel",
    "colNumber": "Number",
    "colType": "Type",
    "colVersion": "Version",
    "colStatus": "Status",
    "colFinalValue": "Final value",
    "colBudgetDate": "Date",
    "headerSection": "Budget details",
    "clientProjectSection": "Client and job",
    "valuesSection": "Values",
    "clientLabel": "Client",
    "numberLabel": "Number",
    "numberHint": "Generated automatically. You can change it if you want.",
    "typeLabel": "Type",
    "typePlaceholder": "Select a type",
    "versionLabel": "Version",
    "statusLabel": "Status",
    "statusPlaceholder": "Select a status",
    "budgetDateLabel": "Budget date",
    "validUntilLabel": "Valid until",
    "notesLabel": "Notes",
    "itemsSection": "Sold items",
    "itemsSectionDescription": "What was sold to the client, by service front.",
    "itemsRequired": "Add at least one item.",
    "itemLineTitle": "Item {{index}}",
    "itemNameLabel": "Description",
    "itemDescriptionLabel": "Details",
    "itemAmountLabel": "Amount",
    "serviceFrontLabel": "Service front",
    "serviceFrontPlaceholder": "Select a service front",
    "addItem": "Add item",
    "addItemSave": "Add",
    "editItem": "Edit item",
    "removeItem": "Remove item",
    "emptyItemsHint": "No items added.",
    "itemsTableTitle": "Items in this budget",
    "colServiceFront": "Service front",
    "colItemName": "Description",
    "colItemAmount": "Amount",
    "commercialSection": "Commercial terms",
    "commercialSectionDescription": "Installments and deadline are contract terms. Approving the budget does not create receivables.",
    "discountLabel": "Discount",
    "discountHint": "Discount stays on the total. Per-front revenue uses item amounts.",
    "discountExceedsTotal": "Discount cannot be greater than the items total.",
    "paymentMethodLabel": "Payment method",
    "paymentMethodPlaceholder": "Select a payment method",
    "installmentCountLabel": "Number of installments",
    "executionDeadlineDaysLabel": "Execution deadline (days)",
    "executionDeadlineDaysValue_one": "{{count}} day",
    "executionDeadlineDaysValue_other": "{{count}} days",
    "commercialNotesLabel": "Commercial notes",
    "totalValueLabel": "Total",
    "finalValueLabel": "Final value",
    "updatedAtLabel": "Updated",
    "liveTotal": "Total: {{value}}",
    "liveDiscount": "Discount: {{value}}",
    "liveFinal": "Final value: {{value}}",
    "actionsMenu": "Actions",
    "newVersion": "New version",
    "formCreateTitle": "New client budget",
    "formEditTitle": "Edit client budget",
    "newVersionTitle": "New version — {{number}}",
    "drawerDetailTitle": "Client budget detail",
    "loadError": "Could not load the client budget.",
    "notFound": "Client budget not found.",
    "saveError": "Could not save the client budget.",
    "deleteError": "Could not delete the client budget.",
    "saveSuccess": "Client budget saved.",
    "versionSaveSuccess": "New client budget version created.",
    "deleteSuccess": "Client budget removed.",
    "deleteConfirmTitle": "Remove this client budget?",
    "deleteConfirmDescription": "This permanently removes the client budget. This action cannot be undone.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This client budget has linked receivables and cannot be deleted.",
    "emptyTitle": "No client budgets",
    "emptyDescription": "Define what was sold and for how much. After approval, cost planning uses this as revenue.",
    "orgEmptyTitle": "No quotes",
    "orgEmptyDescription": "Create a quote for a client. When you open the job, you can enter this quote’s number.",
    "colClient": "Client",
    "colProject": "Job",
    "projectLabel": "Job",
    "projectPlaceholder": "Select a job",
    "quoteScopeLabel": "Link",
    "quoteScopeUnattached": "No job",
    "quoteScopeAttached": "With a job",
    "proposedNameLabel": "Job name",
    "proposedAddressLabel": "Job address",
    "serviceFrontModelLabel": "Service front model",
    "serviceFrontModelPlaceholder": "Optional. If you pick one, sold items follow that model’s steps.",
    "serviceFrontModelStepLabel": "Model step",
    "serviceFrontModelStepPlaceholder": "Select a step",
    "itemsSectionDescriptionCommercial": "What was sold to the client. Without a model, each item is a commercial line.",
    "itemsSectionDescriptionModel": "What was sold to the client, by service front model step.",
    "approve": "Approve",
    "approveSuccess": "Quote approved.",
    "sendForReview": "Send for review",
    "sendForReviewSuccess": "Quote sent for review.",
    "reject": "Reject",
    "rejectSuccess": "Quote rejected.",
    "cancelBudget": "Cancel",
    "cancelBudgetSuccess": "Quote cancelled.",
    "noProjectYet": "No job yet",
    "searchPlaceholder": "Search client budgets…",
    "clearSearch": "Clear search",
    "filter": {
      "date": "Date",
      "type": "Type",
      "typeSearch": "Search types…",
      "typeEmpty": "No types found.",
      "status": "Status",
      "statusSearch": "Search statuses…",
      "statusEmpty": "No statuses found."
    },
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "clearFilters": "Clear filters",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noFilterResults": "No client budgets match the selected filters.",
    "loadMoreError": "Could not load more client budgets.",
    "loadMoreRetry": "Try again"
  },
  "purchaseRequests": {
    "new": "New request",
    "edit": "Edit",
    "save": "Save",
    "submit": "Submit for approval",
    "approve": "Approve",
    "cancel": "Cancel",
    "createQuotation": "Create quotation",
    "colNumber": "Number",
    "colNeededAt": "Needed by",
    "colServiceFront": "Service front",
    "colPriority": "Priority",
    "colStatus": "Status",
    "requestedAtLabel": "Requested on",
    "neededAtLabel": "Needed by",
    "serviceFrontLabel": "Service front",
    "serviceFrontPlaceholder": "Select a service front",
    "priorityLabel": "Priority",
    "priorityPlaceholder": "Select a priority",
    "notesLabel": "Notes",
    "itemsSection": "Items",
    "expandItems": "Hide details",
    "collapseItems": "Show details",
    "itemNameLabel": "Description",
    "itemNameDescription": "Product or service the job needs to buy.",
    "itemQuantityLabel": "Quantity",
    "itemUnitLabel": "Unit",
    "itemUnitPlaceholder": "Select a unit",
    "itemCatalogKindLabel": "Type",
    "itemCatalogKindPlaceholder": "Select a type",
    "itemCatalogKindMaterial": "Material",
    "itemCatalogKindEquipment": "Equipment",
    "itemCatalogKindOther": "Other",
    "itemMaterialLabel": "Material",
    "itemMaterialPlaceholder": "Select a material",
    "itemMaterialDescription": "Link a catalog material if it is already registered.",
    "itemEquipmentLabel": "Equipment",
    "itemEquipmentPlaceholder": "Select equipment",
    "addItem": "Add item",
    "addItemSave": "Add",
    "editItem": "Edit item",
    "removeItem": "Remove item",
    "emptyItemsHint": "No items added.",
    "deleteItemConfirmTitle": "Remove this item?",
    "deleteItemConfirmDescription": "It will be removed from this purchase request.",
    "deleteItemConfirmAction": "Remove",
    "itemsRequired": "Add at least one item.",
    "stepDetails": "Request details",
    "formSections": {
      "identification": "Identification",
      "items": "Items"
    },
    "stepReview": "Review and submit",
    "formCreateTitle": "New purchase request",
    "formEditTitle": "Edit purchase request",
    "formReviewTitle": "Review and submit",
    "detailTitle": "Purchase request",
    "backToList": "Back to requests",
    "loadError": "Could not load purchase requests.",
    "saveError": "Could not save the purchase request.",
    "saveSuccess": "Purchase request saved.",
    "submitSuccess": "Purchase request submitted for approval.",
    "approveSuccess": "Purchase request approved.",
    "cancelSuccess": "Purchase request cancelled.",
    "quotationCreated": "Purchase request sent to quotation.",
    "notFound": "This purchase request no longer exists or you do not have access.",
    "editDraftOnly": "Only draft purchase requests can be edited.",
    "cancelConfirmTitle": "Cancel this purchase request?",
    "cancelConfirmDescription": "The request will be cancelled. Any quotations in progress for this request will also be cancelled.",
    "cancelConfirmAction": "Cancel request",
    "actionsMenu": "Actions",
    "emptyTitle": "No purchase requests",
    "emptyDescription": "Ask for what the job needs to buy. You will quote suppliers next.",
    "emptyFilteredTitle": "No requests found",
    "emptyFilteredDescription": "No purchase request matches the search.",
    "searchPlaceholder": "Search requests…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results"
  },
  "projectQuotations": {
    "colNumber": "Number",
    "colName": "Quotation",
    "colDate": "Date",
    "colDeadline": "Response deadline",
    "colStatus": "Status",
    "actionsMenu": "Actions",
    "nameLabel": "Name",
    "dateLabel": "Quotation date",
    "deadlineLabel": "Response deadline",
    "notesLabel": "Notes",
    "requestLabel": "Purchase request",
    "openRequest": "Open request",
    "fromRequest": "Quotation from",
    "detailTitle": "Quotation",
    "formSections": {
      "identification": "Identification"
    },
    "backToList": "Back to quotations",
    "compareTitle": "Compare suppliers",
    "expandCompare": "Hide details",
    "collapseCompare": "Show details",
    "supplierCol": "Supplier",
    "actionsCol": "Actions",
    "addSupplier": "Add supplier",
    "partnerLabel": "Supplier",
    "partnerPlaceholder": "Search suppliers",
    "newPartnerLabel": "Or type a new supplier name",
    "supplierAdded": "Supplier added.",
    "removeSupplier": "Remove",
    "removeSupplierConfirmTitle": "Remove this supplier?",
    "removeSupplierConfirmDescription": "This supplier's prices will be removed from the quotation. This cannot be undone.",
    "removeSupplierConfirmAction": "Remove",
    "supplierRemoved": "Supplier removed.",
    "pricesPending": "Unsaved changes…",
    "pricesSaving": "Saving…",
    "pricesSaved": "All changes saved",
    "pricesSaveFailedShort": "Couldn’t save — will retry",
    "selectSupplier": "Select",
    "selected": "Selected",
    "unselectSupplier": "Undo selection",
    "supplierSelected": "Supplier selected.",
    "supplierUnselected": "Selection cleared.",
    "approve": "Approve",
    "approveSuccess": "Quotation approved.",
    "createPurchaseOrder": "Generate purchase order",
    "poCreated": "Purchase order generated.",
    "openPurchaseOrder": "Order {{number}}",
    "cancel": "Cancel",
    "cancelConfirmTitle": "Cancel this quotation?",
    "cancelConfirmDescription": "The quotation will be cancelled and cannot generate a purchase order.",
    "cancelConfirmAction": "Cancel quotation",
    "cancelSuccess": "Quotation cancelled.",
    "noSuppliers": "Add suppliers to compare prices. The cheapest option is never selected automatically.",
    "unitPriceLabel": "Unit price",
    "freightLabel": "Freight",
    "leadTimeLabel": "Lead time (days)",
    "leadTimeCol": "Delivery",
    "paymentTermLabel": "Payment term (days)",
    "paymentTermCol": "Payment",
    "daysUnit": "days",
    "totalLabel": "Total",
    "loadError": "Could not load quotations.",
    "notFound": "This quotation no longer exists or you do not have access.",
    "emptyTitle": "No quotations",
    "emptyDescription": "Create a quotation from an approved purchase request.",
    "emptyFilteredTitle": "No quotations found",
    "emptyFilteredDescription": "No quotation matches the search.",
    "searchPlaceholder": "Search quotations…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results"
  },
  "purchaseOrders": {
    "colNumber": "Number",
    "colPartner": "Supplier",
    "colTotal": "Total",
    "colStatus": "Status",
    "colReceived": "Stock",
    "notReceived": "Not updated",
    "freightLabel": "Freight",
    "quotationLabel": "Quotation",
    "openQuotation": "Open quotation",
    "notesLabel": "Notes",
    "formSections": {
      "identification": "Identification"
    },
    "itemsSection": "Items",
    "expandItems": "Hide details",
    "collapseItems": "Show details",
    "colItemName": "Item",
    "itemQuantityLabel": "Quantity",
    "itemUnitPriceLabel": "Unit price",
    "colLineTotal": "Amount",
    "itemMaterialLabel": "Material",
    "noMaterial": "No catalog material",
    "detailTitle": "Purchase order",
    "backToList": "Back to orders",
    "generatePayable": "Generate payable",
    "payableCreated": "Payable generated.",
    "payableAmountHint": "The amount will be {{amount}} (order total, including freight).",
    "openPayable": "Open payable",
    "updateStock": "Update stock",
    "updateStockHint": "This adds the quantities to job-site stock. Organization warehouse stock is not changed.",
    "pickMaterial": "Choose material",
    "stockUpdated": "Job-site stock updated.",
    "cancel": "Cancel",
    "cancelConfirmTitle": "Cancel this purchase order?",
    "cancelConfirmDescription": "The order will be cancelled. You can generate a new order from the quotation if needed.",
    "cancelConfirmAction": "Cancel order",
    "cancelSuccess": "Purchase order cancelled.",
    "loadError": "Could not load purchase orders.",
    "notFound": "This purchase order no longer exists or you do not have access.",
    "emptyTitle": "No purchase orders",
    "emptyDescription": "Generate an order from an approved quotation.",
    "emptyFilteredTitle": "No orders found",
    "emptyFilteredDescription": "No purchase order matches the search.",
    "searchPlaceholder": "Search orders…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results"
  },
  "projectTracking": {
    "loadError": "Could not load project overview.",
    "alertsTitle": "Alerts",
    "alertsEmpty": "No open alerts.",
    "openServiceFronts": "Open service fronts",
    "expandView": "Expand",
    "collapseView": "Exit expanded view",
    "tabs": {
      "schedule": "Schedule",
      "fronts": "Fronts",
      "timeline": "Timeline",
      "indicators": "Indicators"
    },
    "modeTitles": {
      "schedule": "Project schedule",
      "fronts": "Front status",
      "timeline": "Recent activity",
      "indicators": "Project indicators"
    },
    "summary": {
      "needsAttention": "Project needs attention",
      "onTrack": "Project on track",
      "lastUpdate": "Last update",
      "completed": "Completed",
      "openAlerts": "Open alerts",
      "frontsProgress": "{{completed}} of {{total}}",
      "frontsCompleted": "Service fronts completed"
    },
    "schedule": {
      "onTrack": "On track",
      "overdue": "Overdue",
      "noDueDate": "No due date",
      "daysProgress": "{{elapsed}} / {{planned}} days",
      "daysElapsed": "{{count}} days"
    },
    "alertMessages": {
      "projectOverdue": "Project overdue by {{days}} days",
      "frontOverdue": "{{name}} delayed {{days}} days",
      "frontOverdueGroup": "{{count}} service fronts overdue",
      "frontOverdueDays": "{{days}} days overdue",
      "viewAll": "View all",
      "collapse": "Collapse",
      "diaryMissing": "Diary not filled yesterday",
      "diaryStale": "No diary entry for {{days}}+ days"
    },
    "scheduleColumns": {
      "name": "Front",
      "start": "Start",
      "end": "End",
      "duration": "Days"
    },
    "scheduleEmpty": "No schedule dates available for service fronts.",
    "frontsEmpty": "No service fronts yet.",
    "frontsNoWorkers": "No responsible workers",
    "frontsUpdated": "Updated",
    "timelineEmpty": "No recent activity.",
    "timelineDiary": "Diary by {{name}}",
    "timelineOccurrence": "Occurrence: {{name}}",
    "timelineMaterial": "Material: {{name}}",
    "indicators": {
      "occurrencesByMonth": "Occurrences by month",
      "diaryEntriesByMonth": "Project diary entries per month",
      "openOccurrencesBySeverity": "Open occurrences by severity",
      "topConsumedMaterials": "Materials consumption",
      "count": "Count",
      "consumedQuantity": "Consumed quantity",
      "equipmentAllocation": "Equipment allocation",
      "photosByMonth": "Photos timeline",
      "serviceFrontsByStatus": "Planned vs completed service fronts",
      "frontProgress": "Progress by front",
      "progress": "Progress",
      "total": "Total",
      "scheduleTitle": "Schedule",
      "elapsedDays": "Days elapsed",
      "plannedDays": "Planned days",
      "overdueFronts": "Overdue fronts",
      "measurementTitle": "Measurement",
      "plannedQuantity": "Planned quantity",
      "quantityAdvanced": "Measured quantity",
      "measuredValue": "Measured value",
      "diaryComplianceTitle": "Diary (30 days)",
      "publishedDays": "Days with a diary",
      "expectedWorkdays": "Workdays",
      "purchasingTitle": "Purchasing",
      "openRequests": "Open requests",
      "awaitingQuotes": "Quotes waiting",
      "openOrders": "Open orders",
      "stockTitle": "Stock",
      "belowMinimum": "Below minimum",
      "cashTitle": "Project cash",
      "payables": "Payables",
      "receivables": "Receivables",
      "cashOpen": "Open",
      "cashOverdue": "Overdue",
      "severity": {
        "critical": "Critical",
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "equipmentStatus": {
        "allocated": "Allocated",
        "available": "Available",
        "maintenance": "Maintenance"
      },
      "frontStatus": {
        "completed": "Completed",
        "in_progress": "In progress",
        "not_started": "Not started"
      }
    },
    "indicatorsEmpty": "Not enough data yet."
  },
  "projectPhotos": {
    "addPhoto": "Add photo",
    "atCapHint": "Album general photo limit reached ({{used}}/{{limit}}). Diary photos do not count toward this limit.",
    "edit": "Edit",
    "delete": "Delete",
    "drawerTitle": "Photo detail",
    "detailsTitle": "Detail",
    "infoTitle": "Information",
    "captionLabel": "Caption",
    "dateLabel": "Date",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "uploaderLabel": "Uploaded by",
    "originSection": "Origin",
    "originTypeLabel": "Type",
    "serviceFrontLabel": "Service front",
    "occurrenceLabel": "Occurrence",
    "diaryEntryLabel": "Diary entry",
    "openDiaryEntry": "Open diary entry",
    "tagsSection": "Tags",
    "tagsLabel": "Tags",
    "tagsPlaceholder": "Search tags",
    "noTagsAvailable": "No tags available.",
    "unknownUser": "Unknown user",
    "origin": {
      "general": "General project photo",
      "serviceFront": "Service front",
      "occurrence": "Occurrence"
    },
    "uploadTitle": "Add photo",
    "uploadHint": "Choose an image or take a photo.",
    "dropHint": "Drop the image to upload.",
    "chooseFile": "Choose file",
    "takePhoto": "Take photo",
    "uploadAction": "Upload",
    "uploadSuccess": "Photo added.",
    "invalidFile": "Unsupported file type.",
    "saveSuccess": "Photo updated.",
    "deleteSuccess": "Photo removed.",
    "deleteConfirmTitle": "Remove this photo?",
    "deleteConfirmDescription": "This action cannot be undone.",
    "emptyTitle": "No photos",
    "emptyDescription": "Add general project photos or capture photos in the diary.",
    "loadError": "Could not load photos.",
    "noFilterResults": "No photos match the selected filters.",
    "loadMoreError": "Could not load more photos.",
    "loadMoreRetry": "Try again",
    "saveError": "Could not save the photo.",
    "deleteError": "Could not delete the photo.",
    "filter": {
      "date": "Date",
      "origin": "Origin",
      "originEmpty": "No origins found.",
      "tags": "Tags",
      "tagsSearch": "Search tags…",
      "tagsEmpty": "No tags found.",
      "creators": "Uploaded by",
      "creatorsSearch": "Search people…",
      "creatorsEmpty": "No people found."
    }
  },
  "photoTags": {
    "title": "Photo tags",
    "new": "New tag",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "nameLabel": "Name",
    "colorLabel": "Color",
    "colorPlaceholder": "#1D4ED8",
    "colorInvalid": "Enter a valid color (e.g. #1D4ED8).",
    "formCreateTitle": "New tag",
    "formEditTitle": "Edit tag",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Tag details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "colName": "Name",
    "colColor": "Color",
    "colStatus": "Status",
    "typeLabel": "Type",
    "reservedBadge": "Reserved",
    "createdAt": "Created at",
    "total": "{{count}} tags",
    "actionsMenu": "Tag actions",
    "searchPlaceholder": "Search tags",
    "clearSearch": "Clear search",
    "drawerDetailTitle": "Tag detail",
    "emptyTitle": "No tags",
    "emptyDescription": "No photo tags are configured for this organization yet.",
    "noFilterResults": "No tags found for the applied filters.",
    "noSearchResults": "No tags found for the search.",
    "loadError": "Could not load tags.",
    "loadMoreError": "Could not load more tags.",
    "loadMoreRetry": "Try again",
    "notFound": "Tag not found.",
    "saveSuccess": "Tag saved.",
    "deleteSuccess": "Tag removed.",
    "deleteConfirmTitle": "Remove this tag?",
    "deleteConfirmDescription": "The tag will be removed from all photos. This action cannot be undone.",
    "deleteConfirmAction": "Remove"
  },
  "materialCategories": {
    "new": "New category",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "formCreateTitle": "New category",
    "formEditTitle": "Edit category",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Category details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Category detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load categories.",
    "saveSuccess": "Category saved.",
    "deleteSuccess": "Category removed.",
    "deleteConfirmTitle": "Remove this category?",
    "deleteConfirmDescription": "This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "actionsMenu": "Actions",
    "emptyTitle": "No categories",
    "emptyCatalog": "No categories registered.",
    "emptyDescription": "No material categories are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No categories match your search.",
    "noFilterResults": "No categories match the selected filters.",
    "loadMoreError": "Could not load more categories.",
    "loadMoreRetry": "Try again",
    "notFound": "This category no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "materials": {
    "new": "New material",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colCode": "Code",
    "colName": "Name",
    "colCategory": "Category",
    "colUnit": "Unit",
    "colBrand": "Brand",
    "colManufacturer": "Manufacturer",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "codeLabel": "Code",
    "codeHint": "Generated automatically. You can change it if you want.",
    "descriptionLabel": "Description",
    "barcodeLabel": "Barcode",
    "barcodeHint": "Optional. Must be unique within the organization.",
    "barcodeInvalid": "Use 8 to 64 characters (letters, numbers, - or _).",
    "brandLabel": "Brand",
    "manufacturerLabel": "Manufacturer",
    "modelLabel": "Model",
    "minimumStockLabel": "Minimum stock",
    "currentStockLabel": "Current stock",
    "colCurrentStock": "Current stock",
    "colMinimumStock": "Minimum stock",
    "categoryLabel": "Category",
    "unitLabel": "Measurement unit",
    "categoryPlaceholder": "Select a category",
    "unitPlaceholder": "Select a unit",
    "noneOption": "None",
    "formCreateTitle": "New material",
    "formEditTitle": "Edit material",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Material details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "drawerDetailTitle": "Material detail",
    "drawerNoDescription": "No description",
    "drawerNoCategory": "No category",
    "drawerNoUnit": "No unit",
    "drawerNoValue": "—",
    "loadError": "Could not load materials.",
    "saveSuccess": "Material saved.",
    "deleteSuccess": "Material removed.",
    "deleteConfirmTitle": "Remove this material?",
    "deleteConfirmDescription": "This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "actionsMenu": "Actions",
    "actionsStockSection": "Stock",
    "viewMovements": "View movements",
    "emptyTitle": "No materials",
    "emptyDescription": "No materials are configured for this organization yet.",
    "searchPlaceholder": "Search by name, code, brand…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No materials match your search.",
    "noFilterResults": "No materials match the selected filters.",
    "loadMoreError": "Could not load more materials.",
    "loadMoreRetry": "Try again",
    "codeNotFound": "No material found with this code.",
    "notFound": "This material no longer exists or you cannot access it.",
    "createdAt": "Created",
    "filterCategory": "Category",
    "filterCategorySearch": "Search categories…",
    "filterCategoryEmpty": "No categories found.",
    "filterBrand": "Brand",
    "filterBrandSearch": "Search brands…",
    "filterBrandEmpty": "No brands found.",
    "filterManufacturer": "Manufacturer",
    "filterManufacturerSearch": "Search manufacturers…",
    "filterManufacturerEmpty": "No manufacturers found.",
    "stockAdd": "Add",
    "stockRemove": "Remove",
    "stockAdjustAddTitle": "Add stock",
    "stockAdjustRemoveTitle": "Remove stock",
    "stockAdjustQuantityLabel": "Quantity",
    "stockAdjustConfirmAdd": "Add stock",
    "stockAdjustConfirmRemove": "Remove stock",
    "stockAdjustSuccess": "Stock updated.",
    "stockInsufficient": "Cannot remove more than the current stock.",
    "tabs": {
      "list": "List",
      "movements": "Stock movements"
    }
  },
  "materialStockMovements": {
    "pageTitle": "Stock movements",
    "colDate": "Date",
    "colMaterial": "Material",
    "colCategory": "Category",
    "colQuantity": "Quantity",
    "colSource": "Type",
    "colOrigin": "Description",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load stock movements.",
    "loadMoreError": "Could not load more movements.",
    "loadMoreRetry": "Try again",
    "emptyTitle": "No stock movements",
    "emptyDescription": "Stock changes will appear here.",
    "emptyFilteredTitle": "No movements match your filters",
    "emptyFilteredDescription": "Try adjusting the date range or filters.",
    "drawerTitle": "Stock movements",
    "formSections": {
      "identification": "Identification"
    },
    "recentSection": "Recent movements",
    "searchPlaceholder": "Search by name or code",
    "clearSearch": "Clear search",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "filter": {
      "date": "Date",
      "material": "Material",
      "materialSearch": "Search materials",
      "materialEmpty": "No materials found",
      "category": "Category",
      "categorySearch": "Search categories",
      "categoryEmpty": "No categories found",
      "type": "Type",
      "typeSearch": "Search types",
      "typeEmpty": "No types found"
    },
    "source": {
      "opening_balance": "Opening balance",
      "purchase": "Purchase",
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out",
      "consumption": "Consumption",
      "adjustment": "Adjustment",
      "return": "Return",
      "manual": "Manual"
    }
  },
  "workerRoles": {
    "new": "New role",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "formCreateTitle": "New role",
    "formEditTitle": "Edit role",
    "drawerDetailTitle": "Role detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load roles.",
    "saveSuccess": "Role saved.",
    "deleteSuccess": "Role removed.",
    "deleteConfirmTitle": "Remove this role?",
    "deleteConfirmDescription": "You cannot delete a role that is assigned to collaborators.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This role is in use and cannot be deleted.",
    "actionsMenu": "Actions",
    "emptyTitle": "No roles",
    "emptyCatalog": "No roles registered.",
    "emptyDescription": "Add roles for the team.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No roles match your search.",
    "noFilterResults": "No roles match the selected filters.",
    "loadMoreError": "Could not load more roles.",
    "loadMoreRetry": "Try again",
    "notFound": "This role no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "weatherConditions": {
    "new": "New condition",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "formCreateTitle": "New weather condition",
    "formEditTitle": "Edit weather condition",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Condition details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Weather condition detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load weather conditions.",
    "saveSuccess": "Weather condition saved.",
    "deleteSuccess": "Weather condition removed.",
    "deleteConfirmTitle": "Remove this weather condition?",
    "deleteConfirmDescription": "You cannot delete a condition that is used in diary entries.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This condition is in use and cannot be deleted.",
    "actionsMenu": "Actions",
    "emptyTitle": "No weather conditions",
    "emptyDescription": "No weather conditions are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No conditions match your search.",
    "noFilterResults": "No conditions match the selected filters.",
    "loadMoreError": "Could not load more conditions.",
    "loadMoreRetry": "Try again",
    "notFound": "This condition no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "projectPriorities": {
    "new": "New priority",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#2563EB",
    "formCreateTitle": "New project priority",
    "formEditTitle": "Edit project priority",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Priority details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Project priority detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load project priorities.",
    "saveSuccess": "Project priority saved.",
    "deleteSuccess": "Project priority removed.",
    "deleteConfirmTitle": "Remove this project priority?",
    "deleteConfirmDescription": "Priorities used by projects cannot be deleted.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This priority is in use and cannot be deleted.",
    "actionsMenu": "Actions",
    "emptyTitle": "No project priorities",
    "emptyDescription": "No project priorities are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No priorities match your search.",
    "noFilterResults": "No priorities match the selected filters.",
    "loadMoreError": "Could not load more priorities.",
    "loadMoreRetry": "Try again",
    "notFound": "This priority no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "projectTypes": {
    "new": "New type",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colDefaultModel": "Default model",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "defaultModelLabel": "Default service front model",
    "defaultModelPlaceholder": "Select a model…",
    "noDefaultModel": "No default model",
    "drawerNoDefaultModel": "None",
    "formCreateTitle": "New project type",
    "formEditTitle": "Edit project type",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Type details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Project type detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load project types.",
    "saveSuccess": "Project type saved.",
    "deleteSuccess": "Project type removed.",
    "deleteConfirmTitle": "Remove this project type?",
    "deleteConfirmDescription": "Types used by projects cannot be deleted.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This type is in use and cannot be deleted.",
    "actionsMenu": "Actions",
    "emptyTitle": "No project types",
    "emptyDescription": "No project types are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No types match your search.",
    "noFilterResults": "No types match the selected filters.",
    "loadMoreError": "Could not load more types.",
    "loadMoreRetry": "Try again",
    "notFound": "This type no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "projectStatuses": {
    "edit": "Edit",
    "save": "Save",
    "colName": "Name",
    "colKey": "System key",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "keyLabel": "System key",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Edit project status",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Status details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Project status detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load project statuses.",
    "emptyTitle": "No project statuses",
    "emptyDescription": "No project statuses are configured for this organization yet.",
    "saveSuccess": "Project status saved.",
    "actionsMenu": "Actions",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This status no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "projectBudgetStatuses": {
    "edit": "Edit",
    "save": "Save",
    "colName": "Name",
    "colKey": "System key",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "keyLabel": "System key",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Edit cost planning status",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Status details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Cost planning status detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load cost planning statuses.",
    "emptyTitle": "No cost planning statuses",
    "emptyDescription": "No cost planning statuses are configured for this organization yet.",
    "saveSuccess": "Cost planning status saved.",
    "actionsMenu": "Actions",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This status no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "projectClientBudgetStatuses": {
    "edit": "Edit",
    "save": "Save",
    "colName": "Name",
    "colKey": "System key",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "keyLabel": "System key",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#2563EB",
    "formEditTitle": "Edit client budget status",
    "drawerDetailTitle": "Client budget status detail",
    "loadError": "Could not load client budget statuses.",
    "emptyTitle": "No client budget statuses",
    "emptyDescription": "No client budget statuses are configured for this organization yet.",
    "saveSuccess": "Client budget status saved.",
    "actionsMenu": "Actions",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This status no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "serviceFrontDeadlineStatuses": {
    "edit": "Edit",
    "save": "Save",
    "colName": "Name",
    "colKey": "System key",
    "colDescription": "Description",
    "colColor": "Color",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "keyLabel": "System key",
    "descriptionLabel": "Description",
    "colorLabel": "Color",
    "colorPlaceholder": "#EAB308",
    "formEditTitle": "Edit deadline status",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Status details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Deadline status detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load deadline statuses.",
    "emptyTitle": "No deadline statuses",
    "emptyDescription": "No deadline statuses are configured for this organization yet.",
    "saveSuccess": "Deadline status saved.",
    "actionsMenu": "Actions",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This status no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "measurementUnits": {
    "new": "New unit",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colSymbol": "Symbol",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "symbolLabel": "Symbol",
    "symbolPlaceholder": "kg",
    "formCreateTitle": "New measurement unit",
    "formEditTitle": "Edit measurement unit",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Unit details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Measurement unit detail",
    "loadError": "Could not load measurement units.",
    "saveSuccess": "Measurement unit saved.",
    "deleteSuccess": "Measurement unit removed.",
    "deleteConfirmTitle": "Remove this unit?",
    "deleteConfirmDescription": "You cannot delete a unit that is used by materials.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This unit is in use and cannot be deleted.",
    "actionsMenu": "Actions",
    "emptyTitle": "No measurement units",
    "emptyCatalog": "No measurement units registered.",
    "emptyDescription": "No measurement units are configured for this organization yet.",
    "searchPlaceholder": "Search by name or symbol…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No units match your search.",
    "noFilterResults": "No units match the selected filters.",
    "loadMoreError": "Could not load more units.",
    "loadMoreRetry": "Try again",
    "notFound": "This unit no longer exists or you cannot access it."
  },
  "partners": {
    "new": "New partner",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "colName": "Name",
    "colCode": "Code",
    "colPersonType": "Person",
    "colDocument": "Document",
    "colEmail": "Email",
    "colPhone": "Phone",
    "colKind": "Type",
    "colStatus": "Status",
    "detailGeneralSection": "General",
    "nameLabel": "Name",
    "codeLabel": "Code",
    "codeNotFound": "No partner found with this code.",
    "codeTaken": "A partner with this code already exists.",
    "nameLabelIndividual": "Full name",
    "nameLabelCompany": "Trade name",
    "legalNameLabel": "Legal name",
    "legalNameRequired": "Enter the legal name.",
    "documentLabel": "Document",
    "cpfLabel": "CPF",
    "cnpjLabel": "CNPJ",
    "cpfPlaceholder": "000.000.000-00",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "cpfInvalid": "Enter a valid CPF.",
    "rgLabel": "ID number",
    "stateRegistrationLabel": "State tax ID",
    "municipalRegistrationLabel": "Municipal tax ID",
    "birthDateLabel": "Date of birth",
    "birthDatePlaceholder": "DD/MM/YYYY",
    "birthDateOpenCalendar": "Open calendar",
    "birthDateFuture": "Date of birth cannot be in the future.",
    "emailLabel": "Email",
    "emailInvalid": "Enter a valid email.",
    "phoneLabel": "Phone",
    "phonePlaceholder": "(00) 00000-0000",
    "phoneInvalid": "Enter a valid phone number.",
    "personTypeLabel": "Type",
    "personTypeIndividual": "Individual",
    "personTypeCompany": "Company",
    "filterPersonType": "Person",
    "filterPersonTypeSearch": "Search person types…",
    "filterPersonTypeEmpty": "No person types found.",
    "filterKind": "Type",
    "filterKindSearch": "Search types…",
    "filterKindEmpty": "No types found.",
    "isFinalConsumerLabel": "End consumer for NFS-e issuance",
    "isFinalConsumerDescription": "Indicates whether this partner is an end consumer for NFS-e invoices.",
    "isFinalConsumerYes": "Yes",
    "isFinalConsumerNo": "No",
    "formSections": {
      "type": "Type",
      "identification": "Identification",
      "contact": "Contact",
      "details": "Details"
    },
    "addressesSection": "Address",
    "addAddress": "Add address",
    "removeAddress": "Remove address",
    "removeAddressConfirmTitle": "Remove this address?",
    "removeAddressConfirmDescription": "This removes the address from this partner. This cannot be undone after you save.",
    "removeAddressConfirmAction": "Remove",
    "addressesEmpty": "No addresses yet.",
    "contactsEmpty": "No contacts yet.",
    "duplicateContact": "This contact has already been added.",
    "formContactCreateTitle": "New contact",
    "formContactEditTitle": "Edit contact",
    "removeContactConfirmTitle": "Remove this contact?",
    "removeContactConfirmDescription": "This removes the contact from this partner. This cannot be undone after you save.",
    "removeContactConfirmAction": "Remove",
    "duplicateAddress": "This address has already been added.",
    "formAddressCreateTitle": "New address",
    "formAddressEditTitle": "Edit address",
    "zipCodeLabel": "Postal code",
    "zipCodePlaceholder": "00000-000",
    "zipCodeSearching": "Looking up address…",
    "zipInvalid": "Enter a valid postal code.",
    "streetLabel": "Street",
    "streetNumberLabel": "Number",
    "complementLabel": "Complement",
    "neighborhoodLabel": "Neighborhood",
    "cityLabel": "City",
    "stateLabel": "State",
    "statePlaceholder": "Select",
    "contactsSection": "Contacts",
    "addContact": "Add contact",
    "removeContact": "Remove contact",
    "contactNameLabel": "Name",
    "paymentMethodsSection": "Payment details",
    "addPaymentData": "Add payment details",
    "removePaymentData": "Remove payment details",
    "paymentDataEmpty": "No payment details yet.",
    "duplicatePaymentData": "This payment detail has already been added.",
    "formPaymentDataCreateTitle": "New payment details",
    "formPaymentDataEditTitle": "Edit payment details",
    "removePaymentDataConfirmTitle": "Remove these payment details?",
    "removePaymentDataConfirmDescription": "This removes the payment details from this partner. This cannot be undone after you save.",
    "removePaymentDataConfirmAction": "Remove",
    "paymentDataTypeLabel": "Type",
    "paymentDataTypePix": "Pix",
    "paymentDataTypeTed": "TED",
    "paymentDataTypeAch": "ACH",
    "paymentDataTypeCheck": "Check",
    "paymentDataTypeWire": "Wire",
    "paymentDataTypeMoney": "Cash",
    "paymentDataTypeOther": "Other",
    "paymentDataDescriptionLabel": "Description",
    "paymentDataDescriptionPlaceholder": "Ex: Supplier Pix, Banco do Brasil account",
    "paymentDataSelectPlaceholder": "Select",
    "paymentDataBankLabel": "Bank",
    "paymentDataAgencyLabel": "Branch",
    "paymentDataRoutingLabel": "Routing number",
    "paymentDataAgencyPlaceholder": "Ex: 1234",
    "paymentDataAccountLabel": "Account",
    "paymentDataAccountPlaceholder": "Ex: 00123-4",
    "paymentDataPixKeyTypeLabel": "Pix key type",
    "paymentDataPixKeyTypeCpf": "CPF",
    "paymentDataPixKeyTypeCnpj": "CNPJ",
    "paymentDataPixKeyTypeEmail": "Email",
    "paymentDataPixKeyTypePhone": "Phone",
    "paymentDataPixKeyTypeEvp": "Random key",
    "paymentDataPixKeyLabel": "Pix key",
    "paymentDataPixKeyPlaceholder": "Enter",
    "paymentDataPixKeyInvalid": "Enter a valid Pix key.",
    "paymentDataNotesPlaceholder": "Enter",
    "paymentDataIsPrimary": "Set as the primary payment method",
    "paymentDataDetailsLabel": "Details",
    "paymentDataPrimaryColumn": "Primary",
    "kindLabel": "Type",
    "notesLabel": "Notes",
    "isClient": "Client",
    "isSupplier": "Supplier",
    "isServiceProvider": "Service provider",
    "kindClient": "Client",
    "kindSupplier": "Supplier",
    "kindServiceProvider": "Service provider",
    "kindRequired": "Select client, supplier, service provider, or a combination.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "formCreateTitle": "New partner",
    "formEditTitle": "Edit partner",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Partner details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "drawerDetailTitle": "Partner detail",
    "loadError": "Could not load partners.",
    "loadMoreError": "Could not load more partners.",
    "loadMoreRetry": "Try again",
    "saveSuccess": "Partner saved.",
    "deleteSuccess": "Partner removed.",
    "deleteConfirmTitle": "Remove this partner?",
    "deleteConfirmDescription": "This removes the partner permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This partner is in use and cannot be deleted.",
    "nameTaken": "A partner with this name already exists.",
    "documentTaken": "A partner with this document already exists.",
    "actionsMenu": "Actions",
    "emptyTitle": "No partners",
    "emptyDescription": "Register clients, suppliers, and service providers for projects and finance.",
    "emptyFilteredTitle": "No partners found",
    "emptyFilteredDescription": "No partners match the selected filters.",
    "searchPlaceholder": "Search partners…",
    "clearSearch": "Clear search",
    "addButtonLabel": "Add partner",
    "emptyCatalog": "No clients registered.",
    "emptyCatalogSupplier": "No suppliers registered.",
    "emptyCatalogServiceProvider": "No service providers registered.",
    "codeNotFound": "No partner found with this document.",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This partner no longer exists or you cannot access it."
  },
  "financialCategories": {
    "new": "New category",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "colName": "Name",
    "colKind": "Type",
    "colGroup": "Group",
    "colStatus": "Status",
    "nameLabel": "Name",
    "kindLabel": "Type",
    "kindPlaceholder": "Select a type",
    "groupLabel": "Cash-flow group",
    "groupPlaceholder": "Select a cash-flow group",
    "kind": {
      "payable": "Expense",
      "receivable": "Revenue"
    },
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "formCreateTitle": "New financial category",
    "formEditTitle": "Edit financial category",
    "drawerDetailTitle": "Category detail",
    "loadError": "Could not load financial categories.",
    "saveSuccess": "Financial category saved.",
    "deleteSuccess": "Financial category removed.",
    "deleteConfirmTitle": "Remove this category?",
    "deleteConfirmDescription": "This removes the category permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This category is in use and cannot be deleted.",
    "nameTaken": "A financial category with this name already exists.",
    "actionsMenu": "Actions",
    "emptyTitle": "No financial categories",
    "emptyDescription": "Create categories to classify payables and receivables.",
    "emptyFilteredTitle": "No categories found",
    "emptyFilteredDescription": "No categories match the selected filters.",
    "searchPlaceholder": "Search categories…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This category no longer exists or you cannot access it."
  },
  "paymentMethods": {
    "new": "New payment method",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "colName": "Name",
    "colStatus": "Status",
    "nameLabel": "Name",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "formCreateTitle": "New payment method",
    "formEditTitle": "Edit payment method",
    "drawerDetailTitle": "Payment method detail",
    "loadError": "Could not load payment methods.",
    "saveSuccess": "Payment method saved.",
    "deleteSuccess": "Payment method removed.",
    "deleteConfirmTitle": "Remove this payment method?",
    "deleteConfirmDescription": "This removes the payment method permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This payment method is in use and cannot be deleted.",
    "nameTaken": "A payment method with this name already exists.",
    "actionsMenu": "Actions",
    "emptyTitle": "No payment methods",
    "emptyDescription": "Register the payment methods used on bills.",
    "emptyFilteredTitle": "No payment methods found",
    "emptyFilteredDescription": "No payment methods match the selected filters.",
    "searchPlaceholder": "Search payment methods…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This payment method no longer exists or you cannot access it."
  },
  "finance": {
    "title": "Finance",
    "tabs": {
      "payables": "Payables",
      "receivables": "Receivables",
      "invoices": "Tax invoices",
      "cashFlow": "Cash flow"
    },
    "status": {
      "open": "Open",
      "paid": "Settled",
      "cancelled": "Cancelled",
      "overdue": "Overdue"
    }
  },
  "payables": {
    "new": "New payable",
    "edit": "Edit",
    "delete": "Delete",
    "settle": "Mark as paid",
    "save": "Save",
    "drawerDetailTitle": "Payable detail",
    "colCode": "Code",
    "codeLabel": "Code",
    "colDescription": "Description",
    "colProject": "Project",
    "colPartner": "Supplier",
    "colAmount": "Amount",
    "colDueDate": "Due date",
    "colStatus": "Status",
    "projectLabel": "Project",
    "partnerLabel": "Supplier",
    "budgetItemLabel": "Cost plan line",
    "budgetItemEmpty": "No cost plan lines yet.",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "paymentMethodLabel": "Payment method",
    "descriptionLabel": "Description",
    "amountLabel": "Amount",
    "dueDateLabel": "Due date",
    "statusLabel": "Status",
    "paidAtLabel": "Paid on",
    "documentNumberLabel": "Document number",
    "notesLabel": "Notes",
    "formCreateTitle": "New payable",
    "formEditTitle": "Edit payable",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Bill details",
    "formSections": {
      "identification": "Identification",
      "values": "Values"
    },
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "loadError": "Could not load payables.",
    "saveError": "Could not save the payable.",
    "deleteError": "Could not delete the payable.",
    "saveSuccess": "Payable saved.",
    "deleteSuccess": "Payable removed.",
    "deleteConfirmTitle": "Remove this payable?",
    "deleteConfirmDescription": "This removes the payable permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "settleConfirmTitle": "Mark this payable as paid?",
    "settleConfirmDescription": "{{description}} — {{amount}}. Enter the payment date.",
    "settleConfirmAction": "Mark as paid",
    "settleSuccess": "Payable marked as paid.",
    "actionsMenu": "Actions",
    "emptyTitle": "No payables",
    "emptyDescription": "Record project payables, with or without a cost plan line.",
    "emptyFilteredTitle": "No payables found",
    "emptyFilteredDescription": "No payables match your filters.",
    "searchPlaceholder": "Search payables…",
    "clearSearch": "Clear search",
    "filterStatus": "Status",
    "filterStatusSearch": "Search status",
    "filterStatusEmpty": "No statuses found.",
    "filterOverdue": "Overdue",
    "filterOverdueSearch": "Search",
    "filterOverdueEmpty": "No options.",
    "filterDueDate": "Due date",
    "filterDueDateFrom": "From",
    "filterDueDateTo": "To",
    "filterSettledAt": "Paid on",
    "filterSettledAtFrom": "From",
    "filterSettledAtTo": "To",
    "filterCashFlowGroup": "Cash flow group",
    "filterCashFlowGroupSearch": "Search group",
    "filterCashFlowGroupEmpty": "No groups found.",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This payable no longer exists or you cannot access it."
  },
  "receivables": {
    "new": "New receivable",
    "edit": "Edit",
    "delete": "Delete",
    "settle": "Mark as received",
    "save": "Save",
    "drawerDetailTitle": "Receivable detail",
    "colCode": "Code",
    "codeLabel": "Code",
    "colDescription": "Description",
    "colProject": "Project",
    "colClient": "Client",
    "colAmount": "Amount",
    "colDueDate": "Due date",
    "colStatus": "Status",
    "colCharge": "Charge",
    "colNfse": "Invoice",
    "badgeChargeGenerated": "Created",
    "badgeNfseGenerated": "Issued",
    "projectLabel": "Project",
    "clientLabel": "Client",
    "categoryLabel": "Category",
    "paymentMethodLabel": "Payment method",
    "descriptionLabel": "Description",
    "amountLabel": "Amount",
    "dueDateLabel": "Due date",
    "statusLabel": "Status",
    "receivedAtLabel": "Received on",
    "documentNumberLabel": "Document number",
    "notesLabel": "Notes",
    "formCreateTitle": "New receivable",
    "formEditTitle": "Edit receivable",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Bill details",
    "formSections": {
      "identification": "Identification",
      "values": "Values"
    },
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "loadError": "Could not load receivables.",
    "saveError": "Could not save the receivable.",
    "deleteError": "Could not delete the receivable.",
    "saveSuccess": "Receivable saved.",
    "deleteSuccess": "Receivable removed.",
    "deleteConfirmTitle": "Remove this receivable?",
    "deleteConfirmDescription": "This removes the receivable permanently. This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "settleConfirmTitle": "Mark this receivable as received?",
    "settleConfirmDescription": "{{description}} — {{amount}}. Enter the receipt date.",
    "settleConfirmAction": "Mark as received",
    "settleSuccess": "Receivable marked as received.",
    "actionsMenu": "Actions",
    "emptyTitle": "No receivables",
    "emptyDescription": "Record receivables linked to the project client.",
    "emptyFilteredTitle": "No receivables found",
    "emptyFilteredDescription": "No receivables match your filters.",
    "searchPlaceholder": "Search receivables…",
    "clearSearch": "Clear search",
    "filterStatus": "Status",
    "filterStatusSearch": "Search status",
    "filterStatusEmpty": "No statuses found.",
    "filterOverdue": "Overdue",
    "filterOverdueSearch": "Search",
    "filterOverdueEmpty": "No options.",
    "filterDueDate": "Due date",
    "filterDueDateFrom": "From",
    "filterDueDateTo": "To",
    "filterSettledAt": "Received on",
    "filterSettledAtFrom": "From",
    "filterSettledAtTo": "To",
    "filterCashFlowGroup": "Cash flow group",
    "filterCashFlowGroupSearch": "Search group",
    "filterCashFlowGroupEmpty": "No groups found.",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "notFound": "This receivable no longer exists or you cannot access it.",
    "generateCharge": "Generate charge",
    "viewCharge": "View charge",
    "chargeCreateSuccess": "Charge created.",
    "chargeCreateError": "Could not create the charge.",
    "chargeNeedsOnboard": "Activate charges in company Settings before generating PIX or boleto.",
    "chargeNeedsBankAccount": "Register the bank account under Organization before generating boleto or PIX.",
    "chargeChooseTitle": "How do you want to charge?",
    "chargeChooseDescription": "The client pays with PIX or boleto, processed by Asaas. Funds go to your company account.",
    "chargeChooseDescriptionPagarme": "The client pays with PIX or boleto through Pagar.me. The Pagar.me fee is deducted from the amount paid. The net amount goes to your company account. KonstruLog does not keep a commission.",
    "chargePix": "PIX",
    "chargeBoleto": "Boleto",
    "chargeDrawerTitle": "Charge",
    "chargeProjectLine": "{{project}}",
    "chargeTypeLabel": "Type",
    "chargePixSection": "PIX",
    "chargePixQrAlt": "PIX QR code",
    "chargeCopyPix": "Copy PIX code",
    "chargePixCopied": "PIX code copied.",
    "chargeBoletoSection": "Boleto",
    "chargeOpenBoleto": "Open boleto",
    "chargeCopyLine": "Copy barcode line",
    "chargeLineCopied": "Barcode line copied.",
    "chargeSend": "Send charge",
    "chargeShareTitle": "Charge",
    "chargeShareCopied": "Charge details copied.",
    "chargeCopyFailed": "Could not copy."
  },
  "cashFlow": {
    "fromLabel": "From",
    "toLabel": "To",
    "apply": "Apply",
    "loadError": "Could not load cash flow.",
    "colGroup": "Group",
    "colPlanned": "Planned",
    "colRealized": "Realized",
    "totalsOut": "Outflows",
    "totalsIn": "Inflows",
    "groups": {
      "suppliers": "Suppliers",
      "labor": "Labor",
      "taxes": "Taxes",
      "services": "Services",
      "other": "Other",
      "receipts": "Receipts",
      "other_receipts": "Other receipts"
    }
  },
  "projectCosts": {
    "title": "Project costs",
    "recordAdvance": "Service measurement",
    "loadError": "Could not load project costs.",
    "overBudgetAlert": "Paid amount already exceeds this project's current cost plan.",
    "budgetedCost": "Planned",
    "measuredCost": "Measured",
    "paidPayables": "Paid",
    "openPayables": "Open payables",
    "overduePayables": "Overdue payables",
    "plannedRevenue": "Planned revenue",
    "receivedReceivables": "Received",
    "openReceivables": "Open receivables",
    "overdueReceivables": "Overdue receivables",
    "budgetActualTitle": "Planned vs actual",
    "measuredHint": "Measured is work executed. Paid and payables change only after you create a bill.",
    "budgetActualEmpty": "There is no approved cost plan with lines to compare.",
    "colItem": "Item",
    "colPlanned": "Planned",
    "colPaid": "Paid",
    "openPayablesLink": "Open payables",
    "openPayablesLinkAria": "Open payables for {{name}}",
    "colRemaining": "Remaining",
    "colMeasured": "Measured",
    "colQty": "Physical progress",
    "qtyProgress": "{{advanced}} / {{planned}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "expandFrontAria": "Show items of {{name}}",
    "collapseFrontAria": "Hide items of {{name}}",
    "advanceTitle": "Record service measurement",
    "advanceDescription": "Enter how much of this line was executed. The quantity adds to physical progress and measured value. Paid and Remaining change only if you create a payable.",
    "recordAdvanceRowAria": "Record measurement for {{name}}",
    "advanceQuantityHint": "Already measured: {{advanced}} / {{planned}}{{unit}}",
    "advanceQuantityHintNoPlan": "Already measured: {{advanced}}{{unit}}",
    "advanceItemLabel": "Cost plan line",
    "advanceDateLabel": "Date",
    "advanceQuantityLabel": "Quantity executed",
    "advanceNotesLabel": "Notes",
    "advanceSave": "Save measurement",
    "advanceSaveSuccess": "Service measurement recorded.",
    "advanceSaveError": "Could not record the service measurement.",
    "advanceValuePreview": "This is worth {{value}} (quantity × unit price).",
    "advanceCreatePayable": "Create payable",
    "advanceCreatePayableRowAria": "Create payable for {{name}}",
    "advancePayableDescription": "Measurement — {{name}} · {{quantity}}{{unit}}"
  },
  "projectOccurrences": {
    "dateFromLabel": "From date",
    "dateToLabel": "To date",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "typeLabel": "Type",
    "typeAll": "All types",
    "clearFilters": "Clear filters",
    "filter": {
      "date": "Date",
      "type": "Type",
      "typeSearch": "Search…",
      "typeEmpty": "No types found.",
      "workers": "Workers",
      "workersSearch": "Search workers…",
      "workersEmpty": "No workers found.",
      "projectServiceFronts": "Service fronts",
      "projectServiceFrontsSearch": "Search service fronts…",
      "projectServiceFrontsEmpty": "No service fronts found.",
      "creators": "Registered by",
      "creatorsSearch": "Search people…",
      "creatorsEmpty": "No people found.",
      "apply": "Show results",
      "reset": "Clear",
      "close": "Close filter"
    },
    "colDate": "Date",
    "colType": "Type",
    "colDescription": "Description",
    "colWorkers": "Workers",
    "colCreatedBy": "Registered by",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load occurrences.",
    "emptyTitle": "No occurrences logged",
    "emptyDescription": "Occurrences recorded in diary entries will appear here.",
    "noFilterResults": "No occurrences match the selected filters.",
    "drawerTitle": "Occurrence detail",
    "noDescription": "No description",
    "noWorkers": "No workers",
    "unknownCreator": "Unknown user",
    "formSections": {
      "identification": "Identification"
    },
    "photosSection": "Photos",
    "openProjectDiaryEntry": "View diary entry",
    "loadMoreError": "Could not load more occurrences.",
    "loadMoreRetry": "Try again"
  },
  "projectMaterials": {
    "dateFromLabel": "Start date",
    "dateToLabel": "End date",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "clearFilters": "Clear filters",
    "searchPlaceholder": "Search by name or code…",
    "clearSearch": "Clear search",
    "formSections": {
      "identification": "Identification"
    },
    "filter": {
      "date": "Date",
      "material": "Material",
      "materialSearch": "Search materials…",
      "materialEmpty": "No materials found.",
      "creators": "Recorded by",
      "creatorsSearch": "Search people…",
      "creatorsEmpty": "No people found.",
      "apply": "Show results",
      "reset": "Clear",
      "close": "Close filter"
    },
    "colDate": "Date",
    "colCode": "Code",
    "colMaterial": "Material",
    "colQuantity": "Quantity",
    "colCreatedBy": "Recorded by",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load materials.",
    "emptyTitle": "No materials recorded",
    "emptyDescription": "Materials used in diary entries will appear here.",
    "noFilterResults": "No materials match the selected filters.",
    "drawerTitle": "Material detail",
    "unknownCreator": "Unknown user",
    "openProjectDiaryEntry": "Open diary entry",
    "loadMoreError": "Could not load more materials.",
    "loadMoreRetry": "Try again",
    "tabs": {
      "usage": "Usage history",
      "catalog": "Project catalog",
      "movements": "Stock movements"
    }
  },
  "projectMaterialMovements": {
    "colDate": "Date",
    "colCode": "Code",
    "colMaterial": "Material",
    "colQuantity": "Quantity",
    "colSource": "Type",
    "colOrigin": "Description",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load stock movements.",
    "emptyTitle": "No stock movements",
    "emptyDescription": "Transfers and diary consumption will appear here.",
    "emptyFilteredTitle": "No movements match your filters",
    "emptyFilteredDescription": "Try adjusting the date range or filters.",
    "loadMoreError": "Could not load more movements.",
    "loadMoreRetry": "Try again",
    "drawerTitle": "Material movements",
    "movementDetailTitle": "Movement detail",
    "formSections": {
      "identification": "Identification"
    },
    "recentSection": "Recent movements",
    "searchPlaceholder": "Search by name or code",
    "clearSearch": "Clear search",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "filter": {
      "date": "Date",
      "material": "Material",
      "materialSearch": "Search materials",
      "materialEmpty": "No materials found",
      "type": "Type",
      "typeSearch": "Search types",
      "typeEmpty": "No types found"
    },
    "source": {
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out",
      "consumption": "Consumption",
      "reversal": "Reversal",
      "consumption_delta": "Quantity adjustment",
      "purchase": "Purchase"
    }
  },
  "projectMaterialSelection": {
    "colCode": "Code",
    "colName": "Name",
    "colCategory": "Category",
    "colUnit": "Unit",
    "colStatus": "Status",
    "colQuantity": "Current stock",
    "colOrgStock": "Org stock",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load project materials.",
    "saveError": "Could not save project materials.",
    "deleteError": "Could not remove material from project.",
    "emptyTitle": "No materials selected",
    "emptyDescription": "Add materials from your organization catalog and allocate quantities for this project.",
    "searchPlaceholder": "Search by name or code…",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "noSearchResults": "No materials match your search.",
    "noFilterResults": "No materials match the selected filters.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "filterCategory": "Category",
    "filterCategorySearch": "Search categories…",
    "filterCategoryEmpty": "No categories found.",
    "filterUnit": "Unit",
    "filterUnitSearch": "Search units…",
    "filterUnitEmpty": "No units found.",
    "addMaterialsAction": "Add materials",
    "addLabel": "Material",
    "addPlaceholder": "Search catalog materials…",
    "addLineTitle": "Add material line",
    "addLineAction": "Add line",
    "addItemSave": "Add",
    "edit": "Edit",
    "editItem": "Edit line",
    "addBatchSuccess": "Materials added to project.",
    "alreadySelected": "This material is already on the project.",
    "codeNotFound": "This code is not in the project stock.",
    "materialRequired": "Select a material.",
    "quantityLabel": "Quantity",
    "quantityRequired": "Enter a quantity.",
    "quantityExceedsStock": "Quantity cannot exceed organization stock.",
    "quantityMaxHint": "Maximum available: {{max}} {{unit}}",
    "quantityNoStock": "No stock available for this material.",
    "orgStockHint": "Organization stock: {{stock}} {{unit}}",
    "orgStockLabel": "Org stock",
    "orgStockInsufficient": "Not enough organization stock for this quantity.",
    "projectQuantityInsufficient": "Not enough quantity on the project.",
    "remove": "Delete",
    "actionsMenu": "Actions",
    "actionsQuantitySection": "Stock",
    "viewMovements": "View movements",
    "quantityAdd": "Add",
    "quantityRemove": "Remove",
    "quantityAdjustAddTitle": "Add quantity to project",
    "quantityAdjustRemoveTitle": "Remove quantity from project",
    "quantityAdjustLabel": "Quantity",
    "quantityAdjustConfirmAdd": "Add",
    "quantityAdjustConfirmRemove": "Remove",
    "quantityAdjustSuccess": "Project quantity updated.",
    "deleteSuccess": "Material removed from project.",
    "deleteConfirmTitle": "Remove material from project?",
    "deleteConfirmDescription": "Remaining quantity will return to organization stock. Existing diary records are kept.",
    "deleteConfirmAction": "Remove",
    "cancel": "Cancel",
    "diaryEmptyHint": "No materials with available quantity on this project. Add materials in the Project catalog tab first.",
    "formTitle": "Add materials to project",
    "formStepDetails": "Materials",
    "formStepReview": "Review and submit",
    "formReviewTitle": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "formSave": "Save",
    "formDraftSection": "Materials to add",
    "formDraftEmpty": "Add one or more material lines.",
    "formItemsRequired": "Add at least one material line.",
    "draftQuantity": "Quantity: {{quantity}} {{unit}}",
    "removeDraftLine": "Remove line"
  },
  "projectDiaryEntries": {
    "new": "New entry",
    "viewDetails": "View details",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "formSections": {
      "identification": "Identification"
    },
    "colCode": "Code",
    "codeLabel": "Code",
    "colDate": "Date and time",
    "colWeather": "Weather",
    "colWorkability": "Workability",
    "colStatus": "Status",
    "colProjectServiceFronts": "Service fronts",
    "colOccurrences": "Occurrences",
    "colMaterials": "Materials",
    "colPhotos": "Photos",
    "colCreatedBy": "Registered by",
    "colNotes": "Notes",
    "listOccurrencesNone": "No occurrences",
    "listOccurrencesOne": "1 occurrence",
    "listOccurrencesMany": "{{count}} occurrences",
    "projectServiceFrontsOverflowAria": "{{count}} more service fronts",
    "entryDateLabel": "Date and time",
    "entryTimeLabel": "Time",
    "workabilityLabel": "Workability",
    "workabilityPracticable": "Workable",
    "workabilityImpracticable": "Not workable",
    "weatherLabel": "Weather",
    "weatherPlaceholder": "Select weather condition",
    "notesLabel": "Notes",
    "statusLabel": "Status",
    "statusDraft": "Draft",
    "statusPublished": "Published",
    "continueDraft": "Continue draft",
    "discardDraft": "Discard draft",
    "discardDraftConfirmTitle": "Discard this draft?",
    "discardDraftConfirmDescription": "This draft will be permanently removed. It was never published.",
    "discardDraftConfirmAction": "Discard",
    "keepDraftConfirmTitle": "Keep this draft?",
    "keepDraftConfirmDescription": "You can continue it later from the diary list. If you don’t keep it, this draft will be removed.",
    "keepDraftConfirmAction": "Keep",
    "discardDraftSuccess": "Draft discarded.",
    "discardDraftLeaving": "Discarding draft…",
    "publish": "Publish",
    "publishSuccess": "Diary entry published.",
    "publishReviewHint": "This entry is still a draft. Publish to finalize and apply stock movements.",
    "draftPending": "Unsaved changes…",
    "draftSaving": "Saving…",
    "draftSaved": "All changes saved",
    "draftSaveFailed": "Could not save draft. Your changes are kept locally until the next save.",
    "draftSaveFailedShort": "Couldn’t save — will retry",
    "draftPhotoUploading": "Uploading photo…",
    "draftPhotoUploadingCount": "Uploading photo {{current}} of {{total}}…",
    "draftPhotoDeleting": "Deleting photo…",
    "draftPhotoDeleteFailed": "Could not delete the photo.",
    "draftPhotoFailedShort": "Photo upload failed",
    "draftLeavingSaving": "Saving changes…",
    "draftLeavingUploadingPhotos": "Uploading photo…",
    "draftPhotoUploadFailed": "Could not upload all photos. Fix or remove failures before continuing.",
    "draftsBanner": "You have {{count}} unfinished draft(s).",
    "showDraftsBannerAria": "Show unfinished drafts alert ({{count}})",
    "viewDrafts": "View drafts",
    "dismissDraftsBanner": "Dismiss",
    "formDraftTitle": "Draft diary entry",
    "weatherSunny": "Sunny",
    "weatherPartlyCloudy": "Partly cloudy",
    "weatherCloudy": "Cloudy",
    "weatherRainy": "Rainy",
    "weatherStorm": "Storm",
    "generalSection": "General",
    "addShort": "Add",
    "drawerNewProjectServiceFront": "New service front",
    "drawerEditProjectServiceFront": "Edit service front",
    "drawerNewOccurrence": "New occurrence",
    "drawerEditOccurrence": "Edit occurrence",
    "lineNoDescription": "No description yet.",
    "lineUntitled": "Untitled",
    "projectServiceFrontsSection": "Service fronts",
    "projectServiceFrontSection": "Service front",
    "occurrencesSection": "Occurrences",
    "materialsSection": "Materials",
    "photosSection": "Photos",
    "addProjectServiceFront": "Add service front",
    "addOccurrence": "Add occurrence",
    "createProjectServiceFrontLink": "Create new service front",
    "createOccurrenceLink": "Create new occurrence",
    "catalogCreateProjectServiceFrontTitle": "New service front",
    "catalogCreateOccurrenceTitle": "New occurrence",
    "addPhoto": "Add photo",
    "choosePhoto": "Choose photo",
    "takePhoto": "Take photo",
    "photoCameraCapture": "Capture",
    "photoCameraLoading": "Starting camera…",
    "photoCameraUnavailable": "Could not access the camera. Check browser permissions and try again.",
    "photoCameraCaptureFailed": "Could not capture the photo. Try again.",
    "photosCount_one": "{{count}} photo",
    "photosCount_other": "{{count}} photos",
    "photoMaxReached": "Couldn't add more photos to this line.",
    "projectServiceFrontLabel": "Service front",
    "projectServiceFrontPlaceholder": "Select a service front…",
    "occurrenceLabel": "Occurrence",
    "occurrencePlaceholder": "Select an occurrence…",
    "lineDescriptionLabel": "Description",
    "lineDescriptionPlaceholder": "What happened on this front…",
    "workersLabel": "Team",
    "workersPlaceholder": "Select collaborators…",
    "noWorkers": "No team assigned.",
    "occurrenceDescriptionPlaceholder": "Details about this occurrence…",
    "duplicateProjectServiceFront": "Each service front can only be selected once.",
    "duplicateOccurrence": "Each occurrence can only be selected once.",
    "formCreateTitle": "New diary entry",
    "formEditTitle": "Edit diary entry",
    "formReviewTitle": "Review and submit",
    "stepGeneral": "General",
    "stepProjectServiceFronts": "Service fronts",
    "stepOccurrences": "Occurrences",
    "stepMaterials": "Materials",
    "stepDetails": "Entry details",
    "stepServiceFronts": "Service fronts",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewAddedLine": "Added",
    "reviewRemovedLine": "Removed",
    "reviewEditedLine": "Updated",
    "reviewSectionNoChanges": "No changes in this section.",
    "reviewPreviousLine": "Previous: {{value}}",
    "backToList": "Back to diary",
    "notFound": "This diary entry no longer exists or you cannot access it.",
    "pastEntryReadonly": "Past diary entries cannot be edited or deleted.",
    "drawerDetailTitle": "Diary entry detail",
    "drawerNoNotes": "No notes.",
    "loadError": "Could not load diary entries.",
    "saveSuccess": "Diary entry saved.",
    "photosUploadFailed": "The entry was saved, but some photos could not be uploaded.",
    "deleteSuccess": "Diary entry removed.",
    "deleteConfirmTitle": "Remove this diary entry?",
    "deleteConfirmDescription": "This cannot be undone. Photos attached to this entry will also be removed.",
    "deleteConfirmAction": "Remove",
    "actionsMenu": "Actions",
    "emptyTitle": "No diary entries",
    "emptyDescription": "Create the first entry to record daily progress on this obra.",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "filter": {
      "date": "Date",
      "status": "Status",
      "statusSearch": "Search status…",
      "statusEmpty": "No status found.",
      "weather": "Weather",
      "weatherSearch": "Search weather…",
      "weatherEmpty": "No weather found.",
      "projectServiceFronts": "Service fronts",
      "projectServiceFrontsSearch": "Search service fronts…",
      "projectServiceFrontsEmpty": "No service fronts found.",
      "creators": "Registered by",
      "creatorsSearch": "Search people…",
      "creatorsEmpty": "No people found.",
      "apply": "Show results",
      "reset": "Clear",
      "close": "Close filter"
    },
    "clearDates": "Clear dates",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noFilterResults": "No entries match the selected filters.",
    "viewModeAria": "Diary view",
    "viewModeGridAria": "Grid view",
    "viewModeTimelineAria": "Timeline view",
    "timelineToday": "Today",
    "timelineYesterday": "Yesterday",
    "timelinePhotoOverflow": "+{{count}}",
    "timelineOpenPhotoAria": "Open photo {{index}}",
    "timelineFrontPhotosTitle": "Front photos",
    "timelineOccurrencePhotosTitle": "Occurrence photos",
    "loadMoreError": "Could not load more entries.",
    "loadMoreRetry": "Try again",
    "photoCaptionLabel": "Caption",
    "photoCaptionPlaceholder": "Optional caption…",
    "createModeTitle": "How do you want to start?",
    "createModePhoto": "Photo mode",
    "createModePhotoDescription": "Take the site photos first, add a caption to each one, then fill in the rest.",
    "createModeNormal": "Form mode",
    "createModeNormalDescription": "Go straight to the form and fill in the entry details.",
    "photoModeTitle": "Site photos",
    "photoModeAdd": "Add photos",
    "photoModeCaptionPlaceholder": "What does this photo show?",
    "photoModeEmpty": "No photos yet. Take or choose photos to start the entry.",
    "photoModeOk": "Continue",
    "createPreparing": "Opening entry…",
    "photoInvalidType": "Use JPEG, PNG, or WebP images.",
    "photoTooLarge": "Each photo must be 10 MB or smaller.",
    "removePhoto": "Remove photo",
    "photoDeleteConfirmTitle": "Remove this photo?",
    "photoDeleteConfirmDescription": "This cannot be undone.",
    "photoDeleteConfirmAction": "Remove",
    "photoMarkupTitle": "Mark up photo",
    "photoMarkupSaveFailed": "Could not save the marked photo. Try again.",
    "photoMarkupPen": "Pen",
    "photoMarkupArrow": "Arrow",
    "photoMarkupRect": "Box",
    "photoMarkupCircle": "Circle",
    "photoMarkupText": "Text",
    "photoMarkupSelect": "Select",
    "photoMarkupDelete": "Delete mark",
    "photoMarkupSelectHint": "Click a mark to select it, then drag to move or resize.",
    "photoMarkupTextHint": "Click to place text, type, then press Enter. Click elsewhere to move.",
    "photoMarkupTextPlaceholder": "Type here…",
    "photoMarkupColor": "Color",
    "photoMarkupStroke": "Stroke size",
    "photoMarkupStrokeThin": "Thin stroke",
    "photoMarkupStrokeMedium": "Medium stroke",
    "photoMarkupStrokeThick": "Thick stroke",
    "photoMarkupUndo": "Undo",
    "noPhotos": "No photos yet.",
    "noProjectServiceFronts": "No service fronts on this entry.",
    "noOccurrences": "No occurrences on this entry.",
    "noMaterials": "No materials on this entry.",
    "materialsCount_one": "{{count}} material",
    "materialsCount_other": "{{count}} materials",
    "materialLabel": "Material",
    "materialRequired": "Select a material.",
    "materialQuantityLabel": "Quantity",
    "materialQuantityRequired": "Enter the quantity used.",
    "materialStockHint": "Available stock: {{stock}} {{unit}}",
    "projectMaterialQuantityHint": "Available on project: {{quantity}} {{unit}}",
    "materialQuantityExceedsProject": "Quantity cannot exceed available project amount.",
    "addMaterialLine": "Add material",
    "lineDetailsSection": "Details",
    "lineDone": "Done",
    "copyLine": "Copy",
    "lineExpand": "Expand details",
    "lineCollapse": "Collapse details",
    "emptyProjectServiceFrontsHint": "No service fronts added yet — you can continue.",
    "emptyOccurrencesHint": "No occurrences added yet — you can continue.",
    "emptyMaterialsHint": "No materials added yet — you can continue.",
    "deleteLineConfirmTitle": "Remove this item?",
    "deleteLineConfirmDescription": "It will be removed from this entry.",
    "editMaterialLine": "Edit material",
    "duplicateMaterial": "Each material can only be selected once.",
    "dateTaken": "An entry already exists for this date.",
    "createdAt": "Created",
    "createdByLabel": "Registered by",
    "unknownCreator": "Unknown user",
    "colEquipments": "Equipments",
    "equipmentsSection": "Equipments",
    "stepEquipments": "Equipments",
    "noEquipments": "No equipments on this entry.",
    "equipmentsCount_one": "{{count}} equipment",
    "equipmentsCount_other": "{{count}} equipments",
    "equipmentLabel": "Equipment",
    "equipmentRequired": "Select an equipment.",
    "equipmentQuantityLabel": "Quantity",
    "equipmentQuantityRequired": "Enter the quantity used.",
    "projectEquipmentQuantityHint": "Available on project: {{quantity}}",
    "projectEquipmentIndividualHint": "Individual equipment is recorded as one unit.",
    "equipmentQuantityExceedsProject": "Quantity cannot exceed available project amount.",
    "addEquipmentLine": "Add equipment",
    "emptyEquipmentsHint": "No equipments added yet — you can continue.",
    "editEquipmentLine": "Edit equipment",
    "duplicateEquipment": "Each equipment can only be selected once.",
    "checklistsSection": "Checklists",
    "colChecklists": "Checklists",
    "checklistsCount_one": "{{count}} checklist",
    "checklistsCount_other": "{{count}} checklists",
    "checklistsLoadError": "Could not load project checklists.",
    "editChecklist": "Edit checklist",
    "editChecklistNamed": "Edit checklist — {{name}}",
    "checklistItemNotes": "Notes",
    "checklistItemNotesPlaceholder": "Optional notes…",
    "checklistItemChecked": "Checked",
    "checklistItemUnchecked": "Not checked",
    "checklistReviewCheckedCount": "{{checked}}/{{total}} checked",
    "checklistReviewNotesCount": "{{count}} with notes"
  },
  "projects": {
    "new": "New project",
    "edit": "Edit",
    "inactivate": "Inactivate",
    "reactivate": "Reactivate",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colCode": "Code",
    "colTitle": "Title",
    "colDescription": "Description",
    "colClient": "Client",
    "colAddress": "Address",
    "colStartDate": "Start",
    "colType": "Type",
    "colPriority": "Priority",
    "colResponsible": "Responsible",
    "colProgress": "Progress",
    "colStatus": "Status",
    "colDueDate": "Expected end",
    "titleLabel": "Title",
    "codeLabel": "Code",
    "descriptionLabel": "Description",
    "clientLabel": "Client",
    "clientPlaceholder": "Select a client…",
    "clientBudgetLabel": "Client quote",
    "clientBudgetPlaceholder": "Quote number",
    "clientBudgetEmpty": "No approved quotes without a job",
    "clientBudgetCodeNotFound": "No quote found with this number.",
    "budgetScopeLabel": "Quote",
    "budgetScopeWithout": "Without quote",
    "budgetScopeWith": "With quote",
    "formSections": {
      "budget": "Quote",
      "identification": "Identification",
      "responsibilities": "Responsibilities",
      "configuration": "Configuration",
      "serviceFronts": "Service fronts",
      "schedule": "Schedule",
      "planning": "Planning",
      "details": "Details"
    },
    "clientSelected": "Assigned client",
    "plannedRevenueLabel": "Planned revenue",
    "plannedRevenueFromClientBudget": "Set by the approved client budget.",
    "plannedRevenueOpenClientBudget": "Open client budget",
    "addressLabel": "Address",
    "startDateLabel": "Start date",
    "typeLabel": "Type",
    "typePlaceholder": "Select a type…",
    "priorityLabel": "Priority",
    "statusLabel": "Status",
    "responsibleLabel": "Responsible person",
    "dueDateLabel": "Expected end",
    "dueDateBeforeStartDate": "Expected end cannot be before the start date.",
    "responsiblePlaceholder": "Select a collaborator…",
    "responsibleNone": "None",
    "responsibleSelected": "Assigned collaborator",
    "noDescription": "No description",
    "formCreateTitle": "New project",
    "formEditTitle": "Edit project",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Project details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "backToList": "Back to projects",
    "loadingTitle": "Loading project…",
    "notFound": "This project no longer exists or you cannot access it.",
    "overviewSections": {
      "identification": "Identification",
      "statusAndPriority": "Status and priority",
      "execution": "Execution",
      "address": "Address",
      "details": "Details",
      "fiscal": "Project tax details"
    },
    "startDateShortLabel": "Start",
    "dueDateShortLabel": "Expected end",
    "loadError": "Could not load projects.",
    "createSuccess": "Project created.",
    "saveSuccess": "Project saved.",
    "deleteSuccess": "Project removed.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "inactivateSuccess": "Project inactivated.",
    "reactivateSuccess": "Project reactivated.",
    "inactivateConfirmTitle": "Inactivate this project?",
    "inactivateConfirmDescription": "The project stays visible for consult, but nobody can edit it until it is reactivated. It also stops counting toward the plan quota.",
    "inactivateConfirmAction": "Inactivate",
    "reactivateConfirmTitle": "Reactivate this project?",
    "reactivateConfirmDescription": "The project becomes editable again and counts toward the active-project quota if its status is still active.",
    "reactivateConfirmAction": "Reactivate",
    "inactiveReadonly": "This project is inactivated. You can consult it, but not edit anything.",
    "deleteConfirmTitle": "Remove this project?",
    "deleteConfirmDescription": "This cannot be undone. Related diary entries and reports may block deletion.",
    "deleteConfirmAction": "Remove",
    "deleteInUse": "This project cannot be deleted while it is in use.",
    "invalidResponsibleWorker": "The selected collaborator is invalid.",
    "invalidServiceFrontModel": "The selected service front model is invalid.",
    "serviceFrontModelLabel": "Service front model",
    "serviceFrontModelPlaceholder": "Select a model…",
    "serviceFrontModelRequired": "Select a service front model.",
    "serviceFrontModelNameLabel": "Model name",
    "serviceFrontModelNameRequired": "Enter a model name.",
    "serviceFrontsSourceLabel": "Service fronts",
    "serviceFrontsSourceDescription": "Choose how to create service fronts for this project.",
    "serviceFrontsSourceModel": "Use a service front model",
    "serviceFrontsSourceModelDescription": "Copy steps from an existing reusable model.",
    "serviceFrontsSourceMsProject": "Import from MS Project (XML)",
    "serviceFrontsSourceMsProjectDescription": "Create one service front for each dated task in the schedule.",
    "serviceFrontsSourceEmpty": "Create empty project",
    "serviceFrontsSourceEmptyDescription": "Create the project without service fronts for now.",
    "msProjectFileLabel": "MS Project XML file",
    "msProjectFileDescription": "Export your schedule from Microsoft Project as XML.",
    "msProjectFileRequired": "Select an MS Project XML file.",
    "msProjectTasksRequired": "Confirm the service fronts to import.",
    "msProjectPreviewLabel": "Import preview",
    "msProjectPreviewLoading": "Reading schedule…",
    "msProjectPreviewCount_one": "{{count}} service front will be created",
    "msProjectPreviewCount_other": "{{count}} service fronts will be created",
    "msProjectReviewTitle": "Review MS Project import",
    "msProjectReviewDescription": "Select the tasks to import and adjust names or dates if needed.",
    "msProjectReviewImportColumn": "Import",
    "msProjectReviewNameColumn": "Service front name",
    "msProjectReviewStartColumn": "Start",
    "msProjectReviewFinishColumn": "End",
    "msProjectReviewConfirm": "Confirm import",
    "msProjectReviewSelectOne": "Select at least one service front to import.",
    "msProjectReviewNameRequired": "Name is required.",
    "msProjectReviewStartRequired": "Start date is required.",
    "msProjectReviewFinishRequired": "End date is required.",
    "msProjectReviewDatesRequired": "Start and end dates are required.",
    "msProjectReviewFinishBeforeStart": "End date cannot be before the start date.",
    "msProjectReviewDuplicateName": "Service front names must be unique.",
    "msProjectReviewEdit": "Review and edit",
    "saveAsServiceFrontModelLabel": "Also save as a service front model",
    "saveAsServiceFrontModelDescription": "Reuse these fronts when creating future projects.",
    "msProjectModelNameDefault": "{{title}} - Service fronts",
    "projectServiceFront": {
      "description": "Set the color and team for each step of this project's service front.",
      "colorLabel": "Step color",
      "workersPlaceholder": "Select collaborators…",
      "saveSuccess": "Step updated.",
      "empty": "No steps found for this project.",
      "workerCount_one": "{{count}} collaborator",
      "workerCount_other": "{{count}} collaborators"
    },
    "forbidden": "You don’t have permission to change projects.",
    "actionsMenu": "Actions",
    "emptyTitle": "No projects",
    "emptyDescription": "Create one to get started.",
    "searchPlaceholder": "Search by code, title, or description…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No projects match your search.",
    "noFilterResults": "No projects match the selected filters.",
    "clearFilters": "Clear filters",
    "filter": {
      "progress": "Progress",
      "progressRangeInvalid": "From must be less than or equal to To.",
      "status": "Status",
      "statusSearch": "Search statuses…",
      "statusEmpty": "No statuses found.",
      "priority": "Priority",
      "prioritySearch": "Search priorities…",
      "priorityEmpty": "No priorities found.",
      "startDate": "Start",
      "dueDate": "Expected end",
      "dateFromLabel": "From",
      "dateToLabel": "To",
      "responsible": "Responsible",
      "responsibleSearch": "Search people…",
      "responsibleEmpty": "No people found.",
      "client": "Client",
      "clientSearch": "Search clients…",
      "clientEmpty": "No clients found."
    },
    "loadMoreError": "Could not load more projects.",
    "loadMoreRetry": "Try again",
    "type": {
      "residencial": "Residential",
      "comercial": "Commercial",
      "industrial": "Industrial",
      "infraestrutura": "Infrastructure",
      "reforma": "Renovation",
      "outro": "Other"
    },
    "priority": {
      "normal": "Normal",
      "high": "High",
      "critical": "Critical"
    },
    "status": {
      "planned": "Planned",
      "in_progress": "In progress",
      "on_hold": "On hold",
      "overdue": "Overdue",
      "completed": "Completed",
      "cancelled": "Cancelled"
    }
  },
  "project": {
    "navLabel": "Project sections",
    "openNav": "Open project menu",
    "expandNav": "Expand project menu",
    "collapseNav": "Collapse project menu",
    "sections": {
      "overview": "Information",
      "tracking": "Tracking",
      "projectServiceFront": "Service front",
      "projectDiaryEntries": "Diary entries",
      "occurrences": "Occurrences",
      "documentCategories": "Document categories",
      "issues": "Occurrences",
      "materials": "Materials",
      "budget": "Cost planning",
      "projectBudgets": "Cost planning",
      "clientBudgets": "Client budget",
      "purchaseRequests": "Purchase requests",
      "projectQuotations": "Quotations",
      "purchaseOrders": "Purchase orders",
      "costs": "Project costs",
      "payables": "Payables",
      "receivables": "Receivables",
      "invoices": "Tax invoices",
      "cashFlow": "Cash flow",
      "documents": "Documents",
      "photos": "Photos",
      "reports": "Reports",
      "settings": "Settings",
      "equipments": "Equipments"
    },
    "navGroups": {
      "overview": "Overview",
      "execution": "Execution",
      "commercial": "Commercial",
      "purchases": "Purchases",
      "finance": "Finance",
      "docs": "Documents"
    }
  },
  "dashboard": {
    "title": "Home",
    "newProject": "New project",
    "activeProjects": "Active projects",
    "pausedProjects": "Paused project",
    "noEntryToday": "No entry today",
    "overdueProjects": "Overdue",
    "projectsTable": "Projects",
    "viewAll": "View all",
    "colProject": "Project",
    "colStatus": "Status",
    "colLastEntry": "Last entry",
    "colMembers": "Members",
    "colProgress": "Progress",
    "settings": "Settings",
    "logout": "Log out",
    "lastEntryWithLabel": "Last entry · {{label}}",
    "lastEntryNone": "No entry",
    "lastEntryToday": "Today — {{time}}",
    "lastEntryYesterday": "Yesterday — {{time}}",
    "lastEntryDaysAgo_one": "{{count}} day ago",
    "lastEntryDaysAgo_other": "{{count}} days ago",
    "membersCount_one": "{{count}} member",
    "membersCount_other": "{{count}} members",
    "loadError": "Could not load the dashboard.",
    "alertBanner_one": "{{count}} project with no diary entry for {{days}}+ days.",
    "alertBanner_other": "{{count}} projects with no diary entry for {{days}}+ days.",
    "filterActiveProjects": "Filter active projects",
    "filterPausedProjects": "Filter paused projects",
    "filterNoEntryToday": "Filter projects with no entry today",
    "filterOverdueProjects": "Filter overdue projects",
    "filterOpenPayables": "Filter projects with open payables",
    "filterOverduePayables": "Filter projects with overdue payables",
    "filterOpenReceivables": "Filter projects with open receivables",
    "filterOverdueReceivables": "Filter projects with overdue receivables",
    "filterOverBudget": "Filter over-budget projects",
    "emptyFiltered": "No records match the selected filters.",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "financeOpenPayables": "Open payables",
    "financeOverduePayables": "Overdue payables",
    "financeOpenReceivables": "Open receivables",
    "financeOverdueReceivables": "Overdue receivables",
    "financeOverBudget": "Projects over budget",
    "overBudgetBanner_one": "{{count}} project is over budget.",
    "overBudgetBanner_other": "{{count}} projects are over budget.",
    "cardFinanceTitle": "Finance",
    "cardFinanceBudget": "Planned",
    "cardFinanceRealized": "Spent",
    "cardFinanceOpenPayables": "To pay",
    "cardFinanceRemaining": "Balance",
    "cardFinanceOverdue_one": "{{count}} overdue bill",
    "cardFinanceOverdue_other": "{{count}} overdue bills"
  },
  "companyTracking": {
    "title": "Tracking",
    "goToHome": "Go to Home",
    "noPermission": "You do not have permission to view tracking.",
    "empty": "There is no data for this indicator yet.",
    "totalProjects": "Projects",
    "count": "Count",
    "scheduleTitle": "Schedule",
    "scheduleOnTrack": "On track",
    "scheduleOverdue": "Overdue",
    "scheduleNoDueDate": "No due date",
    "progressTitle": "Progress",
    "progress0To25": "0–25%",
    "progress25To50": "25–50%",
    "progress50To75": "50–75%",
    "progress75To100": "75–99%",
    "progress100": "100%",
    "diaryTitle": "Diary today",
    "diaryWithEntry": "With entry",
    "diaryWithoutEntry": "No entry",
    "financeTitle": "Finance",
    "financeOpen": "Open",
    "financeOverdue": "Overdue",
    "payables": "Payables",
    "receivables": "Receivables",
    "measurementTitle": "Measurement",
    "measurementPlanned": "Planned",
    "measurementMeasured": "Measured",
    "purchasingTitle": "Purchasing",
    "openRequests": "Open requests",
    "awaitingQuotes": "Quotes waiting",
    "openOrders": "Open orders",
    "stockTitle": "Stock",
    "belowMinimum": "Below minimum"
  },
  "theme": {
    "ariaLabel": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System",
    "selectionHint": "Theme selection"
  },
  "photoCapture": {
    "choosePhoto": "Choose photo",
    "takePhoto": "Take photo",
    "uploadHint": "Choose an image or take a photo.",
    "dropHint": "Drop the image to upload.",
    "invalidType": "Use JPEG, PNG, or WebP images.",
    "tooLarge": "Each photo must be 10 MB or smaller.",
    "cameraCapture": "Capture",
    "cameraLoading": "Starting camera…",
    "cameraUnavailable": "Could not access the camera. Check browser permissions and try again.",
    "cameraCaptureFailed": "Could not capture the photo. Try again."
  },
  "fileUpload": {
    "prompt": "Click here or drag a file to upload",
    "dropPrompt": "Drop file to upload",
    "maxSize": "Maximum file size: {{size}}",
    "supportedFormats": "Supported formats: {{formats}}",
    "removeFile": "Remove file",
    "invalidType": "Unsupported file type.",
    "invalidSize": "File exceeds the maximum size of {{size}}.",
    "pdfPreviousPage": "Previous page",
    "pdfNextPage": "Next page",
    "pdfPageCounter": "{{current}} / {{total}}",
    "pdfZoomOut": "Zoom out",
    "pdfZoomIn": "Zoom in",
    "pdfLoadError": "Could not load the PDF preview."
  },
  "documentViewer": {
    "view": "View",
    "download": "Download",
    "openInNewTab": "Open in new tab",
    "previewUnavailable": "Preview is not available for this file type."
  },
  "imageLightbox": {
    "title": "Image viewer",
    "close": "Close",
    "previous": "Previous image",
    "next": "Next image",
    "download": "Download image",
    "goToImage": "Go to image {{index}}",
    "imageAlt": "Image {{index}}",
    "imageUnavailable": "Image unavailable"
  },
  "common": {
    "openCalendar": "Open calendar",
    "loading": "Please wait...",
    "downloadError": "Could not download the file. Try again.",
    "cancel": "Cancel",
    "done": "Done",
    "save": "Save",
    "remove": "Remove",
    "comingSoon": "Coming soon.",
    "openMenu": "Open menu",
    "mainNav": "Main navigation",
    "more": "More",
    "soon": "Soon",
    "active": "Active",
    "language": "Language",
    "accountMenu": "Account menu",
    "guest": "Guest",
    "organizations": "Organizations",
    "organizationMenu": "Organization",
    "switchOrganization": "Switch organization",
    "orgOwner": "Owner",
    "orgAdmin": "Admin",
    "orgMember": "Member",
    "orgInvitePending": "Invite pending",
    "back": "Back",
    "backToApp": "Back to app",
    "continue": "Continue",
    "reviewPreviousLine": "Previous: {{value}}",
    "reviewPrevious": "Previous:",
    "reviewNoChanges": "No changes to review.",
    "time": "Time",
    "apply": "Apply",
    "tryAgain": "Try again",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "closeFlow": "Close",
    "stepCompleted": "Completed",
    "stepGoBackAria": "Go back to step {{number}}",
    "formFlowStepsMenuAria": "View all steps",
    "required": "Required",
    "invalid": "Invalid",
    "optional": "Optional",
    "edit": "Edit",
    "delete": "Delete",
    "clear": "Clear",
    "clearAll": "Clear all",
    "codeLabel": "Code",
    "codeNotFound": "No item found with this code.",
    "noResults": "No results found.",
    "selectPlaceholder": "Select…",
    "noRegisters": "No items registered.",
    "notInformed": "Not informed",
    "quantityExceedsMax": "Quantity exceeds the maximum allowed.",
    "loadingMore": "Loading more…",
    "errorGeneric": "Something went wrong. Please try again.",
    "catalogFilter": {
      "status": "Status",
      "close": "Close",
      "reset": "Clear",
      "apply": "Show results"
    },
    "filterDrawer": {
      "title": "Select filters below",
      "openAriaLabel": "Open filters",
      "close": "Close",
      "resetAll": "Clear filters",
      "reset": "Clear",
      "showResults": "Show results"
    }
  },
  "permissions": {
    "groups": {
      "app": "App navigation",
      "settings": "Settings sections",
      "settingsHint": "Enable «Settings menu» above so the user sees the Settings menu. Options below control what they can open inside Settings.",
      "projects": "Project list",
      "finance": "Finance",
      "project": "Inside a project",
      "admin": "Organization administration"
    },
    "nav": {
      "dashboard": "Home",
      "projects": "View project list",
      "finance": "Finance menu",
      "settings": "Settings menu"
    },
    "settings": {
      "organization": "Organization details",
      "users": "Users",
      "workers": "Collaborators",
      "occurrences": "Occurrences",
      "documentCategories": "Document categories",
      "photoTags": "Photo tags",
      "serviceFrontModels": "Service front models",
      "checklistModels": "Checklist models",
      "materials": "Materials",
      "materialsStock": "Adjust material stock",
      "lookups": "Lookups",
      "equipments": "Equipments",
      "equipmentsStock": "Adjust equipment quantity",
      "partners": "Partners",
      "financeLookups": "Categories and payment methods",
      "fiscal": "Tax invoices"
    },
    "projects": {
      "create": "Create and edit projects",
      "delete": "Delete projects"
    },
    "finance": {
      "payables": {
        "view": "View payables",
        "write": "Create and edit payables",
        "delete": "Delete payables"
      },
      "receivables": {
        "view": "View receivables",
        "write": "Create and edit receivables",
        "delete": "Delete receivables"
      },
      "cashFlow": {
        "view": "View cash flow"
      },
      "fiscal": {
        "view": "View NFS-e",
        "emit": "Issue NFS-e",
        "cancel": "Cancel NFS-e"
      }
    },
    "project": {
      "overview": {
        "view": "View project information"
      },
      "tracking": {
        "view": "View project overview"
      },
      "projectServiceFront": {
        "view": "View service fronts",
        "write": "Edit service fronts",
        "delete": "Delete service fronts"
      },
      "projectDiary": {
        "view": "View construction diary",
        "write": "Write diary entries",
        "delete": "Delete diary entries"
      },
      "occurrences": {
        "view": "View project occurrences"
      },
      "documents": {
        "view": "View project documents",
        "write": "Manage project documents",
        "delete": "Delete project documents"
      },
      "photos": {
        "view": "View project photos",
        "write": "Manage project photos",
        "delete": "Delete project photos"
      },
      "materials": {
        "view": "View project materials",
        "write": "Manage project materials",
        "delete": "Remove project materials"
      },
      "reports": {
        "view": "View project reports"
      },
      "projectReport": {
        "view": "View project reports",
        "generate": "Generate project reports",
        "delete": "Delete project reports",
        "manageModels": "Manage diary report models"
      },
      "project_projectReports": {
        "view": "View project reports"
      },
      "equipments": {
        "view": "View project equipments",
        "write": "Manage project equipments",
        "delete": "Remove project equipments"
      },
      "budgets": {
        "view": "View project cost planning",
        "write": "Manage project cost planning",
        "delete": "Delete project cost plans",
        "approve": "Approve project cost plans"
      },
      "clientBudgets": {
        "view": "View client budget",
        "write": "Manage client budget",
        "delete": "Delete client budget",
        "approve": "Approve client budgets"
      },
      "purchaseRequests": {
        "view": "View purchase requests",
        "write": "Manage purchase requests",
        "approve": "Approve purchase requests"
      },
      "quotations": {
        "view": "View project quotations",
        "write": "Manage project quotations",
        "approve": "Approve project quotations"
      },
      "purchaseOrders": {
        "view": "View purchase orders",
        "write": "Manage purchase orders"
      },
      "finance": {
        "view": "View project costs"
      },
      "finance": {
        "view": "View project costs"
      }
    },
    "users": {
      "manage": "Manage users and invites"
    },
    "modules": {
      "dashboard": "Home",
      "projects": "Projects",
      "finance": "Finance",
      "settings": "Settings",
      "projectsDescription": "Choose list access and what the user can do inside each project.",
      "financeDescription": "Payables, receivables, and cash flow.",
      "settingsDescription": "Choose which pages the user can open inside Settings."
    },
    "access": {
      "none": "No access",
      "full": "Full access",
      "custom": "Custom ({{count}})"
    },
    "edit": "Edit",
    "drawer": {
      "accessLevel": "Access level",
      "noAccessHint": "The user will have no permissions in this area.",
      "customAccess": "Custom access",
      "customAccessHint": "Choose specific permissions below.",
      "menuAccess": "Menu",
      "menuAccessHint": "Without sections marked below, the user sees Settings in the menu but no pages inside it.",
      "projectList": "Project list",
      "projectListHint": "Creating projects or in-project permissions automatically include list access.",
      "insideProject": "Inside a project",
      "settingsSections": "Sections",
      "settingsSectionsHint": "Each option unlocks a specific page inside Settings.",
      "adminActions": "Admin actions",
      "actions": "Permissions",
      "includedAutomatically": "Included automatically",
      "subgroups": {
        "overview": "Project overview",
        "serviceFronts": "Service fronts",
        "diary": "Daily diary",
        "occurrences": "Occurrences",
        "materials": "Materials",
        "equipments": "Equipment",
        "clientBudgets": "Client budget",
        "budgets": "Cost planning",
        "purchaseRequests": "Purchase requests",
        "quotations": "Quotations",
        "purchaseOrders": "Purchase orders",
        "costs": "Project costs",
        "payables": "Payables",
        "receivables": "Receivables",
        "cashFlow": "Cash flow",
        "fiscal": "Tax invoices",
        "documents": "Documents",
        "photos": "Photos",
        "reports": "Reports",
        "other": "Other"
      }
    },
    "summary": {
      "empty": "No permissions selected."
    },
    "templates": {
      "manage": "Manage permissions",
      "defaultsTitle": "System defaults",
      "defaultsHint": "Platform-controlled profiles. Read-only.",
      "customTitle": "Custom profiles",
      "customHint": "Profiles created by your organization.",
      "systemBadge": "System default",
      "permissionCount": "{{count}} permissions",
      "memberCount": "{{count}} users",
      "view": "View permissions",
      "create": "Create profile",
      "createTitle": "Create access profile",
      "editTitle": "Edit access profile",
      "formStep": "Profile permissions",
      "formStepReview": "Review",
      "formReviewTitle": "Review and submit",
      "reviewSummaryTitle": "Summary",
      "name": "Profile name",
      "nameRequired": "Enter a profile name.",
      "empty": "No custom profiles are configured for this organization yet.",
      "emptyTitle": "No profiles",
      "colName": "Profile",
      "colPermissions": "Permissions",
      "colMembers": "Users",
      "total": "{{count}} profiles",
      "actionsMenu": "Profile actions",
      "drawerDetailTitle": "Profile detail",
      "permissionsHeading": "Permissions",
      "loadError": "Could not load profiles.",
      "loadMoreError": "Could not load more profiles.",
      "loadMoreRetry": "Try again",
      "createSuccess": "Profile created.",
      "updateSuccess": "Profile updated.",
      "deleteSuccess": "Profile deleted.",
      "deleteTitle": "Delete profile",
      "deleteDescription": "This profile will be permanently deleted."
    }
  },
  "fiscal": {
    "save": "Save",
    "loading": "Loading…",
    "loadError": "Could not load tax data.",
    "saveError": "Could not save tax data.",
    "saveSuccess": "Tax profile saved.",
    "projectSaveSuccess": "Project tax details saved.",
    "editProfile": "Edit tax profile",
    "editProjectProfile": "Edit tax details",
    "orgSection": "Service provider",
    "orgFormTitle": "Company tax profile",
    "projectFormTitle": "Project tax details",
    "formSections": {
      "identification": "Identification",
      "emission": "Issuance",
      "address": "Address",
      "withholdings": "Withholdings"
    },
    "legalNameLabel": "Legal name",
    "cnpjLabel": "CNPJ",
    "orgCadastroHint": "CNPJ and legal name are stored in organization details.",
    "orgCadastroLink": "Open organization details",
    "taxRegimeLabel": "Tax regime",
    "taxRegimePlaceholder": "Select a tax regime",
    "municipalRegistrationLabel": "Municipal registration",
    "cnaeLabel": "CNAE",
    "environmentLabel": "Environment",
    "environmentHint": "Production sends the NFS-e to SEFIN Nacional. Homologation uses Produção Restrita (tpAmb=2, no legal value).",
    "defaultTaxCodeLabel": "Default service code",
    "ibgeLabel": "IBGE code",
    "ibgeInvalid": "Enter the 7-digit IBGE municipality code.",
    "certificateSection": "Certificate",
    "certificateLabel": "A1 certificate",
    "certificateConfigured": "Configured",
    "certificateMissing": "Not configured",
    "certificateExpires": "Valid until {{date}}",
    "certificateUpload": "Upload certificate",
    "certificateReplace": "Replace",
    "certificateRemove": "Remove",
    "certificateSave": "Save certificate",
    "certificateUploadTitle": "A1 certificate",
    "certificateReplaceTitle": "Replace A1 certificate",
    "certificateFormSection": "File",
    "certificateHint": "Upload the company's e-CNPJ A1 .pfx or .p12 file and its password. The password is not stored.",
    "certificatePasswordLabel": "Certificate password",
    "certificateUploadSuccess": "A1 certificate saved.",
    "certificateRemoveSuccess": "A1 certificate removed.",
    "certificateRemoveTitle": "Remove the A1 certificate?",
    "certificateRemoveDescription": "Without the certificate you cannot issue NFS-e against SEFIN.",
    "cnoLabel": "CNO",
    "artLabel": "ART",
    "taxCodesSection": "Service codes (LC 116)",
    "taxCodeNew": "New code",
    "taxCodesEmpty": "No service codes yet.",
    "taxCodesEmptyTitle": "No service codes",
    "taxCodesEmptyDescription": "Add the LC 116 items used when issuing NFS-e.",
    "taxCodesTotal": "{{count}} codes",
    "taxCodeActionsMenu": "Service code actions",
    "taxCodeDrawerDetailTitle": "Service code",
    "createdAt": "Created",
    "colLc116": "LC 116",
    "colIssRate": "ISS",
    "taxCodeCreateTitle": "New service code",
    "taxCodeEditTitle": "Edit service code",
    "taxCodeNameLabel": "Description",
    "lc116Label": "LC 116 item",
    "issRateLabel": "ISS rate (%)",
    "issRateValue": "ISS {{rate}}%",
    "nationalTaxCodeLabel": "National code",
    "nbsCodeLabel": "NBS",
    "taxCodeActiveLabel": "Active",
    "withholdIss": "Withhold ISS",
    "withholdIrrf": "Withhold IRRF",
    "withholdPis": "Withhold PIS",
    "withholdCofins": "Withhold COFINS",
    "withholdCsll": "Withhold CSLL",
    "withholdInss": "Withhold INSS",
    "taxCodeSaveSuccess": "Service code saved.",
    "taxCodeNotFound": "Service code not found.",
    "taxCodeDelete": "Delete",
    "taxCodeDeleteTitle": "Delete this service code?",
    "taxCodeDeleteDescription": "This removes the code if it is not used on an NFS-e.",
    "taxCodeDeleteSuccess": "Service code removed.",
    "taxCodeDeleteInUse": "This code is used on an NFS-e and cannot be deleted.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nfseSection": "NFS-e",
    "drawerDetailTitle": "Tax invoice detail",
    "colNumber": "Number",
    "colType": "Type",
    "colProject": "Project",
    "colPartner": "Partner",
    "colAmount": "Amount",
    "colIssuedAt": "Issued",
    "colStatus": "Status",
    "accessKeyLabel": "Access key",
    "rejectionLabel": "Rejection",
    "openReceivable": "Open receivable",
    "openPayable": "Open payable",
    "receivableLabel": "Receivable",
    "payableLabel": "Payable",
    "searchPlaceholder": "Search tax invoices",
    "clearSearch": "Clear search",
    "actionsMenu": "Tax invoice actions",
    "emptyTitle": "No tax invoices",
    "emptyDescription": "Issue NFS-e from a receivable. Inbound invoices appear when you import XML on a payable.",
    "emptyFilteredTitle": "No tax invoices found",
    "emptyFilteredDescription": "Try a different search.",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "documentType": {
      "nfs_e_out": "Issued NFS-e",
      "nfs_e_in": "Received NFS-e",
      "nfe_in": "Received NF-e"
    },
    "noDocument": "No NFS-e issued for this receivable.",
    "readinessLabel": "Issue",
    "readinessReady": "Registration is ready to issue.",
    "readinessWarning": "warning",
    "emit": "Issue NFS-e",
    "emitSuccess": "NFS-e authorized.",
    "alreadyEmitted": "An authorized or in-flight NFS-e already exists for this receivable.",
    "notReady": "Complete the tax registration before issuing.",
    "notCancellable": "This NFS-e cannot be cancelled.",
    "downloadXml": "Download XML",
    "downloadPdf": "Download PDF",
    "viewPdf": "View PDF",
    "pdfPreviewTitle": "DANFSe",
    "pdfLoadError": "Could not load the NFS-e PDF.",
    "cancelNfse": "Cancel NFS-e",
    "cancelSuccess": "NFS-e cancelled.",
    "cancelConfirmTitle": "Cancel this NFS-e?",
    "cancelConfirmDescription": "Cancellation is sent to the tax environment. This cannot be undone.",
    "cancelDefaultReason": "Cancellation requested by the user",
    "inboundSection": "Supplier XML",
    "importXml": "Import XML",
    "importXmlHint": "Attach the received NF-e or NFS-e XML to store the access key on this payable.",
    "importSuccess": "XML imported.",
    "xmlInvalid": "The XML could not be read. Use an NF-e or NFS-e file.",
    "taxRegime": {
      "simples_nacional": "Simples Nacional",
      "lucro_presumido": "Presumed profit",
      "lucro_real": "Actual profit",
      "mei": "MEI"
    },
    "environment": {
      "homologation": "Homologation",
      "production": "Production"
    },
    "documentStatus": {
      "draft": "Draft",
      "sending": "Sending",
      "authorized": "Authorized",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "readiness": {
      "org": {
        "cnpj": "Company CNPJ",
        "legalName": "Company legal name",
        "fiscalProfile": "Company tax profile",
        "im": "Municipal registration",
        "cnae": "CNAE",
        "address": "Company tax address",
        "ibge": "Company IBGE code",
        "certificate": "Company A1 certificate",
        "demoProduction": "Demo organizations cannot issue in production"
      },
      "partner": {
        "document": "Customer CPF/CNPJ",
        "address": "Customer address",
        "ibge": "Customer IBGE code"
      },
      "project": {
        "cno": "Project CNO",
        "obraAddress": "Project address",
        "obraIbge": "Project IBGE code"
      },
      "serviceTaxCode": "Service code (LC 116)",
      "receivable": {
        "amount": "Receivable amount",
        "status": "Receivable status"
      }
    }
  },
  "chargeAccount": {
    "sectionTitle": "Charges",
    "description": "PIX and boleto are processed by Pagar.me. The Pagar.me fee is deducted from the amount paid. The net amount goes to the bank account registered here. KonstruLog does not keep a commission.",
    "statusLabel": "Status",
    "statusDisconnected": "Not registered",
    "statusPending": "Under review",
    "statusActive": "Active",
    "statusRefused": "Refused",
    "statusSuspended": "Suspended",
    "add": "Register",
    "edit": "Edit",
    "drawerCreateTitle": "Register bank account",
    "drawerEditTitle": "Edit bank account",
    "bank": "Bank",
    "representative": "Representative",
    "cpfInvalid": "Enter a valid CPF.",
    "bankInvalid": "Select a bank.",
    "bankCode": "Bank code",
    "branch": "Branch",
    "branchDigit": "Branch digit",
    "account": "Account",
    "accountDigit": "Account digit",
    "accountType": "Account type",
    "checking": "Checking",
    "savings": "Savings",
    "representativeName": "Legal representative",
    "representativeCpf": "Representative CPF",
    "birthDate": "Birth date",
    "monthlyIncome": "Monthly income",
    "annualRevenue": "Annual revenue",
    "saveError": "Could not register the bank account. Try again shortly.",
    "saved": "Bank account sent for review."
  },
  "asaas": {
    "sectionTitle": "Charges",
    "sectionDescription": "Enable PIX and boleto for receivables. Funds go to your company account, not KonstruLog's.",
    "statusLabel": "Status",
    "statusDisconnected": "Not activated",
    "statusApproved": "Approved",
    "statusPending": "Under review",
    "statusRejected": "Rejected",
    "statusActionRequired": "Action required",
    "activate": "Activate charges",
    "onboardSuccess": "Charges activated. Complete registration if Asaas asks.",
    "onboardError": "Could not activate charges.",
    "completeOnboarding": "Complete Asaas registration",
    "baasDisclosure": "PIX, boleto, and the payment account are processed by Asaas Gestão Financeira Instituição de Pagamentos S.A., a payment institution authorized by the Central Bank of Brazil. KonstruLog only integrates that experience and is not a financial institution.",
    "baasSupport": "Questions about the payment operation: 0800 009 0037 or contato@asaas.com.br.",
    "baasSealAlt": "Asaas financial services"
  },
  "errors": {
    "unexpected": "Something went wrong. Please try again.",
    "boundaryTitle": "Something went wrong",
    "boundaryBody": "An unexpected error occurred. Reload the page to continue.",
    "boundaryReload": "Reload",
    "loadErrorHint": "Check your connection and try again.",
    "UNAUTHORIZED": "Your session expired. Please sign in again.",
    "ONBOARDING_REQUIRED": "Complete onboarding to continue.",
    "ADMIN_REQUIRED": "You don't have permission to perform this action.",
    "NOT_FOUND": "The requested item was not found.",
    "PROJECT_NOT_FOUND": "Project not found.",
    "EMAIL_ALREADY_EXISTS": "An account with this email already exists.",
    "ORG_ALREADY_EXISTS": "You already have an organization.",
    "CNPJ_ALREADY_EXISTS": "An organization with this CNPJ already exists.",
    "VALIDATION_FAILED": "Check the form and try again.",
    "REPORT_RANGE_EMPTY": "There is no data in this period for the report.",
    "INVALID_CURSOR": "Could not load this page of results.",
    "UNKNOWN_FILTER_TYPE": "Unknown filter type.",
    "WORKER_BIRTH_DATE_IN_FUTURE": "Birth date cannot be in the future.",
    "WORKER_MIN_AGE": "Collaborator must be at least 16 years old.",
    "USER_BIRTH_DATE_IN_FUTURE": "Birth date cannot be in the future.",
    "USER_MIN_AGE": "You must be at least 18 years old.",
    "STEP_NAMES_NOT_UNIQUE": "Step names must be unique within a model.",
    "INVALID_HEX_COLOR": "Enter a valid hex color (e.g. #1A56DB).",
    "WORKER_IN_USE": "This collaborator is assigned to activities and cannot be deleted.",
    "WORKER_NAME_TAKEN": "A collaborator with this name already exists.",
    "WORKER_CODE_TAKEN": "A collaborator with this code already exists.",
    "WORKER_USER_ALREADY_LINKED": "This user is already linked to another collaborator.",
    "INVALID_WORKER_USER_ID": "The selected user is not a member of this organization.",
    "INVALID_WORKER_IDS": "One or more collaborators are invalid.",
    "INVALID_RESPONSIBLE_WORKER_ID": "The selected responsible collaborator is not valid.",
    "SERVICE_FRONT_MODEL_NAME_TAKEN": "A model with this name already exists.",
    "SERVICE_FRONT_MODEL_IN_USE": "This model is used by projects and cannot be deleted.",
    "INVALID_SERVICE_FRONT_MODEL_ID": "The selected service front model is not valid.",
    "INVALID_MS_PROJECT_XML": "The MS Project XML file is invalid or could not be read.",
    "MS_PROJECT_NO_TASKS": "No dated tasks were found in the MS Project file.",
    "MS_PROJECT_DUPLICATE_TASK_NAMES": "The MS Project file has duplicate task names.",
    "INVALID_DOCUMENT_TYPE": "This file type is not supported.",
    "DOCUMENT_TOO_LARGE": "The file is too large.",
    "SERVICE_FRONT_NAME_TAKEN": "A service front with this name already exists on the project.",
    "SERVICE_FRONT_IN_USE": "This front is used in activities and cannot be deleted.",
    "OCCURRENCE_NAME_TAKEN": "An occurrence with this name already exists.",
    "OCCURRENCE_IN_USE": "This occurrence is in use and cannot be deleted.",
    "MATERIAL_CATEGORY_NAME_TAKEN": "A category with this name already exists.",
    "PHOTO_TAG_NAME_TAKEN": "A tag with this name already exists.",
    "PHOTO_TAG_RESERVED": "This tag is reserved by the system and cannot be edited or assigned manually.",
    "MATERIAL_NAME_TAKEN": "A material with this name already exists.",
    "MATERIAL_CODE_TAKEN": "A material with this code already exists.",
    "MATERIAL_BARCODE_TAKEN": "A material with this barcode already exists.",
    "MATERIAL_INSUFFICIENT_STOCK": "Cannot remove more than the current stock.",
    "PROJECT_MATERIAL_INSUFFICIENT_QUANTITY": "Not enough quantity on the project.",
    "PROJECT_MATERIAL_ALREADY_SELECTED": "This material is already on the project.",
    "PROJECT_EQUIPMENT_ALREADY_SELECTED": "This equipment is already on the project.",
    "INVALID_MATERIAL_CATEGORY_ID": "The selected category is not valid.",
    "WEATHER_CONDITION_NAME_TAKEN": "A weather condition with this name already exists.",
    "INVALID_WEATHER_CONDITION_ID": "The selected weather condition is not valid.",
    "WEATHER_CONDITION_IN_USE": "This weather condition is used in diary entries and cannot be deleted.",
    "PROJECT_PRIORITY_NAME_TAKEN": "A project priority with this name already exists.",
    "INVALID_PROJECT_PRIORITY_ID": "The selected priority is not valid.",
    "PROJECT_PRIORITY_IN_USE": "This priority is used by projects and cannot be deleted.",
    "PROJECT_TYPE_NAME_TAKEN": "A project type with this name already exists.",
    "INVALID_PROJECT_TYPE_ID": "The selected project type is not valid.",
    "PROJECT_STATUS_NOT_FOUND": "The selected project status is not valid.",
    "PROJECT_TYPE_IN_USE": "This type is used by projects and cannot be deleted.",
    "INVALID_DEFAULT_SERVICE_FRONT_MODEL_ID": "The selected service front model is not valid.",
    "WORKER_ROLE_NAME_TAKEN": "A role with this name already exists.",
    "INVALID_WORKER_ROLE_ID": "The selected role is not valid.",
    "WORKER_ROLE_IN_USE": "This role is assigned to collaborators and cannot be deleted.",
    "MEASUREMENT_UNIT_SYMBOL_TAKEN": "A unit with this symbol already exists.",
    "MEASUREMENT_UNIT_IN_USE": "This unit is in use and cannot be deleted.",
    "INVALID_MEASUREMENT_UNIT_ID": "The selected measurement unit is not valid.",
    "PROJECT_STEP_NAMES_NOT_UNIQUE": "Step names in the service front model must be unique.",
    "PROJECT_SERVICE_FRONT_CONFLICT": "Could not create project steps from the model.",
    "PROJECT_DELETE_CONFLICT": "This project cannot be deleted while it is in use.",
    "PROJECT_NAME_TAKEN": "A project with this title already exists.",
    "PROJECT_CODE_TAKEN": "A project with this code already exists.",
    "PROJECT_INACTIVE": "This project is inactivated and can only be consulted.",
    "SUBSCRIPTION_REQUIRED": "A subscription is required to continue.",
    "SUBSCRIPTION_CANCELED": "Your subscription was canceled. Choose a plan to continue.",
    "PAYMENT_OVERDUE": "Payment is overdue. Update your billing info.",
    "ORGANIZATION_BLOCKED": "Your organization access has been suspended.",
    "HELP_CHAT_UNAVAILABLE": "The help assistant is unavailable right now. Try again or email support@konstrulog.com.",
    "HELP_CHAT_LIMIT": "You reached the daily help-chat limit ({{limit}}). Try again tomorrow or email support.",
    "PLATFORM_INVITE_REQUIRED": "A platform invite must be accepted before continuing.",
    "PLATFORM_INVITE_ALREADY_ACCEPTED": "This platform invite was already accepted.",
    "PUBLIC_ONBOARD_DISABLED": "Self-serve organization signup is disabled. Ask for an invite.",
    "FEATURE_NOT_ON_PLAN": "This feature is not available on the {{plan}} plan.",
    "PLAN_LIMIT_REACHED": "Plan limit reached: {{current}}/{{limit}} {{resource}}.",
    "planResources": {
      "activeProjects": "active projects",
      "teamMembers": "users"
    },
    "MEMBER_ALREADY_EXISTS": "This user is already in your organization.",
    "INVITE_ALREADY_ACCEPTED": "This invite was already accepted.",
    "ORG_ACCESS_REVOKED": "You no longer have access to an organization. Contact your admin if you need help.",
    "ORG_ACCESS_DENIED": "You do not have access to that organization.",
    "USER_ALREADY_IN_ORG": "This email belongs to a user in another organization.",
    "MEMBER_LIMIT_REACHED": "User limit reached for your plan.",
    "MEMBER_DISABLED": "Your access to this organization is disabled.",
    "MEMBER_ALREADY_DISABLED": "This user is already disabled.",
    "MEMBER_ALREADY_ENABLED": "This user is already enabled.",
    "PERMISSION_DENIED": "You don't have permission for this action.",
    "IMPERSONATION_READ_ONLY": "This impersonation session is read-only. Changes are blocked.",
    "PERMISSION_TEMPLATE_IN_USE": "This profile is assigned to users.",
    "PERMISSION_TEMPLATE_LOCKED": "This system profile cannot be changed.",
    "PERMISSION_TEMPLATE_NAME_TAKEN": "A profile with this name already exists.",
    "LAST_ORG_ADMIN_REQUIRED": "The organization must keep at least one Org Admin.",
    "PROJECT_DIARY_ENTRY_DATE_TAKEN": "An entry already exists for this date.",
    "PROJECT_DIARY_ENTRY_SERVICE_FRONT_DUPLICATE": "This service front is already on the entry.",
    "PROJECT_DIARY_ENTRY_SERVICE_FRONT_LIMIT": "A diary entry can have only one service front.",
    "PROJECT_DIARY_ENTRY_OCCURRENCE_DUPLICATE": "This occurrence is already on the entry.",
    "PROJECT_DIARY_ENTRY_PAST_READONLY": "Past diary entries cannot be edited or deleted.",
    "DIARY_ENTRY_FORM_SECTION_DISABLED": "This section is not enabled on the organization's diary form.",
    "INVALID_PHOTO_TYPE": "Use JPEG, PNG, or WebP images.",
    "PHOTO_TOO_LARGE": "Each photo must be 10 MB or smaller.",
    "DIARY_LINE_PHOTO_LIMIT_REACHED": "Couldn't add more photos to this line.",
    "GALLERY_PHOTO_LIMIT_REACHED": "Album photo limit reached ({{current}}/{{limit}}).",
    "PHOTO_UPLOAD_FAILED": "Photo storage is unavailable. Check API Supabase storage configuration.",
    "EQUIPMENT_CATEGORY_NAME_TAKEN": "A category with this name already exists.",
    "EQUIPMENT_NAME_TAKEN": "An equipment with this name already exists.",
    "EQUIPMENT_CODE_TAKEN": "An equipment with this code already exists.",
    "EQUIPMENT_INSUFFICIENT_QUANTITY": "Cannot remove more than the current quantity.",
    "INVALID_EQUIPMENT_CATEGORY_ID": "The selected category is not valid.",
    "CHECKLIST_MODEL_NAME_TAKEN": "A checklist model with this name already exists.",
    "CHECKLIST_MODEL_IN_USE": "This checklist model is in use and cannot be deleted.",
    "CHECKLIST_ITEM_NAMES_NOT_UNIQUE": "Checklist item names must be unique within a model.",
    "INVALID_CHECKLIST_MODEL_IDS": "One or more checklist models are invalid.",
    "INVALID_PROJECT_CHECKLIST_ID": "Invalid checklist for this service front.",
    "PROJECT_DIARY_ENTRY_CHECKLIST_DUPLICATE": "This checklist was already added to this service front on the diary entry.",
    "PROJECT_CHECKLIST_IN_USE": "This checklist is in use and cannot be removed.",
    "INVALID_BUDGET_ITEM_IDS": "The selected cost plan line is not valid.",
    "BUDGET_ITEM_IN_USE": "This cost plan line is used by payables and cannot be deleted.",
    "PROJECT_BUDGET_IN_USE": "This cost plan has linked payables and cannot be deleted.",
    "PROJECT_BUDGET_NOT_EDITABLE": "This cost plan cannot be edited in its current status.",
    "PROJECT_BUDGET_FRONT_HAS_EDITABLE": "This service front already has a cost plan in elaboration or under review. Edit that plan instead.",
    "CLIENT_BUDGET_STATUS_NOT_FOUND": "The selected client budget status is not valid.",
    "CLIENT_BUDGET_STATUS_NAME_TAKEN": "A client budget status with this name already exists.",
    "CLIENT_BUDGET_NOT_FOUND": "Client budget not found.",
    "CLIENT_BUDGET_VERSION_TAKEN": "A client budget with this version already exists.",
    "CLIENT_BUDGET_NOT_EDITABLE": "This client budget cannot be edited in its current status.",
    "CLIENT_BUDGET_IN_USE": "This client budget has linked receivables and cannot be deleted.",
    "CLIENT_BUDGET_DISCOUNT_EXCEEDS_TOTAL": "Discount cannot be greater than the items total.",
    "INVALID_CLIENT_BUDGET_SERVICE_FRONT_IDS": "One or more client budget service fronts are not valid.",
    "INVALID_CLIENT_BUDGET_MODEL_STEP_IDS": "One or more model steps are not valid for this quote.",
    "CLIENT_BUDGET_ALREADY_HAS_PROJECT": "This quote is already attached to a job.",
    "CLIENT_BUDGET_NOT_APPROVED": "Only approved quotes can be converted into a job.",
    "CLIENT_BUDGET_PROPOSED_NAME_REQUIRED": "Enter a job name to convert this quote.",
    "PARTNER_NAME_TAKEN": "A partner with this name already exists.",
    "PARTNER_DOCUMENT_TAKEN": "A partner with this document already exists.",
    "PARTNER_IN_USE": "This partner is in use and cannot be deleted.",
    "INVALID_PARTNER_ID": "The selected partner is not valid.",
    "FINANCIAL_CATEGORY_NAME_TAKEN": "A financial category with this name already exists.",
    "FINANCIAL_CATEGORY_IN_USE": "This financial category is in use and cannot be deleted.",
    "INVALID_FINANCIAL_CATEGORY_ID": "The selected financial category is not valid.",
    "PAYMENT_METHOD_NAME_TAKEN": "A payment method with this name already exists.",
    "PAYMENT_METHOD_IN_USE": "This payment method is in use and cannot be deleted.",
    "SERVICE_TAX_CODE_IN_USE": "This service code is used on an NFS-e and cannot be deleted.",
    "FISCAL_NOT_READY": "Complete the tax registration before issuing the NFS-e.",
    "FISCAL_DOCUMENT_ALREADY_EMITTED": "An authorized or in-flight NFS-e already exists for this receivable.",
    "FISCAL_DOCUMENT_NOT_CANCELLABLE": "This NFS-e cannot be cancelled.",
    "FISCAL_XML_INVALID": "The XML could not be read. Use an NF-e or NFS-e file.",
    "FISCAL_CERTIFICATE_INVALID": "The A1 certificate file is invalid.",
    "FISCAL_CERTIFICATE_PASSWORD": "The A1 certificate password is incorrect.",
    "FISCAL_CERTIFICATE_CNPJ_MISMATCH": "The certificate CNPJ does not match the company.",
    "FISCAL_CERTIFICATE_EXPIRED": "The A1 certificate has expired.",
    "FISCAL_CERTIFICATE_NOT_ICP_BRASIL": "Use an ICP-Brasil e-CNPJ A1 certificate for the company.",
    "FISCAL_CERTIFICATE_MISSING": "Upload the A1 certificate in Settings → Fiscal.",
    "FISCAL_ORG_CNPJ_REQUIRED": "Save the company CNPJ before uploading the certificate.",
    "FISCAL_CERTIFICATE_VAULT_UNAVAILABLE": "The certificate could not be stored. Try again.",
    "FISCAL_SEFIN_UNAVAILABLE": "SEFIN Nacional did not respond. Try again shortly.",
    "FISCAL_DISABLED": "This company does not issue electronic invoices.",
    "CHARGES_DISABLED": "This company does not generate boleto and PIX.",
    "ASAAS_NOT_CONFIGURED": "Charges are not available in this environment yet.",
    "ASAAS_NOT_AVAILABLE_FOR_COUNTRY": "PIX and boleto charges are available only for companies in Brazil.",
    "ASAAS_ORG_PROFILE_INCOMPLETE": "Complete the company CNPJ, commercial email, phone, and address before activating charges.",
    "ASAAS_ACCOUNT_NOT_READY": "Activate charges and finish registration before generating PIX or boleto.",
    "ASAAS_CHARGE_NOT_ALLOWED": "A charge can only be created for an open receivable.",
    "ASAAS_PARTNER_DOCUMENT_INVALID": "Enter a valid CPF or CNPJ on the client record.",
    "ASAAS_PARTNER_INCOMPLETE": "Enter the client email before generating the charge.",
    "ASAAS_CHARGE_ALREADY_EXISTS": "A charge already exists for this receivable.",
    "ASAAS_CHARGE_NOT_CANCELLABLE": "This charge cannot be cancelled.",
    "ASAAS_REQUEST_FAILED": "Asaas did not complete the request. Try again shortly.",
    "PAGARME_NOT_CONFIGURED": "Charges are not available in this environment yet.",
    "PAGARME_NOT_AVAILABLE_FOR_COUNTRY": "PIX and boleto charges are available only for companies in Brazil.",
    "PAGARME_ORG_PROFILE_INCOMPLETE": "Complete the company CNPJ, commercial email, phone, and address before registering the account.",
    "PAGARME_ACCOUNT_NOT_READY": "Register the bank account before generating PIX or boleto.",
    "PAGARME_REGISTRATION_NOT_ALLOWED": "Bank account registration is not available for this company.",
    "PAGARME_CHARGE_NOT_ALLOWED": "A charge can only be created for an open receivable.",
    "PAGARME_REPRESENTATIVE_DOCUMENT_INVALID": "Enter a valid CPF for the legal representative.",
    "PAGARME_PARTNER_DOCUMENT_INVALID": "Enter a valid CPF or CNPJ on the client record.",
    "PAGARME_PARTNER_INCOMPLETE": "Enter the client email and phone before generating the charge.",
    "PAGARME_CHARGE_ALREADY_EXISTS": "A charge already exists for this receivable.",
    "PAGARME_CHARGE_NOT_CANCELLABLE": "This charge cannot be cancelled.",
    "PAGARME_REQUEST_FAILED": "The request could not be completed. Try again shortly.",
    "BILLING_NOT_CONFIGURED": "Online billing is not configured yet. Contact support.",
    "BILLING_SUBSCRIBE_NOT_ALLOWED": "This organization cannot start a self-serve subscription.",
    "BILLING_ALREADY_SUBSCRIBED": "A subscription is already linked to a payment provider.",
    "BILLING_METHOD_NOT_SUPPORTED": "That payment method is not available for your country.",
    "BILLING_PROVIDER_UNAVAILABLE": "This billing provider is not available yet.",
    "BILLING_CARD_REQUIRED": "Credit card details are required to subscribe with a card.",
    "BILLING_RETRY_NOT_ALLOWED": "There is no open credit-card charge to retry for this organization.",
    "INVALID_PAYMENT_METHOD_ID": "The selected payment method is not valid.",
    "INVALID_PAYABLE_STATUS": "The payable status is not valid.",
    "INVALID_RECEIVABLE_STATUS": "The receivable status is not valid.",
    "PROJECT_PAYABLE_NOT_FOUND": "Payable not found.",
    "PROJECT_RECEIVABLE_NOT_FOUND": "Receivable not found.",
    "PURCHASE_REQUEST_INVALID_STATUS": "This purchase request cannot be changed in its current status.",
    "PURCHASE_REQUEST_HAS_ACTIVE_QUOTATION": "This purchase request already has an active quotation.",
    "PURCHASE_REQUEST_ITEM_LIMIT": "The purchase request exceeds the item limit.",
    "QUOTATION_INVALID_STATUS": "This quotation cannot be changed in its current status.",
    "QUOTATION_SUPPLIER_LIMIT": "The quotation exceeds the supplier limit.",
    "QUOTATION_SUPPLIER_ALREADY_ADDED": "This supplier is already on the quotation.",
    "QUOTATION_ALREADY_HAS_PURCHASE_ORDER": "This quotation already has a purchase order.",
    "PURCHASE_ORDER_ALREADY_RECEIVED": "Stock for this purchase order was already updated.",
    "PURCHASE_ORDER_STOCK_MATERIAL_REQUIRED": "Pick a catalog material for each line that has none.",
    "PURCHASE_ORDER_NOT_RECEIVABLE": "This purchase order cannot receive stock in its current status.",
    "PURCHASE_ORDER_INVALID_STATUS": "This purchase order cannot be cancelled in its current status.",
    "PURCHASE_ORDER_HAS_PAYABLES": "Cancel or remove linked payables before cancelling this purchase order."
  },
  "globalSearch": {
    "dialogTitle": "Search",
    "dialogDesc": "Find pages or go to navigation.",
    "openAria": "Open search",
    "ariaLabel": "Search palette",
    "triggerPlaceholder": "Search or navigate…",
    "palettePlaceholder": "Type to filter navigation…",
    "shortcutMac": "⌘K",
    "shortcutWin": "Ctrl+K",
    "empty": "No matches.",
    "sectionGoTo": "Go to",
    "sectionSettings": "Settings"
  },
  "equipmentCategories": {
    "new": "New category",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colName": "Name",
    "colDescription": "Description",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "formCreateTitle": "New category",
    "formEditTitle": "Edit category",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Category details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "reviewPreviousLine": "Previous: {{value}}",
    "drawerDetailTitle": "Category detail",
    "drawerNoDescription": "No description",
    "loadError": "Could not load categories.",
    "saveSuccess": "Category saved.",
    "deleteSuccess": "Category removed.",
    "deleteConfirmTitle": "Remove this category?",
    "deleteConfirmDescription": "This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "actionsMenu": "Actions",
    "emptyTitle": "No categories",
    "emptyCatalog": "No categories registered.",
    "emptyDescription": "No equipment categories are configured for this organization yet.",
    "searchPlaceholder": "Search by name…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No categories match your search.",
    "noFilterResults": "No categories match the selected filters.",
    "loadMoreError": "Could not load more categories.",
    "loadMoreRetry": "Try again",
    "notFound": "This category no longer exists or you cannot access it.",
    "createdAt": "Created"
  },
  "equipments": {
    "new": "New equipment",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "colCode": "Code",
    "colName": "Name",
    "colCategory": "Category",
    "colControlType": "Control",
    "colOperationalStatus": "Equipment status",
    "colCurrentQuantity": "Quantity",
    "colManufacturer": "Manufacturer",
    "colStatus": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "allocatedProjectLabel": "Allocated to",
    "allocatedProjectsLabel": "Allocated to",
    "onProject": "On {{project}}",
    "onProjects": "On {{projects}}",
    "nameLabel": "Name",
    "codeLabel": "Code",
    "codeHint": "Generated automatically. You can change it if you want.",
    "descriptionLabel": "Description",
    "manufacturerLabel": "Manufacturer",
    "modelLabel": "Model",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "noneOption": "None",
    "controlTypeLabel": "Control type",
    "controlTypePlaceholder": "Select control type",
    "acquisitionTypeLabel": "Acquisition",
    "acquisitionTypePlaceholder": "Select acquisition type",
    "rentalCompanyLabel": "Rental company",
    "rentalStartDateLabel": "Rental start",
    "rentalExpectedReturnDateLabel": "Expected return",
    "serialNumberLabel": "Serial number",
    "assetTagLabel": "Asset tag",
    "currentQuantityLabel": "Current quantity",
    "statusPlaceholder": "Select status",
    "controlType": {
      "individual": "Individual",
      "quantity": "Quantity"
    },
    "acquisitionType": {
      "owned": "Owned",
      "rented": "Rented"
    },
    "status": {
      "available": "Available",
      "allocated": "Allocated",
      "maintenance": "Maintenance",
      "inactive": "Inactive"
    },
    "formSections": {
      "identification": "Identification",
      "control": "Control",
      "acquisition": "Acquisition"
    },
    "formCreateTitle": "New equipment",
    "formEditTitle": "Edit equipment",
    "formReviewTitle": "Review and submit",
    "stepDetails": "Equipment details",
    "stepReview": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "drawerDetailTitle": "Equipment detail",
    "drawerNoDescription": "No description",
    "drawerNoCategory": "No category",
    "drawerNoValue": "—",
    "loadError": "Could not load equipments.",
    "saveSuccess": "Equipment saved.",
    "deleteSuccess": "Equipment removed.",
    "deleteConfirmTitle": "Remove this equipment?",
    "deleteConfirmDescription": "This cannot be undone.",
    "deleteConfirmAction": "Remove",
    "actionsMenu": "Actions",
    "actionsStockSection": "Stock",
    "viewMovements": "View movements",
    "changeStatus": "Change status",
    "statusChangeTitle": "Change status",
    "statusChangeLabel": "New status",
    "statusChangeConfirm": "Update status",
    "statusChangeSuccess": "Status updated.",
    "emptyTitle": "No equipments",
    "emptyDescription": "No equipments are configured for this organization yet.",
    "searchPlaceholder": "Search by name, code…",
    "clearSearch": "Clear search",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "noSearchResults": "No equipments match your search.",
    "noFilterResults": "No equipments match the selected filters.",
    "loadMoreError": "Could not load more equipments.",
    "loadMoreRetry": "Try again",
    "codeNotFound": "No equipment found with this code.",
    "notFound": "This equipment no longer exists or you cannot access it.",
    "createdAt": "Created",
    "filterCategory": "Category",
    "filterCategorySearch": "Search categories…",
    "filterCategoryEmpty": "No categories found.",
    "filterManufacturer": "Manufacturer",
    "filterManufacturerSearch": "Search manufacturers…",
    "filterManufacturerEmpty": "No manufacturers found.",
    "filterControlType": "Control",
    "filterControlTypeSearch": "Search control types…",
    "filterControlTypeEmpty": "No control types found.",
    "filterStatus": "Equipment status",
    "filterStatusSearch": "Search statuses…",
    "filterStatusEmpty": "No statuses found.",
    "filterAcquisitionType": "Acquisition",
    "filterAcquisitionTypeSearch": "Search acquisition types…",
    "filterAcquisitionTypeEmpty": "No acquisition types found.",
    "stockAdd": "Add",
    "stockRemove": "Remove",
    "stockAdjustAddTitle": "Add quantity",
    "stockAdjustRemoveTitle": "Remove quantity",
    "stockAdjustQuantityLabel": "Quantity",
    "stockAdjustConfirmAdd": "Add quantity",
    "stockAdjustConfirmRemove": "Remove quantity",
    "stockAdjustSuccess": "Quantity updated.",
    "stockInsufficient": "Cannot remove more than the current quantity.",
    "tabs": {
      "list": "List",
      "movements": "Movements"
    }
  },
  "equipmentStockMovements": {
    "pageTitle": "Movements",
    "colDate": "Date",
    "colEquipment": "Equipment",
    "colCategory": "Category",
    "colQuantity": "Quantity",
    "colSource": "Type",
    "colProject": "Project",
    "colOrigin": "Description",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load movements.",
    "loadMoreError": "Could not load more movements.",
    "loadMoreRetry": "Try again",
    "emptyTitle": "No movements",
    "emptyDescription": "Equipment changes will appear here.",
    "emptyFilteredTitle": "No movements match your filters",
    "emptyFilteredDescription": "Try adjusting the date range or filters.",
    "drawerTitle": "Movements",
    "formSections": {
      "identification": "Identification"
    },
    "recentSection": "Recent movements",
    "searchPlaceholder": "Search by name or code",
    "clearSearch": "Clear search",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "filter": {
      "date": "Date",
      "equipment": "Equipment",
      "equipmentSearch": "Search equipments",
      "equipmentEmpty": "No equipments found",
      "category": "Category",
      "categorySearch": "Search categories",
      "categoryEmpty": "No categories found",
      "type": "Type",
      "typeSearch": "Search types",
      "typeEmpty": "No types found"
    },
    "source": {
      "opening_balance": "Opening balance",
      "purchase": "Purchase",
      "rental_start": "Rental start",
      "rental_end": "Rental end",
      "allocated": "Allocated",
      "returned": "Returned",
      "transferred": "Transferred",
      "maintenance_start": "Maintenance start",
      "maintenance_end": "Maintenance end",
      "disposed": "Disposed",
      "adjustment": "Adjustment",
      "manual": "Manual",
      "usage": "Usage"
    }
  },
  "projectEquipments": {
    "dateFromLabel": "Start date",
    "dateToLabel": "End date",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "clearFilters": "Clear filters",
    "searchPlaceholder": "Search by name or code…",
    "clearSearch": "Clear search",
    "formSections": {
      "identification": "Identification"
    },
    "filter": {
      "date": "Date",
      "equipment": "Equipment",
      "equipmentSearch": "Search equipments…",
      "equipmentEmpty": "No equipments found.",
      "creators": "Recorded by",
      "creatorsSearch": "Search people…",
      "creatorsEmpty": "No people found.",
      "apply": "Show results",
      "reset": "Clear",
      "close": "Close filter"
    },
    "colDate": "Date",
    "colCode": "Code",
    "colEquipment": "Equipment",
    "colQuantity": "Quantity",
    "colCreatedBy": "Recorded by",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load equipments.",
    "emptyTitle": "No equipments recorded",
    "emptyDescription": "Equipments used in diary entries will appear here.",
    "noFilterResults": "No equipments match the selected filters.",
    "drawerTitle": "Equipment detail",
    "unknownCreator": "Unknown user",
    "openProjectDiaryEntry": "Open diary entry",
    "loadMoreError": "Could not load more equipments.",
    "loadMoreRetry": "Try again",
    "tabs": {
      "usage": "Usage history",
      "catalog": "Project catalog",
      "movements": "Stock movements"
    }
  },
  "projectEquipmentMovements": {
    "colDate": "Date",
    "colCode": "Code",
    "colEquipment": "Equipment",
    "colQuantity": "Quantity",
    "colSource": "Type",
    "colFromProject": "Origin",
    "colToProject": "Destination",
    "colOrigin": "Description",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load stock movements.",
    "emptyTitle": "No stock movements",
    "emptyDescription": "Transfers and diary usage will appear here.",
    "emptyFilteredTitle": "No movements match your filters",
    "emptyFilteredDescription": "Try adjusting the date range or filters.",
    "loadMoreError": "Could not load more movements.",
    "loadMoreRetry": "Try again",
    "drawerTitle": "Equipment movements",
    "movementDetailTitle": "Movement detail",
    "formSections": {
      "identification": "Identification"
    },
    "recentSection": "Recent movements",
    "searchPlaceholder": "Search by name or code",
    "clearSearch": "Clear search",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "timeFromLabel": "Start time",
    "timeToLabel": "End time",
    "filter": {
      "date": "Date",
      "equipment": "Equipment",
      "equipmentSearch": "Search equipments",
      "equipmentEmpty": "No equipments found",
      "type": "Type",
      "typeSearch": "Search types",
      "typeEmpty": "No types found"
    },
    "source": {
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out",
      "usage": "Usage",
      "usage_delta": "Quantity adjustment",
      "reversal": "Reversal",
      "returned": "Returned"
    }
  },
  "projectEquipmentSelection": {
    "colCode": "Code",
    "colName": "Name",
    "colCategory": "Category",
    "colControlType": "Control",
    "colStatus": "Status",
    "colQuantity": "Current quantity",
    "colOrgStock": "Org stock",
    "total_one": "{{count}} result",
    "total_other": "{{count}} results",
    "loadError": "Could not load project equipments.",
    "saveError": "Could not save project equipments.",
    "deleteError": "Could not remove equipment from project.",
    "emptyTitle": "No equipments selected",
    "emptyDescription": "Add equipments from your organization catalog and allocate them to this project.",
    "searchPlaceholder": "Search by name or code…",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "noSearchResults": "No equipment matches your search.",
    "noFilterResults": "No equipment matches the selected filters.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "filterCategory": "Category",
    "filterCategorySearch": "Search categories…",
    "filterCategoryEmpty": "No categories found.",
    "filterControlType": "Control",
    "filterControlTypeSearch": "Search control types…",
    "filterControlTypeEmpty": "No control types found.",
    "addEquipmentsAction": "Add equipments",
    "addLabel": "Equipment",
    "addPlaceholder": "Search catalog equipments…",
    "addLineTitle": "Add equipment line",
    "addLineAction": "Add line",
    "addItemSave": "Add",
    "edit": "Edit",
    "editItem": "Edit line",
    "addBatchSuccess": "Equipments added to project.",
    "alreadySelected": "This equipment is already on the project.",
    "codeNotFound": "This code is not in the project stock.",
    "alreadyAllocated": "Already allocated to another project.",
    "allocatedToProject": "Allocated to {{project}}",
    "allocatedToProjects": "Allocated to {{projects}}",
    "equipmentRequired": "Select an equipment.",
    "quantityLabel": "Quantity",
    "quantityRequired": "Enter a quantity.",
    "quantityExceedsStock": "Quantity cannot exceed organization stock.",
    "quantityMaxHint": "Maximum available: {{max}}",
    "quantityNoStock": "No stock available for this equipment.",
    "orgStockHint": "Organization stock: {{stock}}",
    "orgStockLabel": "Org stock",
    "orgStockInsufficient": "Not enough organization stock for this quantity.",
    "projectQuantityInsufficient": "Not enough quantity on the project.",
    "individualQuantityHint": "Individual equipment is allocated as a single unit.",
    "individualAvailableOnly": "Only available individual equipments can be allocated.",
    "remove": "Delete",
    "actionsMenu": "Actions",
    "actionsQuantitySection": "Stock",
    "viewMovements": "View movements",
    "quantityAdd": "Add",
    "quantityRemove": "Remove",
    "quantityAdjustAddTitle": "Add quantity to project",
    "quantityAdjustRemoveTitle": "Remove quantity from project",
    "quantityAdjustLabel": "Quantity",
    "quantityAdjustConfirmAdd": "Add",
    "quantityAdjustConfirmRemove": "Remove",
    "quantityAdjustSuccess": "Project quantity updated.",
    "transfer": "Transfer",
    "transferTitle": "Transfer equipment",
    "transferTargetLabel": "Target project",
    "transferTargetPlaceholder": "Select a project…",
    "transferNotesLabel": "Notes",
    "transferConfirm": "Transfer",
    "transferSuccess": "Equipment transferred.",
    "transferAlreadySelected": "This equipment is already on the destination project.",
    "deleteSuccess": "Equipment removed from project.",
    "deleteConfirmTitle": "Remove equipment from project?",
    "deleteConfirmDescription": "Remaining quantity will return to organization stock. Existing diary records are kept.",
    "deleteConfirmAction": "Remove",
    "cancel": "Cancel",
    "diaryEmptyHint": "No equipments with available quantity on this project. Add equipments in the Project catalog tab first.",
    "formTitle": "Add equipments to project",
    "formStepDetails": "Equipments",
    "formStepReview": "Review and submit",
    "formReviewTitle": "Review and submit",
    "reviewSummaryTitle": "Summary",
    "formSave": "Save",
    "formDraftSection": "Equipments to add",
    "formDraftEmpty": "Add one or more equipment lines.",
    "formItemsRequired": "Add at least one equipment line.",
    "draftQuantity": "Quantity: {{quantity}}",
    "removeDraftLine": "Remove line",
    "controlType": {
      "individual": "Individual",
      "quantity": "Quantity"
    }
  },
  "diaryReports": {
    "title": "Reports",
    "formSections": {
      "identification": "Identification"
    },
    "description": "Generate and access official project reports.",
    "settingsTitle": "Diary report models",
    "modelsTitle": "Report model",
    "modelsTotal": "{{count}} models",
    "modelsLoadError": "Report models could not be loaded.",
    "modelsEmptyTitle": "No report models",
    "modelsEmptyDescription": "No reusable report models are available yet.",
    "systemModelsTitle": "System models",
    "systemModelsHint": "Platform-controlled models. Read-only — clone to customize.",
    "customModelsTitle": "Custom models",
    "customModelsHint": "Models created by your organization from a system model.",
    "customModelsEmpty": "No custom models yet.",
    "customModelsEmptyTitle": "No custom models",
    "customModelsEmptyDescription": "No custom models are configured for this organization yet.",
    "modelDrawerTitle": "Report model details",
    "editModelTitle": "Edit report model",
    "sectionsTitle": "Report sections",
    "sectionsIncludedTitle": "Included sections",
    "documentPreviewTitle": "Document preview",
    "weatherAutoHint": "Automatic via weather API",
    "sectionOptions": {
      "groupByWorkFront": "Group by work front",
      "criticalOnly": "Critical occurrences only",
      "hideIfEmpty": "Hide section if there is no data",
      "photoGrid3": "Display in a 3-column grid",
      "includeCaptions": "Include caption per photo"
    },
    "sectionEnabled": "Included",
    "sectionDisabled": "Not included",
    "modelTypeLabel": "Type",
    "modelType": {
      "system": "System",
      "custom": "Custom"
    },
    "clone": "Clone model",
    "copyName": "Copy of {{name}}",
    "modelCloned": "Editable model created.",
    "modelSaved": "Report model saved.",
    "modelDeleted": "Report model deleted.",
    "defaultUpdated": "Project default model updated.",
    "currentDefault": "Project default",
    "setDefault": "Set as default",
    "systemModelHint": "The standard model is read-only. Clone it to change section names, visibility, or order.",
    "modelName": "Model name",
    "reorderSection": "Reorder section",
    "moveUp": "Move section up",
    "moveDown": "Move section down",
    "includePhotos": "Include diary photos",
    "signatures": "Show signature placeholders",
    "generateTitle": "Generate report",
    "chooseReportTitle": "Choose report",
    "backToChoose": "Back",
    "dateFromLabel": "From",
    "dateToLabel": "To",
    "invalidDateRange": "Start date must be on or before end date.",
    "periodTitle": "Period",
    "reportTypes": {
      "diary": {
        "name": "Site diary",
        "description": "Official PDF of published diary entries in a period, using the selected model.",
        "paramsHint": "Choose a date-time range. Each published diary in the period becomes a day in the PDF (up to 31)."
      },
      "equipment": {
        "name": "Equipment",
        "description": "Used and idle equipment for the selected period.",
        "paramsHint": "Choose the report date range."
      },
      "labor": {
        "name": "Labor",
        "description": "Workers present on diary entries in the period.",
        "paramsHint": "Choose the report date range."
      },
      "occurrences": {
        "name": "Occurrences",
        "description": "Occurrences recorded in diary entries for the period.",
        "paramsHint": "Choose the report date range."
      },
      "progress": {
        "name": "Progress",
        "description": "Progress evolution by service front for the period.",
        "paramsHint": "Choose the report date range."
      },
      "materials": {
        "name": "Materials",
        "description": "Materials used in diary entries for the period.",
        "paramsHint": "Choose the report date range."
      },
      "photos": {
        "name": "Photographic record",
        "description": "Diary and gallery photos in the period (up to 80).",
        "paramsHint": "Choose the report date range."
      },
      "weather": {
        "name": "Weather and workability",
        "description": "Weather and workability from published diary entries.",
        "paramsHint": "Choose the report date range."
      },
      "checklists": {
        "name": "Checklists",
        "description": "Checklist items completed in diary entries for the period.",
        "paramsHint": "Choose the report date range."
      },
      "measurement": {
        "name": "Progress billing",
        "description": "Quantity advances in the period with accumulated qty and value.",
        "paramsHint": "Choose the measurement date range."
      },
      "costVsBudget": {
        "name": "Cost vs budget",
        "description": "Planned, measured, and paid amounts on current project budgets.",
        "paramsHint": "Choose the report date range."
      },
      "clientProposal": {
        "name": "Commercial proposal",
        "description": "PDF of a selected client budget.",
        "paramsHint": "Choose the client budget to print."
      },
      "purchaseOrders": {
        "name": "Purchase orders",
        "description": "Purchase orders issued in the period.",
        "paramsHint": "Choose the report date range."
      },
      "payables": {
        "name": "Accounts payable",
        "description": "Payables due in the period.",
        "paramsHint": "Choose the report date range."
      },
      "receivables": {
        "name": "Accounts receivable",
        "description": "Receivables due in the period.",
        "paramsHint": "Choose the report date range."
      },
      "cashFlow": {
        "name": "Cash flow",
        "description": "Planned and actual inflows and outflows in the period.",
        "paramsHint": "Choose the report date range."
      }
    },
    "groups": {
      "execution": "Execution",
      "commercial": "Commercial",
      "purchasesFinance": "Purchasing and finance"
    },
    "formatLabel": "Format",
    "clientBudgetLabel": "Client budget",
    "selectClientBudget": "Select a client budget",
    "diaryEntryLabel": "Diary entry",
    "selectDiary": "Select a published diary entry",
    "searchDiary": "Search by date or diary content",
    "noPublishedDiaries": "There are no published diary entries available.",
    "modelLabel": "Report model",
    "selectModel": "Select a report model",
    "selectedDiary": "Selected diary entry",
    "preview": "Preview",
    "generate": "Generate",
    "generateError": "Could not start report generation. Try again.",
    "publishedOnly": "Official PDFs can only be generated from published entries.",
    "selectDiaryHint": "Open a published diary entry to generate its report.",
    "openDiaries": "View diary entries",
    "openReports": "Reports",
    "generated": "Official PDF generated.",
    "generatingQueued": "Generating report… You will be notified when it is ready.",
    "historyTitle": "Generated reports",
    "emptyHistory": "No reports generated yet.",
    "total": "{{count}} reports",
    "colType": "Type",
    "colModel": "Model",
    "colParams": "Parameters",
    "colCreatedAt": "Generated at",
    "colStatus": "Status",
    "emptyTitle": "No generated reports",
    "emptyDescription": "Generate the first report by choosing a type and its parameters.",
    "loadError": "Reports could not be loaded.",
    "drawerTitle": "Report details",
    "statusLabel": "Status",
    "modelVersionLabel": "Version",
    "generatedAtLabel": "Generated at",
    "fileSection": "File",
    "fileLabel": "File",
    "sourceDiaryTitle": "Source diary entry",
    "errorTitle": "Generation error",
    "errorMessageLabel": "Details",
    "open": "Open report",
    "download": "Download report",
    "actionsMenu": "Report actions",
    "delete": "Delete report",
    "deleteSelected": "Delete {{count}} reports",
    "deleteReportTitle": "Delete this generated report?",
    "deleteReportDescription": "The generated file will be permanently removed. Source data will not be deleted.",
    "deleteSelectedTitle": "Delete {{count}} generated reports?",
    "deleteSelectedDescription": "The generated files will be permanently removed. Source data will not be deleted.",
    "deleteSuccess": "Report deleted",
    "deleteSelectedSuccess": "{{count}} reports deleted",
    "deleteError": "Could not delete the report. Try again.",
    "selectAll": "Select all reports",
    "selectRow": "Select report",
    "deleteTitle": "Delete this report model?",
    "deleteDescription": "Projects using it will return to the standard model. Generated PDFs are preserved.",
    "status": {
      "pending": "Pending",
      "processing": "Processing",
      "done": "Ready",
      "error": "Failed"
    }
  }
}
